"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8862,2889],{

/***/ 9994:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/barbeque-997a871a.0dbd9a2f.svg","height":180,"width":254});

/***/ }),

/***/ 59131:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Checkbox; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/classnames/index.js
var classnames = __webpack_require__(87637);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/@radix-ui/react-checkbox/dist/index.module.js
var index_module = __webpack_require__(43841);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(38947);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/@ant-design/icons-svg/es/asn/CheckOutlined.js
// This icon file is generated automatically.
var CheckOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" } }] }, "name": "check", "theme": "outlined" };
var CheckOutlinedSvg = CheckOutlined;


//# sourceMappingURL=CheckOutlined.js.map

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/@ant-design/icons/es/components/AntdIcon.js + 8 modules
var AntdIcon = __webpack_require__(6221);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/@ant-design/icons/es/icons/CheckOutlined.js





var CheckOutlined_CheckOutlined = function CheckOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
    ref: ref,
    icon: CheckOutlinedSvg
  }));
};
CheckOutlined_CheckOutlined.displayName = 'CheckOutlined';
var CheckOutlined$1 = /*#__PURE__*/react.forwardRef(CheckOutlined_CheckOutlined);


//# sourceMappingURL=CheckOutlined.js.map

;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/Checkbox.js





function Checkbox(_a) {
    var classes = _a.classes, onChange = _a.onChange, checked = _a.checked, disabled = _a.disabled, name = _a.name, id = _a.id, value = _a.value, defaultChecked = _a.defaultChecked;
    var handleOnChange = function (e) {
        if (disabled)
            return;
        onChange && onChange(e);
    };
    return (react.createElement(index_module/* Root */.fC, { defaultChecked: defaultChecked, id: id, name: name, disabled: disabled, checked: checked, onCheckedChange: handleOnChange, value: value, className: (0,classnames/* default */.Z)('checkbox', classes, {
            'checkbox--disabled': disabled
        }) },
        react.createElement(index_module/* Indicator */.z$, { className: "checkbox__indicator" },
            react.createElement(CheckOutlined$1, null))));
}


//# sourceMappingURL=Checkbox.js.map


/***/ }),

/***/ 53212:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FavouriteIndicator; }
});

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(36929);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/classnames/index.js
var classnames = __webpack_require__(87637);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/assets/icons/favourite-filled.icon.js


function FavouriteFilledIcon() {
    return (react.createElement("svg", { width: "16", height: "13", viewBox: "0 0 16 13", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react.createElement("path", { d: "M4.9987 0.666993C2.9737 0.666993 1.33203 2.30866 1.33203 4.33366C1.33203 8.00033 5.66536 11.3337 7.9987 12.109C10.332 11.3337 14.6654 8.00033 14.6654 4.33366C14.6654 2.30866 13.0237 0.666993 10.9987 0.666993C9.7587 0.666993 8.66203 1.28266 7.9987 2.22499C7.66059 1.74339 7.21142 1.35036 6.68921 1.07916C6.167 0.807954 5.58713 0.666577 4.9987 0.666993Z", fill: "#CC0000", stroke: "#CC0000", strokeWidth: "1.2", strokeLinecap: "round", strokeLinejoin: "round" })));
}


//# sourceMappingURL=favourite-filled.icon.js.map

;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/assets/icons/favourite-outlined.icon.js


function FavouriteOutlinedIcon() {
    return (react.createElement("svg", { width: "16", height: "13", viewBox: "0 0 16 13", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react.createElement("path", { d: "M4.99992 0.666749C2.97492 0.666749 1.33325 2.30842 1.33325 4.33342C1.33325 8.00008 5.66659 11.3334 7.99992 12.1087C10.3333 11.3334 14.6666 8.00008 14.6666 4.33342C14.6666 2.30842 13.0249 0.666749 10.9999 0.666749C9.75992 0.666749 8.66325 1.28242 7.99992 2.22475C7.66181 1.74315 7.21264 1.35011 6.69043 1.07891C6.16822 0.80771 5.58835 0.666333 4.99992 0.666749Z", stroke: "#CC0000", strokeWidth: "1.2", strokeLinecap: "round", strokeLinejoin: "round" })));
}


//# sourceMappingURL=favourite-outlined.icon.js.map

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/@ant-design/icons/es/components/Icon.js
var Icon = __webpack_require__(21845);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/FavouriteIndicator.js







function FavouriteIndicator(_a) {
    var _this = this;
    var classes = _a.classes, isFavourite = _a.isFavourite, toggleFavourite = _a.toggleFavourite, onError = _a.onError;
    var _b = react.useState(isFavourite), isFavouriteState = _b[0], setIsFavouriteState = _b[1];
    (0,react.useEffect)(function () { return setIsFavouriteState(isFavourite); }, [isFavourite]);
    var handleToggleFavourite = function (e) { return (0,tslib_es6/* __awaiter */.mG)(_this, void 0, void 0, function () {
        var _a, err_1;
        return (0,tslib_es6/* __generator */.Jh)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    e.stopPropagation();
                    _a = toggleFavourite;
                    if (!_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, toggleFavourite(!isFavouriteState)];
                case 1:
                    _a = (_b.sent());
                    _b.label = 2;
                case 2:
                    setIsFavouriteState(!isFavouriteState);
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _b.sent();
                    onError && onError(err_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (react.createElement("div", { className: (0,classnames/* default */.Z)('favourite-indicator', classes) },
        react.createElement(Icon/* default */.Z, { component: isFavouriteState ? FavouriteFilledIcon : FavouriteOutlinedIcon, className: "favourite-indicator--".concat(isFavouriteState ? 'filled' : 'outlined'), onClick: handleToggleFavourite })));
}


//# sourceMappingURL=FavouriteIndicator.js.map


/***/ }),

/***/ 2889:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ FloatingStack; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);
/* harmony import */ var _Utils_portaldom_util_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88444);




function FloatingStack(_a) {
    var children = _a.children, order = _a.order;
    var _b = react__WEBPACK_IMPORTED_MODULE_0__.useState(null), portalState = _b[0], setPortalState = _b[1];
    var onRefUpdate = function (ref) {
        if (ref && order) {
            ref.setAttribute('data-order', order.toString());
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        setPortalState((0,_Utils_portaldom_util_js__WEBPACK_IMPORTED_MODULE_2__/* .getPortalDOM */ .V)('floating-stack'));
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (portalState) {
            // sort the children based on order
            var children_1 = Array.from(portalState.children);
            children_1.sort(function (a, b) {
                var aOrder = parseInt(a.getAttribute('data-order') || '0', 10);
                var bOrder = parseInt(b.getAttribute('data-order') || '0', 10);
                return bOrder - aOrder;
            });
            children_1.forEach(function (child) {
                portalState.appendChild(child);
            });
        }
    }, [portalState, children]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, portalState && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(DOMPortal, { children: children, portalState: portalState, onRefUpdate: onRefUpdate }))));
}
function DOMPortal(_a) {
    var children = _a.children, portalState = _a.portalState, onRefUpdate = _a.onRefUpdate;
    var childRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        onRefUpdate(childRef.current);
    }, [childRef.current]);
    return react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal(react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { ref: childRef, className: "floating-stack-fw" }, children), portalState);
}


//# sourceMappingURL=FloatingStack.js.map


/***/ }),

/***/ 59423:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Carousel; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/classnames/index.js
var classnames = __webpack_require__(87637);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(36929);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/react-swipeable/es/index.js


const LEFT = "Left";
const RIGHT = "Right";
const UP = "Up";
const DOWN = "Down";

/* global document */
const defaultProps = {
    delta: 10,
    preventScrollOnSwipe: false,
    rotationAngle: 0,
    trackMouse: false,
    trackTouch: true,
    swipeDuration: Infinity,
    touchEventOptions: { passive: true },
};
const initialState = {
    first: true,
    initial: [0, 0],
    start: 0,
    swiping: false,
    xy: [0, 0],
};
const mouseMove = "mousemove";
const mouseUp = "mouseup";
const touchEnd = "touchend";
const touchMove = "touchmove";
const touchStart = "touchstart";
function getDirection(absX, absY, deltaX, deltaY) {
    if (absX > absY) {
        if (deltaX > 0) {
            return RIGHT;
        }
        return LEFT;
    }
    else if (deltaY > 0) {
        return DOWN;
    }
    return UP;
}
function rotateXYByAngle(pos, angle) {
    if (angle === 0)
        return pos;
    const angleInRadians = (Math.PI / 180) * angle;
    const x = pos[0] * Math.cos(angleInRadians) + pos[1] * Math.sin(angleInRadians);
    const y = pos[1] * Math.cos(angleInRadians) - pos[0] * Math.sin(angleInRadians);
    return [x, y];
}
function getHandlers(set, handlerProps) {
    const onStart = (event) => {
        const isTouch = "touches" in event;
        // if more than a single touch don't track, for now...
        if (isTouch && event.touches.length > 1)
            return;
        set((state, props) => {
            // setup mouse listeners on document to track swipe since swipe can leave container
            if (props.trackMouse && !isTouch) {
                document.addEventListener(mouseMove, onMove);
                document.addEventListener(mouseUp, onUp);
            }
            const { clientX, clientY } = isTouch ? event.touches[0] : event;
            const xy = rotateXYByAngle([clientX, clientY], props.rotationAngle);
            props.onTouchStartOrOnMouseDown &&
                props.onTouchStartOrOnMouseDown({ event });
            return Object.assign(Object.assign(Object.assign({}, state), initialState), { initial: xy.slice(), xy, start: event.timeStamp || 0 });
        });
    };
    const onMove = (event) => {
        set((state, props) => {
            const isTouch = "touches" in event;
            // Discount a swipe if additional touches are present after
            // a swipe has started.
            if (isTouch && event.touches.length > 1) {
                return state;
            }
            // if swipe has exceeded duration stop tracking
            if (event.timeStamp - state.start > props.swipeDuration) {
                return state.swiping ? Object.assign(Object.assign({}, state), { swiping: false }) : state;
            }
            const { clientX, clientY } = isTouch ? event.touches[0] : event;
            const [x, y] = rotateXYByAngle([clientX, clientY], props.rotationAngle);
            const deltaX = x - state.xy[0];
            const deltaY = y - state.xy[1];
            const absX = Math.abs(deltaX);
            const absY = Math.abs(deltaY);
            const time = (event.timeStamp || 0) - state.start;
            const velocity = Math.sqrt(absX * absX + absY * absY) / (time || 1);
            const vxvy = [deltaX / (time || 1), deltaY / (time || 1)];
            const dir = getDirection(absX, absY, deltaX, deltaY);
            // if swipe is under delta and we have not started to track a swipe: skip update
            const delta = typeof props.delta === "number"
                ? props.delta
                : props.delta[dir.toLowerCase()] ||
                    defaultProps.delta;
            if (absX < delta && absY < delta && !state.swiping)
                return state;
            const eventData = {
                absX,
                absY,
                deltaX,
                deltaY,
                dir,
                event,
                first: state.first,
                initial: state.initial,
                velocity,
                vxvy,
            };
            // call onSwipeStart if present and is first swipe event
            eventData.first && props.onSwipeStart && props.onSwipeStart(eventData);
            // call onSwiping if present
            props.onSwiping && props.onSwiping(eventData);
            // track if a swipe is cancelable (handler for swiping or swiped(dir) exists)
            // so we can call preventDefault if needed
            let cancelablePageSwipe = false;
            if (props.onSwiping ||
                props.onSwiped ||
                props[`onSwiped${dir}`]) {
                cancelablePageSwipe = true;
            }
            if (cancelablePageSwipe &&
                props.preventScrollOnSwipe &&
                props.trackTouch &&
                event.cancelable) {
                event.preventDefault();
            }
            return Object.assign(Object.assign({}, state), { 
                // first is now always false
                first: false, eventData, swiping: true });
        });
    };
    const onEnd = (event) => {
        set((state, props) => {
            let eventData;
            if (state.swiping && state.eventData) {
                // if swipe is less than duration fire swiped callbacks
                if (event.timeStamp - state.start < props.swipeDuration) {
                    eventData = Object.assign(Object.assign({}, state.eventData), { event });
                    props.onSwiped && props.onSwiped(eventData);
                    const onSwipedDir = props[`onSwiped${eventData.dir}`];
                    onSwipedDir && onSwipedDir(eventData);
                }
            }
            else {
                props.onTap && props.onTap({ event });
            }
            props.onTouchEndOrOnMouseUp && props.onTouchEndOrOnMouseUp({ event });
            return Object.assign(Object.assign(Object.assign({}, state), initialState), { eventData });
        });
    };
    const cleanUpMouse = () => {
        // safe to just call removeEventListener
        document.removeEventListener(mouseMove, onMove);
        document.removeEventListener(mouseUp, onUp);
    };
    const onUp = (e) => {
        cleanUpMouse();
        onEnd(e);
    };
    /**
     * The value of passive on touchMove depends on `preventScrollOnSwipe`:
     * - true => { passive: false }
     * - false => { passive: true } // Default
     *
     * NOTE: When preventScrollOnSwipe is true, we attempt to call preventDefault to prevent scroll.
     *
     * props.touchEventOptions can also be set for all touch event listeners,
     * but for `touchmove` specifically when `preventScrollOnSwipe` it will
     * supersede and force passive to false.
     *
     */
    const attachTouch = (el, props) => {
        let cleanup = () => { };
        if (el && el.addEventListener) {
            const baseOptions = Object.assign(Object.assign({}, defaultProps.touchEventOptions), props.touchEventOptions);
            // attach touch event listeners and handlers
            const tls = [
                [touchStart, onStart, baseOptions],
                // preventScrollOnSwipe option supersedes touchEventOptions.passive
                [
                    touchMove,
                    onMove,
                    Object.assign(Object.assign({}, baseOptions), (props.preventScrollOnSwipe ? { passive: false } : {})),
                ],
                [touchEnd, onEnd, baseOptions],
            ];
            tls.forEach(([e, h, o]) => el.addEventListener(e, h, o));
            // return properly scoped cleanup method for removing listeners, options not required
            cleanup = () => tls.forEach(([e, h]) => el.removeEventListener(e, h));
        }
        return cleanup;
    };
    const onRef = (el) => {
        // "inline" ref functions are called twice on render, once with null then again with DOM element
        // ignore null here
        if (el === null)
            return;
        set((state, props) => {
            // if the same DOM el as previous just return state
            if (state.el === el)
                return state;
            const addState = {};
            // if new DOM el clean up old DOM and reset cleanUpTouch
            if (state.el && state.el !== el && state.cleanUpTouch) {
                state.cleanUpTouch();
                addState.cleanUpTouch = void 0;
            }
            // only attach if we want to track touch
            if (props.trackTouch && el) {
                addState.cleanUpTouch = attachTouch(el, props);
            }
            // store event attached DOM el for comparison, clean up, and re-attachment
            return Object.assign(Object.assign(Object.assign({}, state), { el }), addState);
        });
    };
    // set ref callback to attach touch event listeners
    const output = {
        ref: onRef,
    };
    // if track mouse attach mouse down listener
    if (handlerProps.trackMouse) {
        output.onMouseDown = onStart;
    }
    return [output, attachTouch];
}
function updateTransientState(state, props, previousProps, attachTouch) {
    // if trackTouch is off or there is no el, then remove handlers if necessary and exit
    if (!props.trackTouch || !state.el) {
        if (state.cleanUpTouch) {
            state.cleanUpTouch();
        }
        return Object.assign(Object.assign({}, state), { cleanUpTouch: undefined });
    }
    // trackTouch is on, so if there are no handlers attached, attach them and exit
    if (!state.cleanUpTouch) {
        return Object.assign(Object.assign({}, state), { cleanUpTouch: attachTouch(state.el, props) });
    }
    // trackTouch is on and handlers are already attached, so if preventScrollOnSwipe changes value,
    // remove and reattach handlers (this is required to update the passive option when attaching
    // the handlers)
    if (props.preventScrollOnSwipe !== previousProps.preventScrollOnSwipe ||
        props.touchEventOptions.passive !== previousProps.touchEventOptions.passive) {
        state.cleanUpTouch();
        return Object.assign(Object.assign({}, state), { cleanUpTouch: attachTouch(state.el, props) });
    }
    return state;
}
function useSwipeable(options) {
    const { trackMouse } = options;
    const transientState = react.useRef(Object.assign({}, initialState));
    const transientProps = react.useRef(Object.assign({}, defaultProps));
    // track previous rendered props
    const previousProps = react.useRef(Object.assign({}, transientProps.current));
    previousProps.current = Object.assign({}, transientProps.current);
    // update current render props & defaults
    transientProps.current = Object.assign(Object.assign({}, defaultProps), options);
    // Force defaults for config properties
    let defaultKey;
    for (defaultKey in defaultProps) {
        if (transientProps.current[defaultKey] === void 0) {
            transientProps.current[defaultKey] = defaultProps[defaultKey];
        }
    }
    const [handlers, attachTouch] = react.useMemo(() => getHandlers((stateSetter) => (transientState.current = stateSetter(transientState.current, transientProps.current)), { trackMouse }), [trackMouse]);
    transientState.current = updateTransientState(transientState.current, transientProps.current, previousProps.current, attachTouch);
    return handlers;
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Components/Cells/Carousel/carousel-progress.component.js



function CarouselProgress(_a) {
    var slides = _a.slides, position = _a.position;
    return (react.createElement("div", { className: "carousel-progress" }, slides.map(function (_, index) { return (react.createElement("div", { className: (0,classnames/* default */.Z)('carousel-progress__dot', {
            'carousel-progress__dot--active': index === position
        }), key: index })); })));
}


//# sourceMappingURL=carousel-progress.component.js.map

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/LazyImage.js
var LazyImage = __webpack_require__(93791);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/framer-motion/dist/es/components/LazyMotion/index.js
var LazyMotion = __webpack_require__(71966);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/framer-motion/dist/es/render/dom/features-animation.js + 82 modules
var features_animation = __webpack_require__(75452);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/framer-motion/dist/es/render/dom/motion-minimal.js + 29 modules
var motion_minimal = __webpack_require__(47032);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Components/Cells/Carousel/Web/carousel-mobile.component.js










function CarouselMobile(_a) {
    var _b;
    var slides = _a.slides, autoPlay = _a.autoPlay, autoPlaySpeed = _a.autoPlaySpeed, imageComponent = _a.imageComponent, classes = _a.classes;
    var _c = (0,react.useState)(0), position = _c[0], setPosition = _c[1];
    var showCarouselProgress = slides.length !== 1;
    var autoPlayRef = (0,react.useRef)(null);
    (0,react.useEffect)(function () {
        handleAutoPlay();
        return function () { return clearInterval(autoPlayRef.current); };
    }, [autoPlay, autoPlaySpeed]);
    var handleAutoPlay = function () {
        if (autoPlay) {
            if (!autoPlay.current) {
                autoPlayRef.current = setInterval(function () {
                    handleSwipe('Left');
                }, autoPlaySpeed);
            }
        }
    };
    var handleSwipe = function (dir) {
        if (dir === 'Left') {
            setPosition(function (prev) {
                return prev < slides.length - 1 ? prev + 1 : 0;
            });
        }
        if (dir === 'Right') {
            if (position > 0) {
                setPosition(position - 1);
            }
            else {
                setPosition(slides.length - 1);
            }
        }
    };
    var handlers = useSwipeable({
        onSwipedLeft: function () { return handleSwipe('Left'); },
        onSwipedRight: function () { return handleSwipe('Right'); },
        swipeDuration: Infinity,
        preventScrollOnSwipe: true,
        trackMouse: true
    });
    return (react.createElement("div", { className: (0,classnames/* default */.Z)('carousel__mobile__wrapper', classes) },
        react.createElement("div", (0,tslib_es6/* __assign */.pi)({}, handlers, { className: (0,classnames/* default */.Z)('carousel__mobile', {
                'carousel__mobile--solo': slides.length === 1
            }) }),
            react.createElement("div", { className: "carousel__mobile__container" },
                react.createElement(LazyMotion/* LazyMotion */.X, { features: features_animation/* domAnimation */.H }, slides.length > 1 ? (slides.map(function (item, index) { return (react.createElement(motion_minimal.m.div, { className: "carousel__mobile__slide", key: index, initial: {
                        left: "".concat(index * 60 - 30, "vw"),
                        scale: 1
                    }, animate: {
                        left: "".concat((index - position) * 60 - 30, "vw"),
                        scale: slides.length > 1 ? (index === position ? 1 : 0.85) : 1
                    }, transition: {
                        type: 'spring',
                        stiffness: 260,
                        damping: 20
                    } },
                    react.createElement(LazyImage/* default */.Z, { src: item.image, imageComponent: imageComponent, width: 230, height: 140, priority: index <= 2, alt: "carousel-image" }),
                    (item === null || item === void 0 ? void 0 : item.markups) ? (react.createElement("div", { className: "carousel-markup", dangerouslySetInnerHTML: {
                            __html: item.markups
                        } })) : null)); })) : (react.createElement("div", { className: "carousel__mobile__slide--solo" },
                    react.createElement(LazyImage/* default */.Z, { src: slides[0].image, imageComponent: imageComponent, width: 230, height: 140, alt: "carousel-image" }),
                    ((_b = slides[0]) === null || _b === void 0 ? void 0 : _b.markups) ? (react.createElement("div", { className: "carousel-markup", dangerouslySetInnerHTML: {
                            __html: slides[0].markups
                        } })) : null))))),
        showCarouselProgress ? (react.createElement(CarouselProgress, { slides: slides, position: position })) : null));
}


//# sourceMappingURL=carousel-mobile.component.js.map

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/swiper/react/swiper.js + 10 modules
var react_swiper = __webpack_require__(29030);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/swiper/react/swiper-slide.js
var swiper_slide = __webpack_require__(22208);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/swiper/core/core.js + 61 modules
var core = __webpack_require__(39569);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/swiper/shared/dom.js
var dom = __webpack_require__(72540);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/swiper/modules/autoplay/autoplay.js
var autoplay = __webpack_require__(52340);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/assets/icons/chevron-right-banner-icon.icon.js


function ChevronBannerRightArrow() {
    return (react.createElement("svg", { width: "30", height: "30", viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react.createElement("path", { d: "M7.5 3.525L19.0987 15L7.5 26.475L11.0883 30L26.25 15L11.0883 0L7.5 3.525Z", fill: "#151515" }),
        react.createElement("mask", { id: "mask0_6406_18326", style: { maskType: 'luminance' }, maskUnits: "userSpaceOnUse", x: "7", y: "0", width: "20", height: "30" },
            react.createElement("path", { d: "M7.5 3.525L19.0987 15L7.5 26.475L11.0883 30L26.25 15L11.0883 0L7.5 3.525Z", fill: "white" })),
        react.createElement("g", { mask: "url(#mask0_6406_18326)" },
            react.createElement("rect", { width: "30", height: "30", transform: "matrix(1 0 0 -1 0 30)", fill: "#2D2D2D" }))));
}


//# sourceMappingURL=chevron-right-banner-icon.icon.js.map

;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/assets/icons/chevron-left-banner-icon.icon.js


function ChevronBannerLeftArrow() {
    return (react.createElement("svg", { width: "30", height: "30", viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react.createElement("path", { d: "M22.5 3.525L10.9013 15L22.5 26.475L18.9117 30L3.75 15L18.9117 0L22.5 3.525Z", fill: "#151515" }),
        react.createElement("mask", { id: "mask0_6406_18334", style: { maskType: 'luminance' }, maskUnits: "userSpaceOnUse", x: "3", y: "0", width: "20", height: "30" },
            react.createElement("path", { d: "M22.5 3.525L10.9013 15L22.5 26.475L18.9117 30L3.75 15L18.9117 0L22.5 3.525Z", fill: "white" })),
        react.createElement("g", { mask: "url(#mask0_6406_18334)" },
            react.createElement("rect", { x: "30", y: "30", width: "30", height: "30", transform: "rotate(-180 30 30)", fill: "#2D2D2D" }))));
}


//# sourceMappingURL=chevron-left-banner-icon.icon.js.map

;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Components/Cells/Carousel/Web/carousel-desktop.component.js












function CarouselDesktop(_a) {
    var slides = _a.slides, autoPlay = _a.autoPlay; _a.autoPlaySpeed; var imageComponent = _a.imageComponent, classes = _a.classes;
    var _b = react.useState(0), activeIndex = _b[0], setActiveIndex = _b[1];
    var _c = react.useState(null), swiper = _c[0], setSwiper = _c[1];
    var showArrows = slides.length !== 1;
    var showCarouselProgress = slides.length !== 1;
    var swiperRef = (0,react.useRef)(null);
    var autoPlayOn = function () {
        var _a;
        (_a = swiperRef.current) === null || _a === void 0 ? void 0 : _a.swiper.autoplay.start();
    };
    var autoPlayOff = function () {
        var _a;
        (_a = swiperRef.current) === null || _a === void 0 ? void 0 : _a.swiper.autoplay.stop();
    };
    (0,react.useEffect)(function () {
        if ((swiperRef === null || swiperRef === void 0 ? void 0 : swiperRef.current) && autoPlay) {
            if ((slides === null || slides === void 0 ? void 0 : slides.length) > 1) {
                autoPlayOn();
            }
            else {
                autoPlayOff();
            }
        }
    }, [autoPlay, swiperRef === null || swiperRef === void 0 ? void 0 : swiperRef.current]);
    return (react.createElement("div", { className: (0,classnames/* default */.Z)('carousel__desktop__wrapper', classes) },
        react.createElement("div", { onMouseEnter: autoPlayOff, onMouseLeave: function () { return ((slides === null || slides === void 0 ? void 0 : slides.length) > 1 ? autoPlayOn() : null); }, className: "carousel__desktop" },
            react.createElement(react_swiper/* Swiper */.t, { ref: swiperRef, slidesPerView: slides.length < 3 ? 1 : 3, loop: true, className: (0,classnames/* default */.Z)('carousel-container', {
                    'carousel-container--big-banner': slides.length < 3
                }), spaceBetween: 16, centeredSlides: true, onSlideChangeTransitionEnd: function (s) { return setActiveIndex(s.realIndex); }, modules: [autoplay/* default */.Z], autoplay: {
                    delay: 3000
                }, onSwiper: function (s) {
                    setSwiper(s);
                } },
                showArrows ? (react.createElement("div", { onClick: function () { return swiper.slideNext(); }, className: "carousel__right_arrow__wrapper " },
                    react.createElement(ChevronBannerRightArrow, null))) : null,
                slides.map(function (slide, index) { return (react.createElement(swiper_slide/* SwiperSlide */.o, { className: "carousel__slide", key: index },
                    react.createElement(LazyImage/* default */.Z, { classes: "carousel__image", src: slide.image, alt: "carousel__slide", imageComponent: imageComponent, width: slides.length < 3 ? 1268 : 412, height: slides.length < 3 ? 500 : 260, priority: slides.length < 3 ? index === 0 : index < 3 }),
                    (slide === null || slide === void 0 ? void 0 : slide.markups) ? (react.createElement("div", { className: "carousel__slide__markup", dangerouslySetInnerHTML: {
                            __html: slide.markups
                        } })) : null)); }),
                showArrows ? (react.createElement("div", { onClick: function () { return swiper.slidePrev(); }, className: "carousel__left_arrow__wrapper " },
                    react.createElement(ChevronBannerLeftArrow, null))) : null)),
        showCarouselProgress ? (react.createElement(CarouselProgress, { slides: slides, position: activeIndex })) : null));
}


//# sourceMappingURL=carousel-desktop.component.js.map

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Utils/text.util.js
var text_util = __webpack_require__(72443);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Cells/Carousel.js






function Carousel(_a) {
    var classes = _a.classes, _b = _a.desktopSlides, desktopSlides = _b === void 0 ? [] : _b, _c = _a.mobileSlides, mobileSlides = _c === void 0 ? [] : _c, _d = _a.autoplay, autoplay = _d === void 0 ? true : _d, _e = _a.autoplaySpeed, autoplaySpeed = _e === void 0 ? 5000 : _e, imageComponent = _a.imageComponent;
    var _f = (0,react.useState)([]), slidesForDesktop = _f[0], setSlidesForDesktop = _f[1];
    var _g = (0,react.useState)([]), slidesForMobile = _g[0], setSlidesForMobile = _g[1];
    (0,react.useEffect)(function () {
        var sanitizedSlides = sanitizeSlides(desktopSlides);
        setSlidesForDesktop(sanitizedSlides);
    }, [desktopSlides]);
    (0,react.useEffect)(function () {
        var sanitizedSlides = sanitizeSlides(mobileSlides);
        setSlidesForMobile(sanitizedSlides);
    }, [mobileSlides]);
    var sanitizeSlides = function (slides) {
        return slides.map(function (slide) {
            slide.markups = (slide === null || slide === void 0 ? void 0 : slide.markups)
                ? text_util/* default.htmlDecode */.Z.htmlDecode(slide.markups)
                : '';
            return slide;
        });
    };
    if (!(slidesForDesktop === null || slidesForDesktop === void 0 ? void 0 : slidesForDesktop.length) && !(slidesForMobile === null || slidesForMobile === void 0 ? void 0 : slidesForMobile.length))
        return null;
    return (react.createElement("div", { className: (0,classnames/* default */.Z)('carousel', classes) },
        (slidesForMobile === null || slidesForMobile === void 0 ? void 0 : slidesForMobile.length) ? (react.createElement(CarouselMobile, { classes: "carousel-mobile", slides: slidesForMobile, autoPlay: autoplay, autoPlaySpeed: autoplaySpeed, imageComponent: imageComponent })) : null,
        (slidesForDesktop === null || slidesForDesktop === void 0 ? void 0 : slidesForDesktop.length) ? (react.createElement(CarouselDesktop, { classes: "carousel-desktop", slides: slidesForDesktop, autoPlay: autoplay, autoPlaySpeed: autoplaySpeed, imageComponent: imageComponent })) : null));
}


//# sourceMappingURL=Carousel.js.map


/***/ }),

/***/ 36780:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ItemListCart; }
});

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(36929);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/classnames/index.js
var classnames = __webpack_require__(87637);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/Typography.js
var Typography = __webpack_require__(87427);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/Input.js
var Input = __webpack_require__(3670);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/assets/barbeque-997a871a.svg
var barbeque_997a871a = __webpack_require__(9994);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/LazyImage.js
var LazyImage = __webpack_require__(93791);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Molecules/CartItemCard.js
var CartItemCard = __webpack_require__(54387);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/Button.js
var Button = __webpack_require__(66693);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/assets/icons/caution.icon.js
var caution_icon = __webpack_require__(85470);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/Icon.js
var Icon = __webpack_require__(8055);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/assets/icons/special-request.icon.js




function SpecialRequestIcon(props) {
    return (react.createElement(Icon/* default */.Z, (0,tslib_es6/* __assign */.pi)({ svg: function () { return "\n    <svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <mask id=\"mask0_134_1438\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"3\" y=\"1\" width=\"19\" height=\"22\">\n    <path d=\"M20 11.5V7L15.5 2H5C4.73478 2 4.48043 2.10536 4.29289 2.29289C4.10536 2.48043 4 2.73478 4 3V21C4 21.2652 4.10536 21.5196 4.29289 21.7071C4.48043 21.8946 4.73478 22 5 22H11\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n    <path d=\"M16 22L21 17L19 15L14 20V22H16Z\" fill=\"white\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n    <path d=\"M15 2V7H20\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n    </mask>\n    <g mask=\"url(#mask0_134_1438)\">\n    <path d=\"M0 0H24V24H0V0Z\" fill=\"black\"/>\n    </g>\n    </svg>\n    "; } }, props)));
}


//# sourceMappingURL=special-request.icon.js.map

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Utils/currency.util.js
var currency_util = __webpack_require__(46454);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/assets/icons/plus.icon.js
var plus_icon = __webpack_require__(95289);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/@ant-design/icons/lib/components/Icon.js + 1 modules
var components_Icon = __webpack_require__(4610);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/provider.js
var provider = __webpack_require__(53675);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Utils/clone.util.js
var clone_util = __webpack_require__(58316);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Cells/ItemListCart.js


















function ItemListCart(_a) {
    var _this = this;
    var _b;
    var classes = _a.classes, cartItems = _a.cartItems, editCustomizationCallback = _a.editCustomizationCallback, checkoutCallback = _a.checkoutCallback, onItemUpdate = _a.onItemUpdate, subTotal = _a.subTotal, totalItems = _a.totalItems, showCount = _a.showCount, _c = _a.hideCheckout, hideCheckout = _c === void 0 ? false : _c, _d = _a.minOrder, minOrder = _d === void 0 ? 0 : _d, _e = _a.hideRequest, hideRequest = _e === void 0 ? true : _e, specialRequest = _a.specialRequest, onSpecialRequestChange = _a.onSpecialRequestChange, _f = _a.hideAddMoreItems, hideAddMoreItems = _f === void 0 ? true : _f, addMoreItemsCallback = _a.addMoreItemsCallback, imageComponent = _a.imageComponent, itemLevelInstructionsEnabled = _a.itemLevelInstructionsEnabled;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var _g = (0,react.useState)(false), loading = _g[0], setLoading = _g[1];
    var _h = react.useState(specialRequest || ''), specialRequestText = _h[0], setSpecialRequestText = _h[1];
    var isStoreClosed = ((_b = (0,react.useContext)(provider/* ThemeContext */.N)) === null || _b === void 0 ? void 0 : _b.isStoreClosed) || false;
    var cartItemsClone = (0,clone_util/* default */.Z)(cartItems);
    var _onItemUpdate = function (item, quantity, dir) {
        onItemUpdate((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, item), { quantity: quantity }), dir);
    };
    var PlusIconComponent = function (props) { return (react.createElement(components_Icon/* default */.Z, (0,tslib_es6/* __assign */.pi)({ component: plus_icon/* default */.Z }, props))); };
    (0,react.useEffect)(function () {
        onSpecialRequestChange === null || onSpecialRequestChange === void 0 ? void 0 : onSpecialRequestChange(specialRequestText);
    }, [specialRequestText]);
    var containerRef = (0,react.useRef)(null);
    var _j = (0,react.useState)(false), showTopShadow = _j[0], setShowTopShadow = _j[1];
    (0,react.useEffect)(function () {
        var _a;
        var handleScroll = function () {
            var scrollTop = containerRef.current.scrollTop;
            setShowTopShadow(scrollTop > 0);
        };
        (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('scroll', handleScroll);
        return function () {
            var _a;
            if (containerRef !== null && containerRef.current) {
                (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('scroll', handleScroll);
            }
        };
    }, [containerRef.current]);
    return (react.createElement("div", { className: (0,classnames/* default */.Z)('item-list-cart', classes) },
        react.createElement("div", { className: "item-list-cart-heading", style: {
                boxShadow: showTopShadow ? '0px 2px 2px rgb(0 0 0 / 6%)' : 'none'
            } },
            react.createElement(Typography/* default */.Z, { classes: (0,classnames/* default */.Z)('item-list-cart__title', {
                    'item-list-cart__title--sticky': !hideCheckout
                }), variant: "headingOne" },
                t('menu.cartSummary'),
                ' '),
            showCount && (react.createElement(Typography/* default */.Z, { variant: "bodyTextOne", classes: "item-list-cart__subtitle" },
                "(",
                totalItems,
                " ",
                t('menu.items'),
                ")"))),
        totalItems ? (react.createElement("div", { className: "item-list-cart--active-state", ref: containerRef },
            react.createElement("div", { className: "item-list-cart__items" },
                cartItemsClone.reverse().map(function (item, index) { return (react.createElement(react.Fragment, { key: index },
                    react.createElement(CartItemCard/* default */.Z, { classes: "item-list-cart__item", id: item.id, key: item.id, item_title: item.item_title, item_price: item.item_price, food_type: item.food_type, options: item.options, quantity: item.quantity, signature: item.signature, instructions: item === null || item === void 0 ? void 0 : item.instructions, variant: "outline", onItemUpdate: function (itemId, quantity, dir) {
                            _onItemUpdate(item, quantity, dir);
                        }, onInstructionsChange: function (instructions) {
                            return _onItemUpdate((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, item), { instructions: instructions }), item.quantity, 0);
                        }, editCustomizationCallback: editCustomizationCallback, has_options: (item === null || item === void 0 ? void 0 : item.has_options) || false, itemLevelInstructionsEnabled: itemLevelInstructionsEnabled }))); }),
                hideCheckout && minOrder > subTotal
                    ? minOrder > 0 && (react.createElement("div", { className: "item-list-cart__min-order-value" },
                        react.createElement(caution_icon/* default */.Z, null),
                        react.createElement(Typography/* default */.Z, { variant: "bodyTextTwoMain" }, t('menu.minOrderValue', {
                            minOrder: currency_util/* default.format */.Z.format(minOrder)
                        }))))
                    : null),
            !hideCheckout ? (react.createElement(react.Fragment, null,
                react.createElement("div", { className: "item-list-cart__footer", style: {
                        boxShadow: '0px -2px 8px rgba(0, 0, 0, 0.06)'
                    } },
                    react.createElement("div", { className: "item-list-cart__sub-total" },
                        react.createElement("div", { className: "item-list-cart__footer-left" },
                            react.createElement(Typography/* default */.Z, { classes: "item-list-cart__footer-left-sub-total-label", variant: "bodyTextOneMain" }, t('menu.subTotal')),
                            react.createElement(Typography/* default */.Z, { classes: "item-list-cart__footer-left--total-count", variant: "bodyTextTwo" }, totalItems === 1
                                ? t('menu.itemCountSingular', {
                                    itemCount: totalItems
                                })
                                : t('menu.itemCountPlural', { itemCount: totalItems })),
                            react.createElement(Typography/* default */.Z, { classes: "item-list-cart__footer-left--sub-title", variant: "bodyTextTwo" }, t('menu.taxesAndCharges'))),
                        react.createElement("div", { className: "item-list-cart__footer-right" },
                            react.createElement(Typography/* default */.Z, { variant: "bodyTextOneMain" }, currency_util/* default.format */.Z.format(subTotal)))),
                    react.createElement(Button/* default */.Z, { loading: loading, classes: "item-list-cart__checkout-button", variant: 'solid', size: 'lg', onClick: function () { return (0,tslib_es6/* __awaiter */.mG)(_this, void 0, void 0, function () {
                            var _a;
                            return (0,tslib_es6/* __generator */.Jh)(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        setLoading(true);
                                        _a = checkoutCallback;
                                        if (!_a) return [3 /*break*/, 2];
                                        return [4 /*yield*/, checkoutCallback()];
                                    case 1:
                                        _a = (_b.sent());
                                        _b.label = 2;
                                    case 2:
                                        setLoading(false);
                                        return [2 /*return*/];
                                }
                            });
                        }); }, disabled: (minOrder > subTotal && minOrder > 0) || isStoreClosed }, t('menu.checkout')),
                    minOrder > subTotal && minOrder > 0 && (react.createElement("div", { className: "item-list-cart__min-order-value" },
                        react.createElement(caution_icon/* default */.Z, null),
                        react.createElement(Typography/* default */.Z, { classes: "item-list-cart__min-order-value--text", variant: "bodyTextTwoMain" }, t('menu.minOrderValue', {
                            minOrder: currency_util/* default.format */.Z.format(minOrder)
                        }))))))) : (react.createElement("div", { className: "item-list-cart-footer--secondary" },
                !hideAddMoreItems ? (react.createElement("div", { className: "item-list-cart__add-more-items" },
                    react.createElement(PlusIconComponent, { className: "item-list-cart__add-more-items-icon" }),
                    react.createElement(Button/* default */.Z, { classes: "item-list-cart__add-more-items-button", onClick: function () { return addMoreItemsCallback === null || addMoreItemsCallback === void 0 ? void 0 : addMoreItemsCallback(); }, variant: 'link', size: 'lg' }, t('checkout.addMoreItems')))) : null,
                !hideRequest ? (react.createElement(Input/* default */.Z, { label: t('checkout.specialRequest'), placeholder: t('checkout.enterRequest'), leftIcon: react.createElement(SpecialRequestIcon, null), classes: "special-request", value: specialRequestText, onChange: function (e) {
                        setSpecialRequestText(e.target.value);
                    } })) : null)))) : (react.createElement("div", { className: "item-list-cart--empty-state" },
            react.createElement(LazyImage/* default */.Z, (0,tslib_es6/* __assign */.pi)({}, barbeque_997a871a/* default */.Z, { alt: "Cart Empty", classes: "item-list-cart__illustration", imageComponent: imageComponent })),
            react.createElement("div", { className: "item-list-cart__empty-state-text" },
                react.createElement(Typography/* default */.Z, { variant: "headingThree" }, t('menu.cartEmpty')),
                react.createElement(Typography/* default */.Z, { variant: "bodyTextOne" }, t('menu.cartEmptyDescription')))))));
}


//# sourceMappingURL=ItemListCart.js.map


/***/ }),

/***/ 3121:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ ItemListNavigator; }
});

// UNUSED EXPORTS: DesktopNavigator, MobileNavigator

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/classnames/index.js
var classnames = __webpack_require__(87637);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/assets/icons/cutlery.icon.js


function CutleryIcon() {
    return (react.createElement("svg", { width: "13", height: "12", viewBox: "0 0 13 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react.createElement("path", { d: "M1.91673 12L0.983398 11.0667L7.81673 4.23333C7.61673 3.76667 7.58895 3.23889 7.7334 2.65C7.87784 2.06111 8.19451 1.53333 8.6834 1.06667C9.27229 0.477778 9.92784 0.133333 10.6501 0.0333333C11.3723 -0.0666667 11.9612 0.111111 12.4167 0.566667C12.8723 1.02222 13.0501 1.61111 12.9501 2.33333C12.8501 3.05556 12.5056 3.71111 11.9167 4.3C11.4501 4.78889 10.9223 5.10556 10.3334 5.25C9.74451 5.39444 9.21673 5.36667 8.75006 5.16667L7.91673 6L12.9834 11.0667L12.0501 12L6.9834 6.96667L1.91673 12ZM3.8834 6.3L1.8834 4.3C1.2834 3.7 0.983398 2.98333 0.983398 2.15C0.983398 1.31667 1.2834 0.6 1.8834 0L6.01673 4.16667L3.8834 6.3Z", fill: "white" })));
}


//# sourceMappingURL=cutlery.icon.js.map

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/Typography.js
var Typography = __webpack_require__(87427);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/_virtual/_commonjsHelpers.js
var _commonjsHelpers = __webpack_require__(72017);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/_virtual/CloseCircleFilled.js
var CloseCircleFilledExports = {};
var CloseCircleFilled = {
  get exports(){ return CloseCircleFilledExports; },
  set exports(v){ CloseCircleFilledExports = v; },
};


//# sourceMappingURL=CloseCircleFilled.js.map

;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/_virtual/CloseCircleFilled2.js
var CloseCircleFilled2_CloseCircleFilled = {};


//# sourceMappingURL=CloseCircleFilled2.js.map

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/@babel/runtime/helpers/interopRequireDefault.js
var interopRequireDefault = __webpack_require__(80724);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/@babel/runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__(57961);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/@babel/runtime/helpers/objectSpread2.js + 1 modules
var objectSpread2 = __webpack_require__(35629);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/_virtual/CloseCircleFilled3.js
var CloseCircleFilled3_CloseCircleFilled = {};


//# sourceMappingURL=CloseCircleFilled3.js.map

;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/@ant-design/icons-svg/lib/asn/CloseCircleFilled.js


var hasRequiredCloseCircleFilled;

function requireCloseCircleFilled () {
	if (hasRequiredCloseCircleFilled) return CloseCircleFilled3_CloseCircleFilled;
	hasRequiredCloseCircleFilled = 1;
	// This icon file is generated automatically.
	Object.defineProperty(CloseCircleFilled3_CloseCircleFilled, "__esModule", { value: true });
	var CloseCircleFilled$1 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 01-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z" } }] }, "name": "close-circle", "theme": "filled" };
	CloseCircleFilled3_CloseCircleFilled["default"] = CloseCircleFilled$1;
	return CloseCircleFilled3_CloseCircleFilled;
}


//# sourceMappingURL=CloseCircleFilled.js.map

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/@ant-design/icons/lib/components/AntdIcon.js + 17 modules
var AntdIcon = __webpack_require__(77160);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/_virtual/interopRequireDefault.js
var _virtual_interopRequireDefault = __webpack_require__(50939);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/_virtual/typeof.js
var _virtual_typeof = __webpack_require__(24748);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/@ant-design/icons/lib/icons/CloseCircleFilled.js










var _interopRequireDefault = _virtual_interopRequireDefault/* exports */.I;
var _typeof = _virtual_typeof/* exports */.I;
Object.defineProperty(CloseCircleFilled2_CloseCircleFilled, "__esModule", {
  value: true
});
CloseCircleFilled2_CloseCircleFilled["default"] = void 0;
var _objectSpread2 = _interopRequireDefault((0,objectSpread2/* __require */.s)());
var React = _interopRequireWildcard(react);
var _CloseCircleFilled = _interopRequireDefault(requireCloseCircleFilled());
var _AntdIcon = _interopRequireDefault((0,AntdIcon/* __require */.s)());
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var CloseCircleFilled_CloseCircleFilled = function CloseCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    ref: ref,
    icon: _CloseCircleFilled.default
  }));
};
CloseCircleFilled_CloseCircleFilled.displayName = 'CloseCircleFilled';
var _default = /*#__PURE__*/React.forwardRef(CloseCircleFilled_CloseCircleFilled);
CloseCircleFilled2_CloseCircleFilled["default"] = _default;
//# sourceMappingURL=CloseCircleFilled.js.map

;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/@ant-design/icons/CloseCircleFilled.js





(function (module, exports) {
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = void 0;
	  
	  var _CloseCircleFilled = _interopRequireDefault(CloseCircleFilled2_CloseCircleFilled);
	  
	  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	  
	  var _default = _CloseCircleFilled;
	  exports.default = _default;
	  module.exports = _default;
} (CloseCircleFilled, CloseCircleFilledExports));

var icons_CloseCircleFilled_CloseCircleFilled = /*@__PURE__*/(0,_commonjsHelpers/* getDefaultExportFromCjs */.fm)(CloseCircleFilledExports);


//# sourceMappingURL=CloseCircleFilled.js.map

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/FloatingStack.js
var FloatingStack = __webpack_require__(2889);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Molecules/Dialog.js
var Dialog = __webpack_require__(95066);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Components/Cells/ItemListNavigator/Web/mobile-navigator.component.js









function MobileNavigator(_a) {
    var classes = _a.classes, activeCategoryId = _a.activeCategoryId, activeSubCategoryId = _a.activeSubCategoryId, categories = _a.categories, onCategoryChange = _a.onCategoryChange;
    var _b = (0,react.useState)(false), _isOpen = _b[0], setOpen = _b[1];
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var _onCategoryChange = function (catId, subCatId, fromCat) {
        onCategoryChange === null || onCategoryChange === void 0 ? void 0 : onCategoryChange(catId, subCatId);
        if (subCatId && fromCat)
            return;
        setOpen(false);
    };
    return (react.createElement(FloatingStack["default"], { order: 5 },
        react.createElement("div", { className: (0,classnames/* default */.Z)('mobile-navigator', classes) },
            !_isOpen ? (react.createElement("div", { onClick: function () { return setOpen(true); }, className: "mobile-navigator__menu-button" },
                react.createElement(CutleryIcon, null),
                react.createElement(Typography/* default */.Z, { classes: "mobile-navigator__button__text", variant: 'bodyTextOneMain' }, t('menu.menu')))) : null,
            react.createElement(Dialog/* default */.Z, { removeCloseIcon: true, footer: false, isOpen: _isOpen, onClose: function () { return setOpen(false); }, classes: "mobile-navigator__menu" },
                react.createElement("div", { className: "mobile-navigator__menu-list-wrapper" },
                    react.createElement("div", { className: "mobile-navigator__menu-list" }, categories === null || categories === void 0 ? void 0 : categories.map(function (category) {
                        var _a;
                        return (react.createElement(react.Fragment, { key: category === null || category === void 0 ? void 0 : category.id },
                            react.createElement("div", { className: (0,classnames/* default */.Z)('mobile-navigator__menu__item', {
                                    'mobile-navigator__menu__item--active': (category === null || category === void 0 ? void 0 : category.id) === activeCategoryId
                                }), onClick: function () {
                                    var _a, _b;
                                    return _onCategoryChange(category === null || category === void 0 ? void 0 : category.id, (_b = (_a = category === null || category === void 0 ? void 0 : category.sub_categories) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.id, true);
                                } },
                                react.createElement("div", { className: "mobile-navigator__menu__item__label" },
                                    react.createElement("div", { className: "mobile-navigator__menu__item__highlighter" }),
                                    react.createElement(Typography/* default */.Z, { variant: "bodyTextOneMain", classes: "mobile-navigator__menu__item__text" }, category === null || category === void 0 ? void 0 : category.name)),
                                react.createElement(Typography/* default */.Z, { variant: "bodyTextOneMain", classes: "mobile-navigator__menu__item__count" }, category === null || category === void 0 ? void 0 : category.item_count)),
                            (category === null || category === void 0 ? void 0 : category.id) === activeCategoryId ? (react.createElement("div", { className: "mobile-navigator__menu__item__sub-category" }, (_a = category === null || category === void 0 ? void 0 : category.sub_categories) === null || _a === void 0 ? void 0 : _a.map(function (subCategory) { return (react.createElement("div", { onClick: function () {
                                    return _onCategoryChange &&
                                        _onCategoryChange(category === null || category === void 0 ? void 0 : category.id, subCategory === null || subCategory === void 0 ? void 0 : subCategory.id, false);
                                }, key: subCategory === null || subCategory === void 0 ? void 0 : subCategory.id, className: (0,classnames/* default */.Z)('mobile-navigator__menu__item__sub-category__item', {
                                    'mobile-navigator__menu__item__sub-category__item--active': (subCategory === null || subCategory === void 0 ? void 0 : subCategory.id) === activeSubCategoryId
                                }) },
                                react.createElement(Typography/* default */.Z, { classes: "mobile-navigator__menu__item__sub-category__item__text", variant: activeSubCategoryId === (subCategory === null || subCategory === void 0 ? void 0 : subCategory.id)
                                        ? 'bodyTextTwoMain'
                                        : 'bodyTextTwo' }, subCategory === null || subCategory === void 0 ? void 0 : subCategory.name),
                                react.createElement(Typography/* default */.Z, { variant: activeSubCategoryId === (subCategory === null || subCategory === void 0 ? void 0 : subCategory.id)
                                        ? 'bodyTextTwoMain'
                                        : 'bodyTextTwo', classes: "mobile-navigator__menu__item__count" }, subCategory === null || subCategory === void 0 ? void 0 : subCategory.item_count))); }))) : null));
                    })),
                    _isOpen ? (react.createElement(icons_CloseCircleFilled_CloseCircleFilled, { onClick: function () { return setOpen(false); }, className: "mobile-navigator__menu__close-icon" })) : null,
                    ' ')))));
}


//# sourceMappingURL=mobile-navigator.component.js.map

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Components/Cells/ItemListNavigator/Web/desktop-navigator.component.js
var desktop_navigator_component = __webpack_require__(63633);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Utils/isMobile.util.js
var isMobile_util = __webpack_require__(30558);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Cells/ItemListNavigator.js






function ItemListNavigator(_a) {
    var classes = _a.classes, activeCategoryId = _a.activeCategoryId, activeSubCategoryId = _a.activeSubCategoryId, categories = _a.categories, onCategoryChange = _a.onCategoryChange;
    var handleCategoryChange = function (categoryId, subCategoryId) {
        if (typeof onCategoryChange === 'function') {
            onCategoryChange(categoryId, subCategoryId);
        }
    };
    var isMobile = (0,isMobile_util/* useIsMobile */.d)();
    return (react.createElement("div", { className: (0,classnames/* default */.Z)('item-list-navigator', classes) },
        isMobile && (categories === null || categories === void 0 ? void 0 : categories.length) ? (react.createElement(MobileNavigator, { activeCategoryId: activeCategoryId, activeSubCategoryId: activeSubCategoryId, categories: categories, onCategoryChange: handleCategoryChange })) : null,
        !isMobile && (react.createElement(desktop_navigator_component/* default */.Z, { activeCategoryId: activeCategoryId, activeSubCategoryId: activeSubCategoryId, categories: categories, onCategoryChange: handleCategoryChange }))));
}


//# sourceMappingURL=ItemListNavigator.js.map


/***/ }),

/***/ 63633:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DesktopNavigator; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87637);
/* harmony import */ var _Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87427);
/* harmony import */ var _assets_icons_down_arrow_icon_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56088);
/* harmony import */ var _provider_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53675);






function DesktopNavigator(_a) {
    var classes = _a.classes, activeCategoryId = _a.activeCategoryId, activeSubCategoryId = _a.activeSubCategoryId, categories = _a.categories, onCategoryChange = _a.onCategoryChange, _b = _a.orientation, orientation = _b === void 0 ? 'right' : _b, _c = _a.background, background = _c === void 0 ? true : _c;
    var _d = react__WEBPACK_IMPORTED_MODULE_0__.useState(activeCategoryId), _activeCategoryId = _d[0], setActiveCategoryId = _d[1];
    var _e = react__WEBPACK_IMPORTED_MODULE_0__.useState(activeSubCategoryId), _activeSubCategoryId = _e[0], setActiveSubCategoryId = _e[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () { return setActiveCategoryId(activeCategoryId); }, [activeCategoryId]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () { return setActiveSubCategoryId(activeSubCategoryId); }, [activeSubCategoryId]);
    var _onCategoryChange = function (categoryId, subCategoryId) {
        setActiveCategoryId(categoryId);
        setActiveSubCategoryId(subCategoryId);
        onCategoryChange && onCategoryChange(categoryId, subCategoryId);
    };
    var theme = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_provider_js__WEBPACK_IMPORTED_MODULE_4__/* .ThemeContext */ .N).theme;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('desktop-navigator', classes) }, categories === null || categories === void 0 ? void 0 : categories.map(function (category) {
        var _a, _b;
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, { key: category === null || category === void 0 ? void 0 : category.id },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('desktop-navigator__item', {
                    'desktop-navigator__item--active': (category === null || category === void 0 ? void 0 : category.id) === _activeCategoryId,
                    bg: background
                }, orientation), onClick: function () { var _a, _b; return _onCategoryChange(category === null || category === void 0 ? void 0 : category.id, (_b = (_a = category === null || category === void 0 ? void 0 : category.sub_categories) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.id); } },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { variant: (category === null || category === void 0 ? void 0 : category.id) === _activeCategoryId
                        ? 'bodyTextOneMain'
                        : 'bodyTextOne', classes: "desktop-navigator__item__text" }, category === null || category === void 0 ? void 0 : category.name),
                ((_a = category === null || category === void 0 ? void 0 : category.sub_categories) === null || _a === void 0 ? void 0 : _a.length) ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_assets_icons_down_arrow_icon_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, { className: "desktop-navigator__item__icon", color: theme.colors.primaryColor })) : null),
            (category === null || category === void 0 ? void 0 : category.id) === _activeCategoryId ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "desktop-navigator__sub-category" }, (_b = category === null || category === void 0 ? void 0 : category.sub_categories) === null || _b === void 0 ? void 0 : _b.map(function (subCategory) { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { key: subCategory === null || subCategory === void 0 ? void 0 : subCategory.id, variant: (subCategory === null || subCategory === void 0 ? void 0 : subCategory.id) === _activeSubCategoryId
                    ? 'bodyTextOneMain'
                    : 'bodyTextOne', classes: (0,_external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('desktop-navigator__sub-category__item', {
                    'desktop-navigator__sub-category__item--active': (subCategory === null || subCategory === void 0 ? void 0 : subCategory.id) === _activeSubCategoryId
                }), onClickCallback: function () {
                    return _onCategoryChange(category === null || category === void 0 ? void 0 : category.id, subCategory === null || subCategory === void 0 ? void 0 : subCategory.id);
                } }, subCategory === null || subCategory === void 0 ? void 0 : subCategory.name)); }))) : null));
    })));
}


//# sourceMappingURL=desktop-navigator.component.js.map


/***/ }),

/***/ 27464:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ItemCardShimmer; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87637);



function ItemCardShimmer(_a) {
    var classes = _a.classes;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(' item-card-shimmer', classes) },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "item-card-shimmer__left" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "item-card-shimmer__title" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "item-card-shimmer__description1" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "item-card-shimmer__description2" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "item-card-shimmer__description3" })),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "item-card-shimmer__right" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "item-card-shimmer__image" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "button" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "customizable" }))));
}


//# sourceMappingURL=index.shimmer.js.map


/***/ }),

/***/ 54387:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CartItemCard; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Atoms_DietIndicator_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10371);
/* harmony import */ var _Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87427);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26793);
/* harmony import */ var _external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87637);
/* harmony import */ var _AddToCart_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2082);
/* harmony import */ var _Utils_currency_util_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46454);
/* harmony import */ var _Confirm_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68494);
/* harmony import */ var _Atoms_Divider_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36548);










function CartItemCard(_a) {
    var _b, _c;
    var classes = _a.classes, item_title = _a.item_title, item_price = _a.item_price, food_type = _a.food_type, options = _a.options, loading = _a.loading, quantity = _a.quantity, variant = _a.variant, id = _a.id, signature = _a.signature, _d = _a.current_stock, current_stock = _d === void 0 ? -1 : _d, _e = _a.disablePrice, disablePrice = _e === void 0 ? false : _e, _f = _a.disableEditCustomization, disableEditCustomization = _f === void 0 ? false : _f, itemLevelInstructionsEnabled = _a.itemLevelInstructionsEnabled, instructions = _a.instructions, onItemUpdate = _a.onItemUpdate, editCustomizationCallback = _a.editCustomizationCallback, onInstructionsChange = _a.onInstructionsChange;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_8__/* .useTranslation */ .$)().t;
    var areInstructionsAvailable = (instructions === null || instructions === void 0 ? void 0 : instructions.trim()) ? true : false;
    var confirmationDialog = (0,_Confirm_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    var notesRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
    var onEditCustomization = function () {
        editCustomizationCallback &&
            editCustomizationCallback({
                id: id,
                item_title: item_title,
                item_price: item_price,
                food_type: food_type,
                options: options,
                quantity: quantity,
                signature: signature
            });
    };
    /**
     * On confirm dialog causes state stale issue when we controlled textarea, there fore we are using a uncontrolled textarea
     */
    var onUpdateNotes = function () {
        confirmationDialog({
            title: areInstructionsAvailable
                ? t('cart.editNotes')
                : t('cart.addNotesHeader'),
            content: (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "cart-item-notes-wrapper" },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_DietIndicator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, { food_type: food_type }),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "cart-item-card__title" },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { variant: "headingThree" }, item_title)),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("textarea", { ref: notesRef, className: "cart-item__textarea", placeholder: t('cart.itemLevelInstructions') }, instructions))),
            removeCloseIcon: false,
            dismissText: areInstructionsAvailable
                ? t('cart.clear')
                : t('cart.cancel'),
            onCancel: function () {
                areInstructionsAvailable && (onInstructionsChange === null || onInstructionsChange === void 0 ? void 0 : onInstructionsChange(''));
            },
            confirmText: areInstructionsAvailable ? t('cart.update') : t('cart.save'),
            onConfirm: function () {
                var _a;
                onInstructionsChange === null || onInstructionsChange === void 0 ? void 0 : onInstructionsChange(((_a = notesRef.current) === null || _a === void 0 ? void 0 : _a.value) || '');
            }
        });
    };
    var calculatePrice = function (item_price, options) {
        return (item_price +
            ((options === null || options === void 0 ? void 0 : options.reduce(function (r, option) { return r + option.price * ((option === null || option === void 0 ? void 0 : option.quantity) || 1); }, 0)) || 0));
    };
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)('cart-item-card', classes) },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "cart-item-card__left" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_DietIndicator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, { classes: "cart-item-card__diet-indicator", food_type: food_type }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "cart-item-card__title" },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { variant: "bodyTextTwoMain" }, item_title)),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { classes: "cart-item-card__options", variant: "bodyTextTwo" }, (_c = (_b = options === null || options === void 0 ? void 0 : options.map) === null || _b === void 0 ? void 0 : _b.call(options, function (option) { return option === null || option === void 0 ? void 0 : option.title; })) === null || _c === void 0 ? void 0 : _c.join(', ')),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "cart-item-card__actions" },
                !disableEditCustomization && (options === null || options === void 0 ? void 0 : options.length) > 0 ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { onClickCallback: onEditCustomization, classes: "cart-item-card__edit", variant: "bodyTextTwo", noWrap: true }, t('cart.editCustomization'))) : null,
                itemLevelInstructionsEnabled &&
                    !disableEditCustomization &&
                    (options === null || options === void 0 ? void 0 : options.length) > 0 ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Divider_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, { classes: "cart-item-card__divider", variant: "vertical", dividerStyle: 'solid' })) : null,
                itemLevelInstructionsEnabled ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { onClickCallback: onUpdateNotes, classes: "cart-item-card__notes", variant: "bodyTextTwo", noWrap: true }, areInstructionsAvailable
                    ? t('cart.editNotes')
                    : t('cart.addNotes'))) : null)),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "cart-item-cart__right" },
            onItemUpdate != null && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_AddToCart_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { classes: "cart-item-card__add-to-cart", loading: loading, onItemUpdate: onItemUpdate, quantity: quantity, variant: variant, itemId: id, stock: current_stock })),
            !disablePrice && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { classes: "cart-item-card__price", variant: "bodyTextTwo" }, _Utils_currency_util_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"].format */ .Z.format(calculatePrice(item_price, options)))))));
}


//# sourceMappingURL=CartItemCard.js.map


/***/ }),

/***/ 6501:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ItemCard; }
/* harmony export */ });
/* harmony import */ var _external_lib_tslib_tslib_es6_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(36929);
/* harmony import */ var _Atoms_LazyImage_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93791);
/* harmony import */ var _AddToCart_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2082);
/* harmony import */ var _Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87427);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26793);
/* harmony import */ var _external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87637);
/* harmony import */ var _Atoms_DietIndicator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10371);
/* harmony import */ var _Atoms_FavouriteIndicator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53212);
/* harmony import */ var _Utils_rtl_hook_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(12528);
/* harmony import */ var _Components_Molecules_ItemCard_Web_index_shimmer_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(27464);
/* harmony import */ var _Utils_currency_util_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(46454);
/* harmony import */ var _Utils_isMobile_util_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(30558);














function ItemCard(_a) {
    var _this = this;
    var id = _a.id, item_title = _a.item_title, item_price = _a.item_price, current_stock = _a.current_stock, markup_price = _a.markup_price, food_type = _a.food_type, item_desc = _a.item_desc, has_options = _a.has_options, image_blur_hash = _a.image_blur_hash, image_url = _a.image_url, price_descriptor = _a.price_descriptor, count = _a.count, isFavourite = _a.isFavourite, toggleFavourite = _a.toggleFavourite, onClickCallback = _a.onClickCallback, loading = _a.loading, onItemUpdate = _a.onItemUpdate, imageComponent = _a.imageComponent, onError = _a.onError, isFavouriteEnabled = _a.isFavouriteEnabled, classes = _a.classes, shimmerClass = _a.shimmerClass, loadFirst = _a.loadFirst;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_10__/* .useTranslation */ .$)().t;
    var isRTL = (0,_Utils_rtl_hook_js__WEBPACK_IMPORTED_MODULE_11__/* .useDetectRTL */ .p)();
    var isMobile = (0,_Utils_isMobile_util_js__WEBPACK_IMPORTED_MODULE_9__/* .useIsMobile */ .d)();
    var _b = react__WEBPACK_IMPORTED_MODULE_3__.useState(false), isElementOverflow = _b[0], setIsElementOverflow = _b[1];
    var showMore = react__WEBPACK_IMPORTED_MODULE_3__.useState(false)[0];
    var descriptionRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    function isOverflowY(element) {
        /**
         * 1px is added to account for the rounding error in the calculation
         */
        return (Math.floor(element.scrollHeight / 10) * 10 >
            Math.max(element.offsetHeight, element.clientHeight) + 1.5);
    }
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
        if (descriptionRef.current) {
            if (isOverflowY(descriptionRef.current)) {
                setIsElementOverflow(true);
            }
            else {
                setIsElementOverflow(false);
            }
        }
    }, [descriptionRef, item_desc]);
    if (loading) {
        return react__WEBPACK_IMPORTED_MODULE_3__.createElement(_Components_Molecules_ItemCard_Web_index_shimmer_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, { classes: shimmerClass });
    }
    return (react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", { onClick: onClickCallback, className: (0,_external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)('item-card', classes, {
            disabled: current_stock === 0
        }) },
        react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", { className: "item-card__left" },
            food_type ? (react__WEBPACK_IMPORTED_MODULE_3__.createElement(_Atoms_DietIndicator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, { food_type: food_type, classes: "item-card__diet-indicator", showLabel: false })) : null,
            react__WEBPACK_IMPORTED_MODULE_3__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { classes: "item-card__food-title", variant: "bodyTextOneMain" }, item_title),
            item_price || markup_price ? (react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", { className: "item-card__food-price" },
                item_price >= 0 ? (react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", { className: "item-card__food-price--current" },
                    react__WEBPACK_IMPORTED_MODULE_3__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { variant: "bodyTextOne" }, _Utils_currency_util_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"].format */ .Z.format(item_price)))) : null,
                markup_price ? (react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", { className: "item-card__food-price--markup" },
                    react__WEBPACK_IMPORTED_MODULE_3__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { variant: "bodyTextTwo" }, _Utils_currency_util_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"].format */ .Z.format(markup_price)))) : null)) : null,
            react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", { onClick: function (e) {
                    // e.stopPropagation();
                    // setShowMore(!showMore);
                }, ref: descriptionRef, className: (0,_external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)('item-cart__food-description-wrapper ', {
                    'item-cart__food-description-wrapper--unhide-overflow': showMore
                }) },
                react__WEBPACK_IMPORTED_MODULE_3__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { classes: (0,_external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)('item-card__food-description'), variant: "bodyTextTwo" }, item_desc === null || item_desc === void 0 ? void 0 : item_desc.replace(/<\/?[^>]+(>|$)/g, '')),
                isElementOverflow && !showMore ? (react__WEBPACK_IMPORTED_MODULE_3__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { classes: "\n              item-card__food-description--show-toggle\n              item-card__food-description--show-toggle--show-more", variant: "bodyTextTwoMain" }, t('itemCard.showMore'))) : null),
            price_descriptor ? (react__WEBPACK_IMPORTED_MODULE_3__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { classes: "item-card__food-price--descriptor", variant: "bodyTextTwo" }, price_descriptor)) : null),
        react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", { className: "item-card__right" },
            react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", { onClick: onClickCallback },
                react__WEBPACK_IMPORTED_MODULE_3__.createElement(_Atoms_LazyImage_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, { classes: "item-card__food-image", src: image_url, alt: item_title, blur_hash: image_blur_hash, width: isMobile ? 120 : 180, height: isMobile ? 90 : 116, imageComponent: imageComponent, onClick: onClickCallback, priority: loadFirst })),
            isFavouriteEnabled ? (react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", { onClick: function (e) { return e.stopPropagation(); } },
                react__WEBPACK_IMPORTED_MODULE_3__.createElement(_Atoms_FavouriteIndicator_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, { classes: (0,_external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)('item-card__favourite-indicator', {
                        'item-card__favourite-indicator--rtl': isRTL
                    }), isFavourite: isFavourite, toggleFavourite: toggleFavourite, onError: onError }))) : null,
            react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", { onClick: function (e) {
                    e.stopPropagation();
                }, className: "item-card__cart" },
                react__WEBPACK_IMPORTED_MODULE_3__.createElement(_AddToCart_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, { classes: "item-card__add-to-cart", quantity: count || 0, stock: current_stock, loading: loading, variant: "outline", onItemUpdate: function (id, quantity, dir) { return (0,_external_lib_tslib_tslib_es6_js__WEBPACK_IMPORTED_MODULE_12__/* .__awaiter */ .mG)(_this, void 0, void 0, function () {
                        var _a;
                        return (0,_external_lib_tslib_tslib_es6_js__WEBPACK_IMPORTED_MODULE_12__/* .__generator */ .Jh)(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    _a = onItemUpdate;
                                    if (!_a) return [3 /*break*/, 2];
                                    return [4 /*yield*/, onItemUpdate({
                                            quantity: quantity,
                                            id: id,
                                            item_title: item_title,
                                            item_desc: item_desc,
                                            food_type: food_type,
                                            item_price: item_price,
                                            has_options: has_options
                                        }, dir)];
                                case 1:
                                    _a = (_b.sent());
                                    _b.label = 2;
                                case 2:
                                    return [2 /*return*/];
                            }
                        });
                    }); }, itemId: id, onError: onError }),
                has_options && current_stock !== 0 ? (react__WEBPACK_IMPORTED_MODULE_3__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { classes: "item-card__customizable", variant: "bodyTextTwo" }, t('itemCard.customize'))) : null))));
}


//# sourceMappingURL=ItemCard.js.map


/***/ }),

/***/ 37646:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SortSelector; }
});

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(36929);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/Icon.js
var Icon = __webpack_require__(8055);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/assets/icons/sort.icon.js




function SortIcon(props) {
    return (react.createElement(Icon/* default */.Z, (0,tslib_es6/* __assign */.pi)({ svg: function () { return "\n    <svg width=\"24\" height=\"20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path d=\"M5.24997 3.125C5.24997 2.95924 5.17095 2.80027 5.0303 2.68306C4.88965 2.56585 4.69888 2.5 4.49997 2.5C4.30106 2.5 4.11029 2.56585 3.96964 2.68306C3.82899 2.80027 3.74997 2.95924 3.74997 3.125V14.1163L2.03097 12.6825C1.89014 12.5651 1.69913 12.4992 1.49997 12.4992C1.30081 12.4992 1.1098 12.5651 0.968971 12.6825C0.828141 12.7999 0.749023 12.959 0.749023 13.125C0.749023 13.291 0.828141 13.4501 0.968971 13.5675L3.96897 16.0662L3.97947 16.075C4.12028 16.1894 4.30965 16.2528 4.50632 16.2514C4.70299 16.25 4.89103 16.1839 5.02947 16.0675L8.02947 13.5675C8.0992 13.5095 8.15454 13.4406 8.19231 13.3647C8.23009 13.2889 8.24957 13.2076 8.24964 13.1254C8.24971 13.0433 8.23037 12.962 8.19272 12.8861C8.15507 12.8102 8.09985 12.7412 8.03022 12.6831C7.96059 12.625 7.8779 12.5789 7.78688 12.5474C7.69586 12.5159 7.5983 12.4997 7.49975 12.4997C7.40121 12.4996 7.30361 12.5157 7.21254 12.5471C7.12147 12.5785 7.0387 12.6245 6.96897 12.6825L5.24997 14.1163V3.125ZM10.5 4.375C10.5 4.20924 10.579 4.05027 10.7196 3.93306C10.8603 3.81585 11.0511 3.75 11.25 3.75H21.75C21.9489 3.75 22.1396 3.81585 22.2803 3.93306C22.421 4.05027 22.5 4.20924 22.5 4.375C22.5 4.54076 22.421 4.69973 22.2803 4.81694C22.1396 4.93415 21.9489 5 21.75 5H11.25C11.0511 5 10.8603 4.93415 10.7196 4.81694C10.579 4.69973 10.5 4.54076 10.5 4.375ZM11.25 7.5C11.0511 7.5 10.8603 7.56585 10.7196 7.68306C10.579 7.80027 10.5 7.95924 10.5 8.125C10.5 8.29076 10.579 8.44973 10.7196 8.56694C10.8603 8.68415 11.0511 8.75 11.25 8.75H18.75C18.9489 8.75 19.1396 8.68415 19.2803 8.56694C19.421 8.44973 19.5 8.29076 19.5 8.125C19.5 7.95924 19.421 7.80027 19.2803 7.68306C19.1396 7.56585 18.9489 7.5 18.75 7.5H11.25ZM11.25 11.25C11.0511 11.25 10.8603 11.3158 10.7196 11.4331C10.579 11.5503 10.5 11.7092 10.5 11.875C10.5 12.0408 10.579 12.1997 10.7196 12.3169C10.8603 12.4342 11.0511 12.5 11.25 12.5H15.75C15.9489 12.5 16.1396 12.4342 16.2803 12.3169C16.421 12.1997 16.5 12.0408 16.5 11.875C16.5 11.7092 16.421 11.5503 16.2803 11.4331C16.1396 11.3158 15.9489 11.25 15.75 11.25H11.25ZM11.25 15C11.0511 15 10.8603 15.0658 10.7196 15.1831C10.579 15.3003 10.5 15.4592 10.5 15.625C10.5 15.7908 10.579 15.9497 10.7196 16.0669C10.8603 16.1842 11.0511 16.25 11.25 16.25H12.75C12.9489 16.25 13.1396 16.1842 13.2803 16.0669C13.421 15.9497 13.5 15.7908 13.5 15.625C13.5 15.4592 13.421 15.3003 13.2803 15.1831C13.1396 15.0658 12.9489 15 12.75 15H11.25Z\" fill=\"#151515\" stroke=\"#151515\" stroke-width=\"0.6\"/>\n    </svg>\n    "; } }, props)));
}


//# sourceMappingURL=sort.icon.js.map

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/classnames/index.js
var classnames = __webpack_require__(87637);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/Typography.js
var Typography = __webpack_require__(87427);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Molecules/Dialog.js
var Dialog = __webpack_require__(95066);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Utils/isMobile.util.js
var isMobile_util = __webpack_require__(30558);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Components/Cells/ItemListNavigator/Web/desktop-navigator.component.js
var desktop_navigator_component = __webpack_require__(63633);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/Divider.js
var Divider = __webpack_require__(36548);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/Radio.js
var Radio = __webpack_require__(13515);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/@radix-ui/react-radio-group/dist/index.module.js + 3 modules
var index_module = __webpack_require__(72710);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/assets/icons/filter.icon.js
var filter_icon = __webpack_require__(23199);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/Button.js
var Button = __webpack_require__(66693);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/Checkbox.js + 2 modules
var Checkbox = __webpack_require__(59131);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/Label.js
var Label = __webpack_require__(58513);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Molecules/SortSelector.js


















function SortSelector(_a) {
    var _b, _c;
    var classes = _a.classes, _d = _a.sortOptions, sortOptions = _d === void 0 ? [] : _d, type = _a.type, _e = _a.onFilterByCallback, onFilterByCallback = _e === void 0 ? function () { } : _e, _f = _a.onFilterByChange, onFilterByChange = _f === void 0 ? function () { } : _f, onSortByChange = _a.onSortByChange, onFilterClearCallback = _a.onFilterClearCallback, onSortClearCallback = _a.onSortClearCallback, _g = _a.selectedfilterOptions, selectedfilterOptions = _g === void 0 ? [] : _g, selectedSortOptions = _a.selectedSortOptions, _h = _a.filterSortIndicatorData, filterSortIndicatorData = _h === void 0 ? {} : _h;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var _j = (0,react.useState)(false), isOpen = _j[0], setIsOpen = _j[1];
    var _k = (0,react.useState)(0), selectedIndex = _k[0], setSelectedIndex = _k[1];
    var panelRef = react.useRef(null);
    var isMobile = (0,isMobile_util/* useIsMobile */.d)();
    var SortSelectorIcon = function (props) {
        return type === 'radio' ? react.createElement(SortIcon, (0,tslib_es6/* __assign */.pi)({}, props)) : react.createElement(filter_icon/* default */.Z, (0,tslib_es6/* __assign */.pi)({}, props));
    };
    var onOptionSelected = function (event) {
        onSortByChange && onSortByChange(event.target.value);
    };
    var handleApplyClick = (0,react.useCallback)(function () {
        onFilterByCallback &&
            onFilterByCallback(selectedSortOptions, selectedfilterOptions);
        setIsOpen(false);
    }, [selectedSortOptions, selectedfilterOptions]);
    var handleClearClick = function () {
        if (onFilterClearCallback) {
            onFilterClearCallback();
        }
        if (onSortClearCallback) {
            onSortClearCallback();
        }
        setIsOpen(false);
    };
    var onCheckboxOptionSelected = function (checked, id) {
        onFilterByChange && onFilterByChange(checked, id);
    };
    var getCategories = function () {
        return sortOptions === null || sortOptions === void 0 ? void 0 : sortOptions.map(function (option, index) {
            return {
                id: index,
                name: option.group,
                slug: option.group,
                item_count: 0
            };
        });
    };
    var getTitle = function () {
        if (type === 'radio') {
            return t('common.sort');
        }
        else {
            return t('common.filter');
        }
    };
    var getFooter = function () {
        return (react.createElement("div", { className: "sort-selector__dialog-footer" },
            react.createElement(Button/* default */.Z, { type: "primary", fullWidth: true, variant: "link", size: "sm", onClick: handleClearClick }, "Clear"),
            react.createElement(Button/* default */.Z, { type: "primary", fullWidth: true, variant: "solid", size: "sm", onClick: handleApplyClick },
                "Apply ",
                getTitle())));
    };
    var getRadioDefaultValue = function () {
        var defaultVal = '';
        sortOptions === null || sortOptions === void 0 ? void 0 : sortOptions.map(function (option) {
            var _a;
            return (_a = option.options) === null || _a === void 0 ? void 0 : _a.map(function (op) {
                if (op.title === selectedSortOptions) {
                    defaultVal = String(op.id);
                }
            });
        });
        return defaultVal;
    };
    return (react.createElement(react.Fragment, null,
        react.createElement("a", { onClick: function () { return setIsOpen(true); } },
            react.createElement("div", { className: (0,classnames/* default */.Z)('sort-selector', classes), ref: panelRef },
                react.createElement(SortSelectorIcon, { className: (0,classnames/* default */.Z)('sort-selector__icon') }),
                react.createElement(Typography/* default */.Z, { classes: "sort-selector__text", variant: "bodyTextOne", weight: "semibold" }, getTitle()),
                filterSortIndicatorData.showFilterIndicator &&
                    selectedfilterOptions &&
                    selectedfilterOptions.length > 0 && (react.createElement("div", { className: "sort-selector__applied-indicator" })),
                filterSortIndicatorData.showSortIndicator &&
                    selectedSortOptions &&
                    selectedSortOptions.length > 0 && (react.createElement("div", { className: "sort-selector__applied-indicator" })))),
        react.createElement(Dialog/* default */.Z, { classes: "sort-selector__dialog", isOpen: isOpen, footer: getFooter(), onClose: function () { return setIsOpen(false); }, dialogRef: panelRef.current, title: isMobile ? getTitle() : undefined, removeCloseIcon: !isMobile, removeBackdrop: !isMobile, offsetLeft: isMobile ? 0 : -130, offsetTop: isMobile ? 0 : 20 },
            react.createElement("div", { className: "sort-selector__dialog-body" },
                isMobile && (react.createElement("div", { className: "sort-selector__dialog-left" },
                    react.createElement(desktop_navigator_component/* default */.Z, { activeCategoryId: 0, orientation: "left", background: false, activeSubCategoryId: undefined, categories: getCategories(), onCategoryChange: function (index) { return setSelectedIndex(index); } }))),
                react.createElement(Divider/* default */.Z, { variant: "vertical", dividerStyle: "solid", thickness: "thin" }),
                react.createElement("div", { className: "sort-selector__dialog-right" }, type === 'radio' ? (react.createElement("form", { onChange: function (e) { return onOptionSelected(e); } },
                    react.createElement(index_module/* RadioGroup */.Ee, { defaultValue: getRadioDefaultValue(), className: "sort-selector__radio_group" }, (_b = sortOptions === null || sortOptions === void 0 ? void 0 : sortOptions[selectedIndex].options) === null || _b === void 0 ? void 0 : _b.map(function (sortOption, indx) { return (react.createElement("div", { className: "sort-selector__dialog-option", key: sortOption.id },
                        react.createElement(Radio/* default */.Z, { id: String(sortOption.id), value: String(sortOption.id), key: indx }),
                        react.createElement(Label/* default */.Z, { htmlFor: String(sortOption.id) }, sortOption.title === 'Price'
                            ? t('common.priceLowToHigh')
                            : sortOption.title))); })))) : (react.createElement("div", { className: "sort-selector-checkbox__dialog" },
                    react.createElement("div", { className: "sort-checkbox-web" }, sortOptions === null || sortOptions === void 0 ? void 0 : sortOptions.map(function (group, indx) {
                        var _a;
                        return (react.createElement("div", { key: indx },
                            react.createElement(Typography/* default */.Z, { variant: "bodyTextOne", weight: "semibold", classes: "sort-checkbox-web__filter-header" }, group === null || group === void 0 ? void 0 : group.group), (_a = group === null || group === void 0 ? void 0 : group.options) === null || _a === void 0 ? void 0 :
                            _a.map(function (sortOption, indx) { return (react.createElement("div", { className: "sort-selector-checkbox__dialog-option", key: indx },
                                react.createElement(Checkbox/* default */.Z, { id: String(sortOption.id), value: String(sortOption.id), onChange: function (checked) {
                                        return onCheckboxOptionSelected(checked, sortOption.id);
                                    }, checked: selectedfilterOptions.includes(sortOption.id) }),
                                react.createElement(Label/* default */.Z, { htmlFor: String(sortOption.id), classes: "sort-selector__checkbox-label" }, sortOption.title))); })));
                    })),
                    react.createElement("div", { className: "sort-checkbox-mobile" }, (_c = sortOptions === null || sortOptions === void 0 ? void 0 : sortOptions[selectedIndex].options) === null || _c === void 0 ? void 0 : _c.map(function (sortOption, indx) { return (react.createElement("div", { className: "sort-selector-checkbox__dialog-option", key: indx },
                        react.createElement(Checkbox/* default */.Z, { id: String(sortOption.id), value: String(sortOption.id), onChange: function (checked) {
                                return onCheckboxOptionSelected(checked, sortOption.id);
                            }, checked: selectedfilterOptions.includes(sortOption.id) }),
                        react.createElement(Label/* default */.Z, { htmlFor: String(sortOption.id), classes: "sort-selector__checkbox-label" }, sortOption.title))); })))))))));
}


//# sourceMappingURL=SortSelector.js.map


/***/ }),

/***/ 22358:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MenuPanel; }
});

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(36929);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Cells/ItemListNavigator.js + 8 modules
var ItemListNavigator = __webpack_require__(3121);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/Typography.js
var Typography = __webpack_require__(87427);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Components/Organisms/MenuPanel/Web/heading.component.js




function StickyHeading(_a) {
    var category = _a.category, parentCategory = _a.parentCategory, className = _a.className; _a.onCategoryVisible; _a.parentRef; _a.showDescription; _a.showSubCategory;
    var currentRef = (0,react.useRef)(null);
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return (react.createElement("div", { className: className, ref: currentRef },
        react.createElement("div", { className: "menu-panel__sections__header" },
            react.createElement(Typography/* default */.Z, { classes: "menu-panel__sections__header__category", variant: "headingTwo" }, (category === null || category === void 0 ? void 0 : category.name) || (parentCategory === null || parentCategory === void 0 ? void 0 : parentCategory.name)),
            react.createElement(Typography/* default */.Z, { noWrap: true, variant: "bodyTextOne", classes: "menu-panel__sections__item-count" }, t('menu.itemCountPlural', {
                itemCount: (category === null || category === void 0 ? void 0 : category.item_count) || (parentCategory === null || parentCategory === void 0 ? void 0 : parentCategory.item_count) || 0
            })))));
}


//# sourceMappingURL=heading.component.js.map

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Cells/ItemListCart.js + 1 modules
var ItemListCart = __webpack_require__(36780);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/react-virtuoso/dist/index.js



const PUBLISH = 0;
const SUBSCRIBE = 1;
const RESET = 2;
const VALUE = 4;
function compose(a, b) {
  return (arg) => a(b(arg));
}
function thrush(arg, proc) {
  return proc(arg);
}
function curry2to1(proc, arg1) {
  return (arg2) => proc(arg1, arg2);
}
function curry1to0(proc, arg) {
  return () => proc(arg);
}
function tap(arg, proc) {
  proc(arg);
  return arg;
}
function tup(...args) {
  return args;
}
function call(proc) {
  proc();
}
function always(value) {
  return () => value;
}
function joinProc(...procs) {
  return () => {
    procs.map(call);
  };
}
function noop() {
}
function subscribe(emitter, subscription) {
  return emitter(SUBSCRIBE, subscription);
}
function publish(publisher, value) {
  publisher(PUBLISH, value);
}
function dist_reset(emitter) {
  emitter(RESET);
}
function getValue(depot) {
  return depot(VALUE);
}
function connect(emitter, publisher) {
  return subscribe(emitter, curry2to1(publisher, PUBLISH));
}
function handleNext(emitter, subscription) {
  const unsub = emitter(SUBSCRIBE, (value) => {
    unsub();
    subscription(value);
  });
  return unsub;
}
function stream() {
  const subscriptions = [];
  return (action, arg) => {
    switch (action) {
      case RESET:
        subscriptions.splice(0, subscriptions.length);
        return;
      case SUBSCRIBE:
        subscriptions.push(arg);
        return () => {
          const indexOf = subscriptions.indexOf(arg);
          if (indexOf > -1) {
            subscriptions.splice(indexOf, 1);
          }
        };
      case PUBLISH:
        subscriptions.slice().forEach((subscription) => {
          subscription(arg);
        });
        return;
      default:
        throw new Error(`unrecognized action ${action}`);
    }
  };
}
function statefulStream(initial) {
  let value = initial;
  const innerSubject = stream();
  return (action, arg) => {
    switch (action) {
      case SUBSCRIBE:
        const subscription = arg;
        subscription(value);
        break;
      case PUBLISH:
        value = arg;
        break;
      case VALUE:
        return value;
    }
    return innerSubject(action, arg);
  };
}
function eventHandler(emitter) {
  let unsub;
  let currentSubscription;
  const cleanup = () => unsub && unsub();
  return function(action, subscription) {
    switch (action) {
      case SUBSCRIBE:
        if (subscription) {
          if (currentSubscription === subscription) {
            return;
          }
          cleanup();
          currentSubscription = subscription;
          unsub = subscribe(emitter, subscription);
          return unsub;
        } else {
          cleanup();
          return noop;
        }
      case RESET:
        cleanup();
        currentSubscription = null;
        return;
      default:
        throw new Error(`unrecognized action ${action}`);
    }
  };
}
function streamFromEmitter(emitter) {
  return tap(stream(), (stream2) => connect(emitter, stream2));
}
function statefulStreamFromEmitter(emitter, initial) {
  return tap(statefulStream(initial), (stream2) => connect(emitter, stream2));
}
function combineOperators(...operators) {
  return (subscriber) => {
    return operators.reduceRight(thrush, subscriber);
  };
}
function pipe(source, ...operators) {
  const project = combineOperators(...operators);
  return (action, subscription) => {
    switch (action) {
      case SUBSCRIBE:
        return subscribe(source, project(subscription));
      case RESET:
        dist_reset(source);
        return;
    }
  };
}
function defaultComparator(previous, next) {
  return previous === next;
}
function distinctUntilChanged(comparator = defaultComparator) {
  let current;
  return (done) => (next) => {
    if (!comparator(current, next)) {
      current = next;
      done(next);
    }
  };
}
function filter(predicate) {
  return (done) => (value) => {
    predicate(value) && done(value);
  };
}
function map(project) {
  return (done) => compose(done, project);
}
function mapTo(value) {
  return (done) => () => done(value);
}
function scan(scanner, initial) {
  return (done) => (value) => done(initial = scanner(initial, value));
}
function skip(times) {
  return (done) => (value) => {
    times > 0 ? times-- : done(value);
  };
}
function throttleTime(interval) {
  let currentValue;
  let timeout;
  return (done) => (value) => {
    currentValue = value;
    if (timeout) {
      return;
    }
    timeout = setTimeout(() => {
      timeout = void 0;
      done(currentValue);
    }, interval);
  };
}
function debounceTime(interval) {
  let currentValue;
  let timeout;
  return (done) => (value) => {
    currentValue = value;
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => {
      done(currentValue);
    }, interval);
  };
}
function withLatestFrom(...sources) {
  const values = new Array(sources.length);
  let called = 0;
  let pendingCall = null;
  const allCalled = Math.pow(2, sources.length) - 1;
  sources.forEach((source, index) => {
    const bit = Math.pow(2, index);
    subscribe(source, (value) => {
      const prevCalled = called;
      called = called | bit;
      values[index] = value;
      if (prevCalled !== allCalled && called === allCalled && pendingCall) {
        pendingCall();
        pendingCall = null;
      }
    });
  });
  return (done) => (value) => {
    const call2 = () => done([value].concat(values));
    if (called === allCalled) {
      call2();
    } else {
      pendingCall = call2;
    }
  };
}
function merge(...sources) {
  return function(action, subscription) {
    switch (action) {
      case SUBSCRIBE:
        return joinProc(...sources.map((source) => subscribe(source, subscription)));
      case RESET:
        return;
      default:
        throw new Error(`unrecognized action ${action}`);
    }
  };
}
function duc(source, comparator = defaultComparator) {
  return pipe(source, distinctUntilChanged(comparator));
}
function combineLatest(...emitters) {
  const innerSubject = stream();
  const values = new Array(emitters.length);
  let called = 0;
  const allCalled = Math.pow(2, emitters.length) - 1;
  emitters.forEach((source, index) => {
    const bit = Math.pow(2, index);
    subscribe(source, (value) => {
      values[index] = value;
      called = called | bit;
      if (called === allCalled) {
        publish(innerSubject, values);
      }
    });
  });
  return function(action, subscription) {
    switch (action) {
      case SUBSCRIBE:
        if (called === allCalled) {
          subscription(values);
        }
        return subscribe(innerSubject, subscription);
      case RESET:
        return dist_reset(innerSubject);
      default:
        throw new Error(`unrecognized action ${action}`);
    }
  };
}
function system(constructor, dependencies = [], { singleton } = { singleton: true }) {
  return {
    id: id(),
    constructor,
    dependencies,
    singleton
  };
}
const id = () => Symbol();
function init(systemSpec) {
  const singletons = /* @__PURE__ */ new Map();
  const _init = ({ id: id2, constructor, dependencies, singleton }) => {
    if (singleton && singletons.has(id2)) {
      return singletons.get(id2);
    }
    const system2 = constructor(dependencies.map((e) => _init(e)));
    if (singleton) {
      singletons.set(id2, system2);
    }
    return system2;
  };
  return _init(systemSpec);
}
function omit(keys, obj) {
  const result = {};
  const index = {};
  let idx = 0;
  const len = keys.length;
  while (idx < len) {
    index[keys[idx]] = 1;
    idx += 1;
  }
  for (const prop in obj) {
    if (!index.hasOwnProperty(prop)) {
      result[prop] = obj[prop];
    }
  }
  return result;
}
const useIsomorphicLayoutEffect$2 = typeof document !== "undefined" ? react.useLayoutEffect : react.useEffect;
function systemToComponent(systemSpec, map2, Root) {
  const requiredPropNames = Object.keys(map2.required || {});
  const optionalPropNames = Object.keys(map2.optional || {});
  const methodNames = Object.keys(map2.methods || {});
  const eventNames = Object.keys(map2.events || {});
  const Context = react.createContext({});
  function applyPropsToSystem(system2, props) {
    if (system2["propsReady"]) {
      publish(system2["propsReady"], false);
    }
    for (const requiredPropName of requiredPropNames) {
      const stream2 = system2[map2.required[requiredPropName]];
      publish(stream2, props[requiredPropName]);
    }
    for (const optionalPropName of optionalPropNames) {
      if (optionalPropName in props) {
        const stream2 = system2[map2.optional[optionalPropName]];
        publish(stream2, props[optionalPropName]);
      }
    }
    if (system2["propsReady"]) {
      publish(system2["propsReady"], true);
    }
  }
  function buildMethods(system2) {
    return methodNames.reduce((acc, methodName) => {
      acc[methodName] = (value) => {
        const stream2 = system2[map2.methods[methodName]];
        publish(stream2, value);
      };
      return acc;
    }, {});
  }
  function buildEventHandlers(system2) {
    return eventNames.reduce((handlers, eventName) => {
      handlers[eventName] = eventHandler(system2[map2.events[eventName]]);
      return handlers;
    }, {});
  }
  const Component = react.forwardRef((propsWithChildren, ref) => {
    const { children, ...props } = propsWithChildren;
    const [system2] = react.useState(() => {
      return tap(init(systemSpec), (system22) => applyPropsToSystem(system22, props));
    });
    const [handlers] = react.useState(curry1to0(buildEventHandlers, system2));
    useIsomorphicLayoutEffect$2(() => {
      for (const eventName of eventNames) {
        if (eventName in props) {
          subscribe(handlers[eventName], props[eventName]);
        }
      }
      return () => {
        Object.values(handlers).map(dist_reset);
      };
    }, [props, handlers, system2]);
    useIsomorphicLayoutEffect$2(() => {
      applyPropsToSystem(system2, props);
    });
    react.useImperativeHandle(ref, always(buildMethods(system2)));
    return react.createElement(
      Context.Provider,
      { value: system2 },
      Root ? react.createElement(
        Root,
        omit([...requiredPropNames, ...optionalPropNames, ...eventNames], props),
        children
      ) : children
    );
  });
  const usePublisher2 = (key) => {
    return react.useCallback(curry2to1(publish, react.useContext(Context)[key]), [key]);
  };
  const useEmitterValue2 = (key) => {
    const system2 = react.useContext(Context);
    const source = system2[key];
    const [value, setValue] = react.useState(curry1to0(getValue, source));
    useIsomorphicLayoutEffect$2(
      () => subscribe(source, (next) => {
        if (next !== value) {
          setValue(always(next));
        }
      }),
      [source, value]
    );
    return value;
  };
  const useEmitter2 = (key, callback) => {
    const context = react.useContext(Context);
    const source = context[key];
    useIsomorphicLayoutEffect$2(() => subscribe(source, callback), [callback, source]);
  };
  return {
    Component,
    usePublisher: usePublisher2,
    useEmitterValue: useEmitterValue2,
    useEmitter: useEmitter2
  };
}
const useIsomorphicLayoutEffect = typeof document !== "undefined" ? react.useLayoutEffect : react.useEffect;
const useIsomorphicLayoutEffect$1 = useIsomorphicLayoutEffect;
var LogLevel = /* @__PURE__ */ ((LogLevel2) => {
  LogLevel2[LogLevel2["DEBUG"] = 0] = "DEBUG";
  LogLevel2[LogLevel2["INFO"] = 1] = "INFO";
  LogLevel2[LogLevel2["WARN"] = 2] = "WARN";
  LogLevel2[LogLevel2["ERROR"] = 3] = "ERROR";
  return LogLevel2;
})(LogLevel || {});
const CONSOLE_METHOD_MAP = {
  [0]: "debug",
  [1]: "log",
  [2]: "warn",
  [3]: "error"
};
const getGlobalThis = () => typeof globalThis === "undefined" ? window : globalThis;
const loggerSystem = system(
  () => {
    const logLevel = statefulStream(3);
    const log = statefulStream((label, message, level = 1) => {
      const currentLevel = getGlobalThis()["VIRTUOSO_LOG_LEVEL"] || getValue(logLevel);
      if (level >= currentLevel) {
        console[CONSOLE_METHOD_MAP[level]](
          "%creact-virtuoso: %c%s %o",
          "color: #0253b3; font-weight: bold",
          "color: initial",
          label,
          message
        );
      }
    });
    return {
      log,
      logLevel
    };
  },
  [],
  { singleton: true }
);
function useSizeWithElRef(callback, enabled = true) {
  const ref = react.useRef(null);
  let callbackRef = (_el) => {
  };
  if (typeof ResizeObserver !== "undefined") {
    const observer = new ResizeObserver((entries) => {
      const element = entries[0].target;
      if (element.offsetParent !== null) {
        callback(element);
      }
    });
    callbackRef = (elRef) => {
      if (elRef && enabled) {
        observer.observe(elRef);
        ref.current = elRef;
      } else {
        if (ref.current) {
          observer.unobserve(ref.current);
        }
        ref.current = null;
      }
    };
  }
  return { ref, callbackRef };
}
function useSize(callback, enabled = true) {
  return useSizeWithElRef(callback, enabled).callbackRef;
}
function useChangedListContentsSizes(callback, itemSize, enabled, scrollContainerStateCallback, log, gap, customScrollParent) {
  return useSizeWithElRef((el) => {
    const ranges = getChangedChildSizes(el.children, itemSize, "offsetHeight", log);
    let scrollableElement = el.parentElement;
    while (!scrollableElement.dataset["virtuosoScroller"]) {
      scrollableElement = scrollableElement.parentElement;
    }
    const windowScrolling = scrollableElement.lastElementChild.dataset["viewportType"] === "window";
    const scrollTop = customScrollParent ? customScrollParent.scrollTop : windowScrolling ? window.pageYOffset || document.documentElement.scrollTop : scrollableElement.scrollTop;
    const scrollHeight = customScrollParent ? customScrollParent.scrollHeight : windowScrolling ? document.documentElement.scrollHeight : scrollableElement.scrollHeight;
    const viewportHeight = customScrollParent ? customScrollParent.offsetHeight : windowScrolling ? window.innerHeight : scrollableElement.offsetHeight;
    scrollContainerStateCallback({
      scrollTop: Math.max(scrollTop, 0),
      scrollHeight,
      viewportHeight
    });
    gap == null ? void 0 : gap(resolveGapValue$1("row-gap", getComputedStyle(el).rowGap, log));
    if (ranges !== null) {
      callback(ranges);
    }
  }, enabled);
}
function getChangedChildSizes(children, itemSize, field, log) {
  const length = children.length;
  if (length === 0) {
    return null;
  }
  const results = [];
  for (let i = 0; i < length; i++) {
    const child = children.item(i);
    if (!child || child.dataset.index === void 0) {
      continue;
    }
    const index = parseInt(child.dataset.index);
    const knownSize = parseFloat(child.dataset.knownSize);
    const size = itemSize(child, field);
    if (size === 0) {
      log("Zero-sized element, this should not happen", { child }, LogLevel.ERROR);
    }
    if (size === knownSize) {
      continue;
    }
    const lastResult = results[results.length - 1];
    if (results.length === 0 || lastResult.size !== size || lastResult.endIndex !== index - 1) {
      results.push({ startIndex: index, endIndex: index, size });
    } else {
      results[results.length - 1].endIndex++;
    }
  }
  return results;
}
function resolveGapValue$1(property, value, log) {
  if (value !== "normal" && !(value == null ? void 0 : value.endsWith("px"))) {
    log(`${property} was not resolved to pixel value correctly`, value, LogLevel.WARN);
  }
  if (value === "normal") {
    return 0;
  }
  return parseInt(value || "0", 10);
}
function correctItemSize(el, dimension) {
  return Math.round(el.getBoundingClientRect()[dimension]);
}
function approximatelyEqual(num1, num2) {
  return Math.abs(num1 - num2) < 1.01;
}
function useScrollTop(scrollContainerStateCallback, smoothScrollTargetReached, scrollerElement, scrollerRefCallback = noop, customScrollParent) {
  const scrollerRef = react.useRef(null);
  const scrollTopTarget = react.useRef(null);
  const timeoutRef = react.useRef(null);
  const handler = react.useCallback(
    (ev) => {
      const el = ev.target;
      const windowScroll = el === window || el === document;
      const scrollTop = windowScroll ? window.pageYOffset || document.documentElement.scrollTop : el.scrollTop;
      const scrollHeight = windowScroll ? document.documentElement.scrollHeight : el.scrollHeight;
      const viewportHeight = windowScroll ? window.innerHeight : el.offsetHeight;
      const call2 = () => {
        scrollContainerStateCallback({
          scrollTop: Math.max(scrollTop, 0),
          scrollHeight,
          viewportHeight
        });
      };
      if (ev.suppressFlushSync) {
        call2();
      } else {
        react_dom.flushSync(call2);
      }
      if (scrollTopTarget.current !== null) {
        if (scrollTop === scrollTopTarget.current || scrollTop <= 0 || scrollTop === scrollHeight - viewportHeight) {
          scrollTopTarget.current = null;
          smoothScrollTargetReached(true);
          if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
          }
        }
      }
    },
    [scrollContainerStateCallback, smoothScrollTargetReached]
  );
  react.useEffect(() => {
    const localRef = customScrollParent ? customScrollParent : scrollerRef.current;
    scrollerRefCallback(customScrollParent ? customScrollParent : scrollerRef.current);
    handler({ target: localRef, suppressFlushSync: true });
    localRef.addEventListener("scroll", handler, { passive: true });
    return () => {
      scrollerRefCallback(null);
      localRef.removeEventListener("scroll", handler);
    };
  }, [scrollerRef, handler, scrollerElement, scrollerRefCallback, customScrollParent]);
  function scrollToCallback(location) {
    const scrollerElement2 = scrollerRef.current;
    if (!scrollerElement2 || "offsetHeight" in scrollerElement2 && scrollerElement2.offsetHeight === 0) {
      return;
    }
    const isSmooth = location.behavior === "smooth";
    let offsetHeight;
    let scrollHeight;
    let scrollTop;
    if (scrollerElement2 === window) {
      scrollHeight = Math.max(correctItemSize(document.documentElement, "height"), document.documentElement.scrollHeight);
      offsetHeight = window.innerHeight;
      scrollTop = document.documentElement.scrollTop;
    } else {
      scrollHeight = scrollerElement2.scrollHeight;
      offsetHeight = correctItemSize(scrollerElement2, "height");
      scrollTop = scrollerElement2.scrollTop;
    }
    const maxScrollTop = scrollHeight - offsetHeight;
    location.top = Math.ceil(Math.max(Math.min(maxScrollTop, location.top), 0));
    if (approximatelyEqual(offsetHeight, scrollHeight) || location.top === scrollTop) {
      scrollContainerStateCallback({ scrollTop, scrollHeight, viewportHeight: offsetHeight });
      if (isSmooth) {
        smoothScrollTargetReached(true);
      }
      return;
    }
    if (isSmooth) {
      scrollTopTarget.current = location.top;
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => {
        timeoutRef.current = null;
        scrollTopTarget.current = null;
        smoothScrollTargetReached(true);
      }, 1e3);
    } else {
      scrollTopTarget.current = null;
    }
    scrollerElement2.scrollTo(location);
  }
  function scrollByCallback(location) {
    scrollerRef.current.scrollBy(location);
  }
  return { scrollerRef, scrollByCallback, scrollToCallback };
}
const domIOSystem = system(
  () => {
    const scrollContainerState = stream();
    const scrollTop = stream();
    const deviation = statefulStream(0);
    const smoothScrollTargetReached = stream();
    const statefulScrollTop = statefulStream(0);
    const viewportHeight = stream();
    const scrollHeight = stream();
    const headerHeight = statefulStream(0);
    const fixedHeaderHeight = statefulStream(0);
    const fixedFooterHeight = statefulStream(0);
    const footerHeight = statefulStream(0);
    const scrollTo = stream();
    const scrollBy = stream();
    const scrollingInProgress = statefulStream(false);
    connect(
      pipe(
        scrollContainerState,
        map(({ scrollTop: scrollTop2 }) => scrollTop2)
      ),
      scrollTop
    );
    connect(
      pipe(
        scrollContainerState,
        map(({ scrollHeight: scrollHeight2 }) => scrollHeight2)
      ),
      scrollHeight
    );
    connect(scrollTop, statefulScrollTop);
    return {
      scrollContainerState,
      scrollTop,
      viewportHeight,
      headerHeight,
      fixedHeaderHeight,
      fixedFooterHeight,
      footerHeight,
      scrollHeight,
      smoothScrollTargetReached,
      scrollTo,
      scrollBy,
      statefulScrollTop,
      deviation,
      scrollingInProgress
    };
  },
  [],
  { singleton: true }
);
const NIL_NODE = { lvl: 0 };
function newAANode(k, v, lvl, l = NIL_NODE, r = NIL_NODE) {
  return { k, v, lvl, l, r };
}
function empty(node) {
  return node === NIL_NODE;
}
function newTree() {
  return NIL_NODE;
}
function remove(node, key) {
  if (empty(node))
    return NIL_NODE;
  const { k, l, r } = node;
  if (key === k) {
    if (empty(l)) {
      return r;
    } else if (empty(r)) {
      return l;
    } else {
      const [lastKey, lastValue] = last(l);
      return adjust(clone(node, { k: lastKey, v: lastValue, l: deleteLast(l) }));
    }
  } else if (key < k) {
    return adjust(clone(node, { l: remove(l, key) }));
  } else {
    return adjust(clone(node, { r: remove(r, key) }));
  }
}
function findMaxKeyValue(node, value, field = "k") {
  if (empty(node)) {
    return [-Infinity, void 0];
  }
  if (node[field] === value) {
    return [node.k, node.v];
  }
  if (node[field] < value) {
    const r = findMaxKeyValue(node.r, value, field);
    if (r[0] === -Infinity) {
      return [node.k, node.v];
    } else {
      return r;
    }
  }
  return findMaxKeyValue(node.l, value, field);
}
function insert(node, k, v) {
  if (empty(node)) {
    return newAANode(k, v, 1);
  }
  if (k === node.k) {
    return clone(node, { k, v });
  } else if (k < node.k) {
    return rebalance(clone(node, { l: insert(node.l, k, v) }));
  } else {
    return rebalance(clone(node, { r: insert(node.r, k, v) }));
  }
}
function walkWithin(node, start, end) {
  if (empty(node)) {
    return [];
  }
  const { k, v, l, r } = node;
  let result = [];
  if (k > start) {
    result = result.concat(walkWithin(l, start, end));
  }
  if (k >= start && k <= end) {
    result.push({ k, v });
  }
  if (k <= end) {
    result = result.concat(walkWithin(r, start, end));
  }
  return result;
}
function walk(node) {
  if (empty(node)) {
    return [];
  }
  return [...walk(node.l), { k: node.k, v: node.v }, ...walk(node.r)];
}
function last(node) {
  return empty(node.r) ? [node.k, node.v] : last(node.r);
}
function deleteLast(node) {
  return empty(node.r) ? node.l : adjust(clone(node, { r: deleteLast(node.r) }));
}
function clone(node, args) {
  return newAANode(
    args.k !== void 0 ? args.k : node.k,
    args.v !== void 0 ? args.v : node.v,
    args.lvl !== void 0 ? args.lvl : node.lvl,
    args.l !== void 0 ? args.l : node.l,
    args.r !== void 0 ? args.r : node.r
  );
}
function isSingle(node) {
  return empty(node) || node.lvl > node.r.lvl;
}
function rebalance(node) {
  return split(skew(node));
}
function adjust(node) {
  const { l, r, lvl } = node;
  if (r.lvl >= lvl - 1 && l.lvl >= lvl - 1) {
    return node;
  } else if (lvl > r.lvl + 1) {
    if (isSingle(l)) {
      return skew(clone(node, { lvl: lvl - 1 }));
    } else {
      if (!empty(l) && !empty(l.r)) {
        return clone(l.r, {
          l: clone(l, { r: l.r.l }),
          r: clone(node, {
            l: l.r.r,
            lvl: lvl - 1
          }),
          lvl
        });
      } else {
        throw new Error("Unexpected empty nodes");
      }
    }
  } else {
    if (isSingle(node)) {
      return split(clone(node, { lvl: lvl - 1 }));
    } else {
      if (!empty(r) && !empty(r.l)) {
        const rl = r.l;
        const rlvl = isSingle(rl) ? r.lvl - 1 : r.lvl;
        return clone(rl, {
          l: clone(node, {
            r: rl.l,
            lvl: lvl - 1
          }),
          r: split(clone(r, { l: rl.r, lvl: rlvl })),
          lvl: rl.lvl + 1
        });
      } else {
        throw new Error("Unexpected empty nodes");
      }
    }
  }
}
function rangesWithin(node, startIndex, endIndex) {
  if (empty(node)) {
    return [];
  }
  const adjustedStart = findMaxKeyValue(node, startIndex)[0];
  return toRanges(walkWithin(node, adjustedStart, endIndex));
}
function arrayToRanges(items, parser) {
  const length = items.length;
  if (length === 0) {
    return [];
  }
  let { index: start, value } = parser(items[0]);
  const result = [];
  for (let i = 1; i < length; i++) {
    const { index: nextIndex, value: nextValue } = parser(items[i]);
    result.push({ start, end: nextIndex - 1, value });
    start = nextIndex;
    value = nextValue;
  }
  result.push({ start, end: Infinity, value });
  return result;
}
function toRanges(nodes) {
  return arrayToRanges(nodes, ({ k: index, v: value }) => ({ index, value }));
}
function split(node) {
  const { r, lvl } = node;
  return !empty(r) && !empty(r.r) && r.lvl === lvl && r.r.lvl === lvl ? clone(r, { l: clone(node, { r: r.l }), lvl: lvl + 1 }) : node;
}
function skew(node) {
  const { l } = node;
  return !empty(l) && l.lvl === node.lvl ? clone(l, { r: clone(node, { l: l.r }) }) : node;
}
function findIndexOfClosestSmallerOrEqual(items, value, comparator, start = 0) {
  let end = items.length - 1;
  while (start <= end) {
    const index = Math.floor((start + end) / 2);
    const item = items[index];
    const match = comparator(item, value);
    if (match === 0) {
      return index;
    }
    if (match === -1) {
      if (end - start < 2) {
        return index - 1;
      }
      end = index - 1;
    } else {
      if (end === start) {
        return index;
      }
      start = index + 1;
    }
  }
  throw new Error(`Failed binary finding record in array - ${items.join(",")}, searched for ${value}`);
}
function findClosestSmallerOrEqual(items, value, comparator) {
  return items[findIndexOfClosestSmallerOrEqual(items, value, comparator)];
}
function findRange(items, startValue, endValue, comparator) {
  const startIndex = findIndexOfClosestSmallerOrEqual(items, startValue, comparator);
  const endIndex = findIndexOfClosestSmallerOrEqual(items, endValue, comparator, startIndex);
  return items.slice(startIndex, endIndex + 1);
}
const recalcSystem = system(
  () => {
    const recalcInProgress = statefulStream(false);
    return { recalcInProgress };
  },
  [],
  { singleton: true }
);
function rangeIncludes(refRange) {
  const { size, startIndex, endIndex } = refRange;
  return (range) => {
    return range.start === startIndex && (range.end === endIndex || range.end === Infinity) && range.value === size;
  };
}
function insertRanges(sizeTree, ranges) {
  let syncStart = empty(sizeTree) ? 0 : Infinity;
  for (const range of ranges) {
    const { size, startIndex, endIndex } = range;
    syncStart = Math.min(syncStart, startIndex);
    if (empty(sizeTree)) {
      sizeTree = insert(sizeTree, 0, size);
      continue;
    }
    const overlappingRanges = rangesWithin(sizeTree, startIndex - 1, endIndex + 1);
    if (overlappingRanges.some(rangeIncludes(range))) {
      continue;
    }
    let firstPassDone = false;
    let shouldInsert = false;
    for (const { start: rangeStart, end: rangeEnd, value: rangeValue } of overlappingRanges) {
      if (!firstPassDone) {
        shouldInsert = rangeValue !== size;
        firstPassDone = true;
      } else {
        if (endIndex >= rangeStart || size === rangeValue) {
          sizeTree = remove(sizeTree, rangeStart);
        }
      }
      if (rangeEnd > endIndex && endIndex >= rangeStart) {
        if (rangeValue !== size) {
          sizeTree = insert(sizeTree, endIndex + 1, rangeValue);
        }
      }
    }
    if (shouldInsert) {
      sizeTree = insert(sizeTree, startIndex, size);
    }
  }
  return [sizeTree, syncStart];
}
function initialSizeState() {
  return {
    offsetTree: [],
    sizeTree: newTree(),
    groupOffsetTree: newTree(),
    lastIndex: 0,
    lastOffset: 0,
    lastSize: 0,
    groupIndices: []
  };
}
function indexComparator({ index: itemIndex }, index) {
  return index === itemIndex ? 0 : index < itemIndex ? -1 : 1;
}
function offsetComparator({ offset: itemOffset }, offset) {
  return offset === itemOffset ? 0 : offset < itemOffset ? -1 : 1;
}
function offsetPointParser(point) {
  return { index: point.index, value: point };
}
function rangesWithinOffsets(tree, startOffset, endOffset, minStartIndex = 0) {
  if (minStartIndex > 0) {
    startOffset = Math.max(startOffset, findClosestSmallerOrEqual(tree, minStartIndex, indexComparator).offset);
  }
  return arrayToRanges(findRange(tree, startOffset, endOffset, offsetComparator), offsetPointParser);
}
function createOffsetTree(prevOffsetTree, syncStart, sizeTree, gap) {
  let offsetTree = prevOffsetTree;
  let prevIndex = 0;
  let prevSize = 0;
  let prevOffset = 0;
  let startIndex = 0;
  if (syncStart !== 0) {
    startIndex = findIndexOfClosestSmallerOrEqual(offsetTree, syncStart - 1, indexComparator);
    const offsetInfo = offsetTree[startIndex];
    prevOffset = offsetInfo.offset;
    const kv = findMaxKeyValue(sizeTree, syncStart - 1);
    prevIndex = kv[0];
    prevSize = kv[1];
    if (offsetTree.length && offsetTree[startIndex].size === findMaxKeyValue(sizeTree, syncStart)[1]) {
      startIndex -= 1;
    }
    offsetTree = offsetTree.slice(0, startIndex + 1);
  } else {
    offsetTree = [];
  }
  for (const { start: startIndex2, value } of rangesWithin(sizeTree, syncStart, Infinity)) {
    const indexOffset = startIndex2 - prevIndex;
    const aOffset = indexOffset * prevSize + prevOffset + indexOffset * gap;
    offsetTree.push({
      offset: aOffset,
      size: value,
      index: startIndex2
    });
    prevIndex = startIndex2;
    prevOffset = aOffset;
    prevSize = value;
  }
  return {
    offsetTree,
    lastIndex: prevIndex,
    lastOffset: prevOffset,
    lastSize: prevSize
  };
}
function sizeStateReducer(state, [ranges, groupIndices, log, gap]) {
  if (ranges.length > 0) {
    log("received item sizes", ranges, LogLevel.DEBUG);
  }
  const sizeTree = state.sizeTree;
  let newSizeTree = sizeTree;
  let syncStart = 0;
  if (groupIndices.length > 0 && empty(sizeTree) && ranges.length === 2) {
    const groupSize = ranges[0].size;
    const itemSize = ranges[1].size;
    newSizeTree = groupIndices.reduce((tree, groupIndex) => {
      return insert(insert(tree, groupIndex, groupSize), groupIndex + 1, itemSize);
    }, newSizeTree);
  } else {
    [newSizeTree, syncStart] = insertRanges(newSizeTree, ranges);
  }
  if (newSizeTree === sizeTree) {
    return state;
  }
  const { offsetTree: newOffsetTree, lastIndex, lastSize, lastOffset } = createOffsetTree(state.offsetTree, syncStart, newSizeTree, gap);
  return {
    sizeTree: newSizeTree,
    offsetTree: newOffsetTree,
    lastIndex,
    lastOffset,
    lastSize,
    groupOffsetTree: groupIndices.reduce((tree, index) => {
      return insert(tree, index, offsetOf(index, newOffsetTree, gap));
    }, newTree()),
    groupIndices
  };
}
function offsetOf(index, tree, gap) {
  if (tree.length === 0) {
    return 0;
  }
  const { offset, index: startIndex, size } = findClosestSmallerOrEqual(tree, index, indexComparator);
  const itemCount = index - startIndex;
  const top = size * itemCount + (itemCount - 1) * gap + offset;
  return top > 0 ? top + gap : top;
}
function isGroupLocation(location) {
  return typeof location.groupIndex !== "undefined";
}
function originalIndexFromLocation(location, sizes, lastIndex) {
  if (isGroupLocation(location)) {
    return sizes.groupIndices[location.groupIndex] + 1;
  } else {
    const numericIndex = location.index === "LAST" ? lastIndex : location.index;
    let result = originalIndexFromItemIndex(numericIndex, sizes);
    result = Math.max(0, result, Math.min(lastIndex, result));
    return result;
  }
}
function originalIndexFromItemIndex(itemIndex, sizes) {
  if (!hasGroups(sizes)) {
    return itemIndex;
  }
  let groupOffset = 0;
  while (sizes.groupIndices[groupOffset] <= itemIndex + groupOffset) {
    groupOffset++;
  }
  return itemIndex + groupOffset;
}
function hasGroups(sizes) {
  return !empty(sizes.groupOffsetTree);
}
const SIZE_MAP = {
  offsetHeight: "height",
  offsetWidth: "width"
};
const sizeSystem = system(
  ([{ log }, { recalcInProgress }]) => {
    const sizeRanges = stream();
    const totalCount = stream();
    const statefulTotalCount = statefulStreamFromEmitter(totalCount, 0);
    const unshiftWith = stream();
    const shiftWith = stream();
    const firstItemIndex = statefulStream(0);
    const groupIndices = statefulStream([]);
    const fixedItemSize = statefulStream(void 0);
    const defaultItemSize = statefulStream(void 0);
    const itemSize = statefulStream((el, field) => correctItemSize(el, SIZE_MAP[field]));
    const data = statefulStream(void 0);
    const gap = statefulStream(0);
    const initial = initialSizeState();
    const sizes = statefulStreamFromEmitter(
      pipe(sizeRanges, withLatestFrom(groupIndices, log, gap), scan(sizeStateReducer, initial), distinctUntilChanged()),
      initial
    );
    connect(
      pipe(
        groupIndices,
        filter((indexes) => indexes.length > 0),
        withLatestFrom(sizes, gap),
        map(([groupIndices2, sizes2, gap2]) => {
          const groupOffsetTree = groupIndices2.reduce((tree, index, idx) => {
            return insert(tree, index, offsetOf(index, sizes2.offsetTree, gap2) || idx);
          }, newTree());
          return {
            ...sizes2,
            groupIndices: groupIndices2,
            groupOffsetTree
          };
        })
      ),
      sizes
    );
    connect(
      pipe(
        totalCount,
        withLatestFrom(sizes),
        filter(([totalCount2, { lastIndex }]) => {
          return totalCount2 < lastIndex;
        }),
        map(([totalCount2, { lastIndex, lastSize }]) => {
          return [
            {
              startIndex: totalCount2,
              endIndex: lastIndex,
              size: lastSize
            }
          ];
        })
      ),
      sizeRanges
    );
    connect(fixedItemSize, defaultItemSize);
    const trackItemSizes = statefulStreamFromEmitter(
      pipe(
        fixedItemSize,
        map((size) => size === void 0)
      ),
      true
    );
    connect(
      pipe(
        defaultItemSize,
        filter((value) => {
          return value !== void 0 && empty(getValue(sizes).sizeTree);
        }),
        map((size) => [{ startIndex: 0, endIndex: 0, size }])
      ),
      sizeRanges
    );
    const listRefresh = streamFromEmitter(
      pipe(
        sizeRanges,
        withLatestFrom(sizes),
        scan(
          ({ sizes: oldSizes }, [_, newSizes]) => {
            return {
              changed: newSizes !== oldSizes,
              sizes: newSizes
            };
          },
          { changed: false, sizes: initial }
        ),
        map((value) => value.changed)
      )
    );
    subscribe(
      pipe(
        firstItemIndex,
        scan(
          (prev, next) => {
            return { diff: prev.prev - next, prev: next };
          },
          { diff: 0, prev: 0 }
        ),
        map((val) => val.diff)
      ),
      (offset) => {
        if (offset > 0) {
          publish(recalcInProgress, true);
          publish(unshiftWith, offset);
        } else if (offset < 0) {
          publish(shiftWith, offset);
        }
      }
    );
    subscribe(pipe(firstItemIndex, withLatestFrom(log)), ([index, log2]) => {
      if (index < 0) {
        log2(
          "`firstItemIndex` prop should not be set to less than zero. If you don't know the total count, just use a very high value",
          { firstItemIndex },
          LogLevel.ERROR
        );
      }
    });
    const beforeUnshiftWith = streamFromEmitter(unshiftWith);
    connect(
      pipe(
        unshiftWith,
        withLatestFrom(sizes),
        map(([unshiftWith2, sizes2]) => {
          if (sizes2.groupIndices.length > 0) {
            throw new Error("Virtuoso: prepending items does not work with groups");
          }
          return walk(sizes2.sizeTree).reduce(
            (acc, { k: index, v: size }) => {
              return {
                ranges: [...acc.ranges, { startIndex: acc.prevIndex, endIndex: index + unshiftWith2 - 1, size: acc.prevSize }],
                prevIndex: index + unshiftWith2,
                prevSize: size
              };
            },
            {
              ranges: [],
              prevIndex: 0,
              prevSize: sizes2.lastSize
            }
          ).ranges;
        })
      ),
      sizeRanges
    );
    const shiftWithOffset = streamFromEmitter(
      pipe(
        shiftWith,
        withLatestFrom(sizes, gap),
        map(([shiftWith2, { offsetTree }, gap2]) => {
          const newFirstItemIndex = -shiftWith2;
          return offsetOf(newFirstItemIndex, offsetTree, gap2);
        })
      )
    );
    connect(
      pipe(
        shiftWith,
        withLatestFrom(sizes, gap),
        map(([shiftWith2, sizes2, gap2]) => {
          if (sizes2.groupIndices.length > 0) {
            throw new Error("Virtuoso: shifting items does not work with groups");
          }
          const newSizeTree = walk(sizes2.sizeTree).reduce((acc, { k, v }) => {
            return insert(acc, Math.max(0, k + shiftWith2), v);
          }, newTree());
          return {
            ...sizes2,
            sizeTree: newSizeTree,
            ...createOffsetTree(sizes2.offsetTree, 0, newSizeTree, gap2)
          };
        })
      ),
      sizes
    );
    return {
      data,
      totalCount,
      sizeRanges,
      groupIndices,
      defaultItemSize,
      fixedItemSize,
      unshiftWith,
      shiftWith,
      shiftWithOffset,
      beforeUnshiftWith,
      firstItemIndex,
      gap,
      sizes,
      listRefresh,
      statefulTotalCount,
      trackItemSizes,
      itemSize
    };
  },
  tup(loggerSystem, recalcSystem),
  { singleton: true }
);
const SUPPORTS_SCROLL_TO_OPTIONS = typeof document !== "undefined" && "scrollBehavior" in document.documentElement.style;
function normalizeIndexLocation(location) {
  const result = typeof location === "number" ? { index: location } : location;
  if (!result.align) {
    result.align = "start";
  }
  if (!result.behavior || !SUPPORTS_SCROLL_TO_OPTIONS) {
    result.behavior = "auto";
  }
  if (!result.offset) {
    result.offset = 0;
  }
  return result;
}
const scrollToIndexSystem = system(
  ([
    { sizes, totalCount, listRefresh, gap },
    {
      scrollingInProgress,
      viewportHeight,
      scrollTo,
      smoothScrollTargetReached,
      headerHeight,
      footerHeight,
      fixedHeaderHeight,
      fixedFooterHeight
    },
    { log }
  ]) => {
    const scrollToIndex = stream();
    const topListHeight = statefulStream(0);
    let unsubscribeNextListRefresh = null;
    let cleartTimeoutRef = null;
    let unsubscribeListRefresh = null;
    function cleanup() {
      if (unsubscribeNextListRefresh) {
        unsubscribeNextListRefresh();
        unsubscribeNextListRefresh = null;
      }
      if (unsubscribeListRefresh) {
        unsubscribeListRefresh();
        unsubscribeListRefresh = null;
      }
      if (cleartTimeoutRef) {
        clearTimeout(cleartTimeoutRef);
        cleartTimeoutRef = null;
      }
      publish(scrollingInProgress, false);
    }
    connect(
      pipe(
        scrollToIndex,
        withLatestFrom(sizes, viewportHeight, totalCount, topListHeight, headerHeight, footerHeight, log),
        withLatestFrom(gap, fixedHeaderHeight, fixedFooterHeight),
        map(
          ([
            [location, sizes2, viewportHeight2, totalCount2, topListHeight2, headerHeight2, footerHeight2, log2],
            gap2,
            fixedHeaderHeight2,
            fixedFooterHeight2
          ]) => {
            const normalLocation = normalizeIndexLocation(location);
            const { align, behavior, offset } = normalLocation;
            const lastIndex = totalCount2 - 1;
            const index = originalIndexFromLocation(normalLocation, sizes2, lastIndex);
            let top = offsetOf(index, sizes2.offsetTree, gap2) + headerHeight2;
            if (align === "end") {
              top += fixedHeaderHeight2 + findMaxKeyValue(sizes2.sizeTree, index)[1] - viewportHeight2 + fixedFooterHeight2;
              if (index === lastIndex) {
                top += footerHeight2;
              }
            } else if (align === "center") {
              top += (fixedHeaderHeight2 + findMaxKeyValue(sizes2.sizeTree, index)[1] - viewportHeight2 + fixedFooterHeight2) / 2;
            } else {
              top -= topListHeight2;
            }
            if (offset) {
              top += offset;
            }
            const retry = (listChanged) => {
              cleanup();
              if (listChanged) {
                log2("retrying to scroll to", { location }, LogLevel.DEBUG);
                publish(scrollToIndex, location);
              } else {
                log2("list did not change, scroll successful", {}, LogLevel.DEBUG);
              }
            };
            cleanup();
            if (behavior === "smooth") {
              let listChanged = false;
              unsubscribeListRefresh = subscribe(listRefresh, (changed) => {
                listChanged = listChanged || changed;
              });
              unsubscribeNextListRefresh = handleNext(smoothScrollTargetReached, () => {
                retry(listChanged);
              });
            } else {
              unsubscribeNextListRefresh = handleNext(pipe(listRefresh, watchChangesFor(150)), retry);
            }
            cleartTimeoutRef = setTimeout(() => {
              cleanup();
            }, 1200);
            publish(scrollingInProgress, true);
            log2("scrolling from index to", { index, top, behavior }, LogLevel.DEBUG);
            return { top, behavior };
          }
        )
      ),
      scrollTo
    );
    return {
      scrollToIndex,
      topListHeight
    };
  },
  tup(sizeSystem, domIOSystem, loggerSystem),
  { singleton: true }
);
function watchChangesFor(limit) {
  return (done) => {
    const timeoutRef = setTimeout(() => {
      done(false);
    }, limit);
    return (value) => {
      if (value) {
        done(true);
        clearTimeout(timeoutRef);
      }
    };
  };
}
const UP = "up";
const DOWN = "down";
const NONE$1 = "none";
const INITIAL_BOTTOM_STATE = {
  atBottom: false,
  notAtBottomBecause: "NOT_SHOWING_LAST_ITEM",
  state: {
    offsetBottom: 0,
    scrollTop: 0,
    viewportHeight: 0,
    scrollHeight: 0
  }
};
const DEFAULT_AT_TOP_THRESHOLD = 0;
const stateFlagsSystem = system(([{ scrollContainerState, scrollTop, viewportHeight, headerHeight, footerHeight, scrollBy }]) => {
  const isAtBottom = statefulStream(false);
  const isAtTop = statefulStream(true);
  const atBottomStateChange = stream();
  const atTopStateChange = stream();
  const atBottomThreshold = statefulStream(4);
  const atTopThreshold = statefulStream(DEFAULT_AT_TOP_THRESHOLD);
  const isScrolling = statefulStreamFromEmitter(
    pipe(
      merge(pipe(duc(scrollTop), skip(1), mapTo(true)), pipe(duc(scrollTop), skip(1), mapTo(false), debounceTime(100))),
      distinctUntilChanged()
    ),
    false
  );
  const isScrollingBy = statefulStreamFromEmitter(
    pipe(merge(pipe(scrollBy, mapTo(true)), pipe(scrollBy, mapTo(false), debounceTime(200))), distinctUntilChanged()),
    false
  );
  connect(
    pipe(
      combineLatest(duc(scrollTop), duc(atTopThreshold)),
      map(([top, atTopThreshold2]) => top <= atTopThreshold2),
      distinctUntilChanged()
    ),
    isAtTop
  );
  connect(pipe(isAtTop, throttleTime(50)), atTopStateChange);
  const atBottomState = streamFromEmitter(
    pipe(
      combineLatest(scrollContainerState, duc(viewportHeight), duc(headerHeight), duc(footerHeight), duc(atBottomThreshold)),
      scan((current, [{ scrollTop: scrollTop2, scrollHeight }, viewportHeight2, _headerHeight, _footerHeight, atBottomThreshold2]) => {
        const isAtBottom2 = scrollTop2 + viewportHeight2 - scrollHeight > -atBottomThreshold2;
        const state = {
          viewportHeight: viewportHeight2,
          scrollTop: scrollTop2,
          scrollHeight
        };
        if (isAtBottom2) {
          let atBottomBecause;
          let scrollTopDelta;
          if (scrollTop2 > current.state.scrollTop) {
            atBottomBecause = "SCROLLED_DOWN";
            scrollTopDelta = current.state.scrollTop - scrollTop2;
          } else {
            atBottomBecause = "SIZE_DECREASED";
            scrollTopDelta = current.state.scrollTop - scrollTop2 || current.scrollTopDelta;
          }
          return {
            atBottom: true,
            state,
            atBottomBecause,
            scrollTopDelta
          };
        }
        let notAtBottomBecause;
        if (state.scrollHeight > current.state.scrollHeight) {
          notAtBottomBecause = "SIZE_INCREASED";
        } else if (viewportHeight2 < current.state.viewportHeight) {
          notAtBottomBecause = "VIEWPORT_HEIGHT_DECREASING";
        } else if (scrollTop2 < current.state.scrollTop) {
          notAtBottomBecause = "SCROLLING_UPWARDS";
        } else {
          notAtBottomBecause = "NOT_FULLY_SCROLLED_TO_LAST_ITEM_BOTTOM";
        }
        return {
          atBottom: false,
          notAtBottomBecause,
          state
        };
      }, INITIAL_BOTTOM_STATE),
      distinctUntilChanged((prev, next) => {
        return prev && prev.atBottom === next.atBottom;
      })
    )
  );
  const lastJumpDueToItemResize = statefulStreamFromEmitter(
    pipe(
      scrollContainerState,
      scan(
        (current, { scrollTop: scrollTop2, scrollHeight, viewportHeight: viewportHeight2 }) => {
          if (!approximatelyEqual(current.scrollHeight, scrollHeight)) {
            const atBottom = scrollHeight - (scrollTop2 + viewportHeight2) < 1;
            if (current.scrollTop !== scrollTop2 && atBottom) {
              return {
                scrollHeight,
                scrollTop: scrollTop2,
                jump: current.scrollTop - scrollTop2,
                changed: true
              };
            } else {
              return {
                scrollHeight,
                scrollTop: scrollTop2,
                jump: 0,
                changed: true
              };
            }
          } else {
            return {
              scrollTop: scrollTop2,
              scrollHeight,
              jump: 0,
              changed: false
            };
          }
        },
        { scrollHeight: 0, jump: 0, scrollTop: 0, changed: false }
      ),
      filter((value) => value.changed),
      map((value) => value.jump)
    ),
    0
  );
  connect(
    pipe(
      atBottomState,
      map((state) => state.atBottom)
    ),
    isAtBottom
  );
  connect(pipe(isAtBottom, throttleTime(50)), atBottomStateChange);
  const scrollDirection = statefulStream(DOWN);
  connect(
    pipe(
      scrollContainerState,
      map(({ scrollTop: scrollTop2 }) => scrollTop2),
      distinctUntilChanged(),
      scan(
        (acc, scrollTop2) => {
          if (getValue(isScrollingBy)) {
            return { direction: acc.direction, prevScrollTop: scrollTop2 };
          }
          return { direction: scrollTop2 < acc.prevScrollTop ? UP : DOWN, prevScrollTop: scrollTop2 };
        },
        { direction: DOWN, prevScrollTop: 0 }
      ),
      map((value) => value.direction)
    ),
    scrollDirection
  );
  connect(pipe(scrollContainerState, throttleTime(50), mapTo(NONE$1)), scrollDirection);
  const scrollVelocity = statefulStream(0);
  connect(
    pipe(
      isScrolling,
      filter((value) => !value),
      mapTo(0)
    ),
    scrollVelocity
  );
  connect(
    pipe(
      scrollTop,
      throttleTime(100),
      withLatestFrom(isScrolling),
      filter(([_, isScrolling2]) => !!isScrolling2),
      scan(([_, prev], [next]) => [prev, next], [0, 0]),
      map(([prev, next]) => next - prev)
    ),
    scrollVelocity
  );
  return {
    isScrolling,
    isAtTop,
    isAtBottom,
    atBottomState,
    atTopStateChange,
    atBottomStateChange,
    scrollDirection,
    atBottomThreshold,
    atTopThreshold,
    scrollVelocity,
    lastJumpDueToItemResize
  };
}, tup(domIOSystem));
const propsReadySystem = system(
  ([{ log }]) => {
    const propsReady = statefulStream(false);
    const didMount = streamFromEmitter(
      pipe(
        propsReady,
        filter((ready) => ready),
        distinctUntilChanged()
      )
    );
    subscribe(propsReady, (value) => {
      value && getValue(log)("props updated", {}, LogLevel.DEBUG);
    });
    return { propsReady, didMount };
  },
  tup(loggerSystem),
  { singleton: true }
);
function getInitialTopMostItemIndexNumber(location, totalCount) {
  const lastIndex = totalCount - 1;
  const index = typeof location === "number" ? location : location.index === "LAST" ? lastIndex : location.index;
  return index;
}
const initialTopMostItemIndexSystem = system(
  ([{ sizes, listRefresh, defaultItemSize }, { scrollTop }, { scrollToIndex }, { didMount }]) => {
    const scrolledToInitialItem = statefulStream(true);
    const initialTopMostItemIndex = statefulStream(0);
    connect(
      pipe(
        didMount,
        withLatestFrom(initialTopMostItemIndex),
        filter(([_, location]) => !!location),
        mapTo(false)
      ),
      scrolledToInitialItem
    );
    subscribe(
      pipe(
        combineLatest(listRefresh, didMount),
        withLatestFrom(scrolledToInitialItem, sizes, defaultItemSize),
        filter(([[, didMount2], scrolledToInitialItem2, { sizeTree }, defaultItemSize2]) => {
          return didMount2 && (!empty(sizeTree) || defaultItemSize2 !== void 0) && !scrolledToInitialItem2;
        }),
        withLatestFrom(initialTopMostItemIndex)
      ),
      ([, initialTopMostItemIndex2]) => {
        setTimeout(() => {
          handleNext(scrollTop, () => {
            publish(scrolledToInitialItem, true);
          });
          publish(scrollToIndex, initialTopMostItemIndex2);
        });
      }
    );
    return {
      scrolledToInitialItem,
      initialTopMostItemIndex
    };
  },
  tup(sizeSystem, domIOSystem, scrollToIndexSystem, propsReadySystem),
  { singleton: true }
);
function normalizeFollowOutput(follow) {
  if (!follow) {
    return false;
  }
  return follow === "smooth" ? "smooth" : "auto";
}
const behaviorFromFollowOutput = (follow, isAtBottom) => {
  if (typeof follow === "function") {
    return normalizeFollowOutput(follow(isAtBottom));
  }
  return isAtBottom && normalizeFollowOutput(follow);
};
const followOutputSystem = system(
  ([
    { totalCount, listRefresh },
    { isAtBottom, atBottomState },
    { scrollToIndex },
    { scrolledToInitialItem },
    { propsReady, didMount },
    { log },
    { scrollingInProgress }
  ]) => {
    const followOutput = statefulStream(false);
    const autoscrollToBottom = stream();
    let pendingScrollHandle = null;
    function scrollToBottom(followOutputBehavior) {
      publish(scrollToIndex, {
        index: "LAST",
        align: "end",
        behavior: followOutputBehavior
      });
    }
    subscribe(
      pipe(
        combineLatest(pipe(duc(totalCount), skip(1)), didMount),
        withLatestFrom(duc(followOutput), isAtBottom, scrolledToInitialItem, scrollingInProgress),
        map(([[totalCount2, didMount2], followOutput2, isAtBottom2, scrolledToInitialItem2, scrollingInProgress2]) => {
          let shouldFollow = didMount2 && scrolledToInitialItem2;
          let followOutputBehavior = "auto";
          if (shouldFollow) {
            followOutputBehavior = behaviorFromFollowOutput(followOutput2, isAtBottom2 || scrollingInProgress2);
            shouldFollow = shouldFollow && !!followOutputBehavior;
          }
          return { totalCount: totalCount2, shouldFollow, followOutputBehavior };
        }),
        filter(({ shouldFollow }) => shouldFollow)
      ),
      ({ totalCount: totalCount2, followOutputBehavior }) => {
        if (pendingScrollHandle) {
          pendingScrollHandle();
          pendingScrollHandle = null;
        }
        pendingScrollHandle = handleNext(listRefresh, () => {
          getValue(log)("following output to ", { totalCount: totalCount2 }, LogLevel.DEBUG);
          scrollToBottom(followOutputBehavior);
          pendingScrollHandle = null;
        });
      }
    );
    function trapNextSizeIncrease(followOutput2) {
      const cancel = handleNext(atBottomState, (state) => {
        if (followOutput2 && !state.atBottom && state.notAtBottomBecause === "SIZE_INCREASED" && !pendingScrollHandle) {
          getValue(log)("scrolling to bottom due to increased size", {}, LogLevel.DEBUG);
          scrollToBottom("auto");
        }
      });
      setTimeout(cancel, 100);
    }
    subscribe(
      pipe(
        combineLatest(duc(followOutput), totalCount, propsReady),
        filter(([follow, , ready]) => follow && ready),
        scan(
          ({ value }, [, next]) => {
            return { refreshed: value === next, value: next };
          },
          { refreshed: false, value: 0 }
        ),
        filter(({ refreshed }) => refreshed),
        withLatestFrom(followOutput, totalCount)
      ),
      ([, followOutput2]) => {
        trapNextSizeIncrease(followOutput2 !== false);
      }
    );
    subscribe(autoscrollToBottom, () => {
      trapNextSizeIncrease(getValue(followOutput) !== false);
    });
    subscribe(combineLatest(duc(followOutput), atBottomState), ([followOutput2, state]) => {
      if (followOutput2 && !state.atBottom && state.notAtBottomBecause === "VIEWPORT_HEIGHT_DECREASING") {
        scrollToBottom("auto");
      }
    });
    return { followOutput, autoscrollToBottom };
  },
  tup(sizeSystem, stateFlagsSystem, scrollToIndexSystem, initialTopMostItemIndexSystem, propsReadySystem, loggerSystem, domIOSystem)
);
function groupCountsToIndicesAndCount(counts) {
  return counts.reduce(
    (acc, groupCount) => {
      acc.groupIndices.push(acc.totalCount);
      acc.totalCount += groupCount + 1;
      return acc;
    },
    {
      totalCount: 0,
      groupIndices: []
    }
  );
}
const groupedListSystem = system(([{ totalCount, groupIndices, sizes }, { scrollTop, headerHeight }]) => {
  const groupCounts = stream();
  const topItemsIndexes = stream();
  const groupIndicesAndCount = streamFromEmitter(pipe(groupCounts, map(groupCountsToIndicesAndCount)));
  connect(
    pipe(
      groupIndicesAndCount,
      map((value) => value.totalCount)
    ),
    totalCount
  );
  connect(
    pipe(
      groupIndicesAndCount,
      map((value) => value.groupIndices)
    ),
    groupIndices
  );
  connect(
    pipe(
      combineLatest(scrollTop, sizes, headerHeight),
      filter(([_, sizes2]) => hasGroups(sizes2)),
      map(([scrollTop2, state, headerHeight2]) => findMaxKeyValue(state.groupOffsetTree, Math.max(scrollTop2 - headerHeight2, 0), "v")[0]),
      distinctUntilChanged(),
      map((index) => [index])
    ),
    topItemsIndexes
  );
  return { groupCounts, topItemsIndexes };
}, tup(sizeSystem, domIOSystem));
function tupleComparator(prev, current) {
  return !!(prev && prev[0] === current[0] && prev[1] === current[1]);
}
function rangeComparator(prev, next) {
  return !!(prev && prev.startIndex === next.startIndex && prev.endIndex === next.endIndex);
}
const TOP = "top";
const BOTTOM = "bottom";
const NONE = "none";
function getOverscan(overscan, end, direction) {
  if (typeof overscan === "number") {
    return direction === UP && end === TOP || direction === DOWN && end === BOTTOM ? overscan : 0;
  } else {
    if (direction === UP) {
      return end === TOP ? overscan.main : overscan.reverse;
    } else {
      return end === BOTTOM ? overscan.main : overscan.reverse;
    }
  }
}
function getViewportIncrease(value, end) {
  return typeof value === "number" ? value : value[end] || 0;
}
const sizeRangeSystem = system(
  ([{ scrollTop, viewportHeight, deviation, headerHeight, fixedHeaderHeight }]) => {
    const listBoundary = stream();
    const topListHeight = statefulStream(0);
    const increaseViewportBy = statefulStream(0);
    const overscan = statefulStream(0);
    const visibleRange = statefulStreamFromEmitter(
      pipe(
        combineLatest(
          duc(scrollTop),
          duc(viewportHeight),
          duc(headerHeight),
          duc(listBoundary, tupleComparator),
          duc(overscan),
          duc(topListHeight),
          duc(fixedHeaderHeight),
          duc(deviation),
          duc(increaseViewportBy)
        ),
        map(
          ([
            scrollTop2,
            viewportHeight2,
            headerHeight2,
            [listTop, listBottom],
            overscan2,
            topListHeight2,
            fixedHeaderHeight2,
            deviation2,
            increaseViewportBy2
          ]) => {
            const top = scrollTop2 - deviation2;
            const stickyHeaderHeight = topListHeight2 + fixedHeaderHeight2;
            const headerVisible = Math.max(headerHeight2 - top, 0);
            let direction = NONE;
            const topViewportAddition = getViewportIncrease(increaseViewportBy2, TOP);
            const bottomViewportAddition = getViewportIncrease(increaseViewportBy2, BOTTOM);
            listTop -= deviation2;
            listTop += headerHeight2 + fixedHeaderHeight2;
            listBottom += headerHeight2 + fixedHeaderHeight2;
            listBottom -= deviation2;
            if (listTop > scrollTop2 + stickyHeaderHeight - topViewportAddition) {
              direction = UP;
            }
            if (listBottom < scrollTop2 - headerVisible + viewportHeight2 + bottomViewportAddition) {
              direction = DOWN;
            }
            if (direction !== NONE) {
              return [
                Math.max(top - headerHeight2 - getOverscan(overscan2, TOP, direction) - topViewportAddition, 0),
                top - headerVisible - fixedHeaderHeight2 + viewportHeight2 + getOverscan(overscan2, BOTTOM, direction) + bottomViewportAddition
              ];
            }
            return null;
          }
        ),
        filter((value) => value != null),
        distinctUntilChanged(tupleComparator)
      ),
      [0, 0]
    );
    return {
      listBoundary,
      overscan,
      topListHeight,
      increaseViewportBy,
      visibleRange
    };
  },
  tup(domIOSystem),
  { singleton: true }
);
function probeItemSet(index, sizes, data) {
  if (hasGroups(sizes)) {
    const itemIndex = originalIndexFromItemIndex(index, sizes);
    const groupIndex = findMaxKeyValue(sizes.groupOffsetTree, itemIndex)[0];
    return [
      { index: groupIndex, size: 0, offset: 0 },
      { index: itemIndex, size: 0, offset: 0, data: data && data[0] }
    ];
  }
  return [{ index, size: 0, offset: 0, data: data && data[0] }];
}
const EMPTY_LIST_STATE = {
  items: [],
  topItems: [],
  offsetTop: 0,
  offsetBottom: 0,
  top: 0,
  bottom: 0,
  topListHeight: 0,
  totalCount: 0,
  firstItemIndex: 0
};
function transposeItems(items, sizes, firstItemIndex) {
  if (items.length === 0) {
    return [];
  }
  if (!hasGroups(sizes)) {
    return items.map((item) => ({ ...item, index: item.index + firstItemIndex, originalIndex: item.index }));
  }
  const startIndex = items[0].index;
  const endIndex = items[items.length - 1].index;
  const transposedItems = [];
  const groupRanges = rangesWithin(sizes.groupOffsetTree, startIndex, endIndex);
  let currentRange = void 0;
  let currentGroupIndex = 0;
  for (const item of items) {
    if (!currentRange || currentRange.end < item.index) {
      currentRange = groupRanges.shift();
      currentGroupIndex = sizes.groupIndices.indexOf(currentRange.start);
    }
    let transposedItem;
    if (item.index === currentRange.start) {
      transposedItem = {
        type: "group",
        index: currentGroupIndex
      };
    } else {
      transposedItem = {
        index: item.index - (currentGroupIndex + 1) + firstItemIndex,
        groupIndex: currentGroupIndex
      };
    }
    transposedItems.push({
      ...transposedItem,
      size: item.size,
      offset: item.offset,
      originalIndex: item.index,
      data: item.data
    });
  }
  return transposedItems;
}
function buildListState(items, topItems, totalCount, gap, sizes, firstItemIndex) {
  const { lastSize, lastOffset, lastIndex } = sizes;
  let offsetTop = 0;
  let bottom = 0;
  if (items.length > 0) {
    offsetTop = items[0].offset;
    const lastItem = items[items.length - 1];
    bottom = lastItem.offset + lastItem.size;
  }
  const itemCount = totalCount - lastIndex;
  const total = lastOffset + itemCount * lastSize + (itemCount - 1) * gap;
  const top = offsetTop;
  const offsetBottom = total - bottom;
  return {
    items: transposeItems(items, sizes, firstItemIndex),
    topItems: transposeItems(topItems, sizes, firstItemIndex),
    topListHeight: topItems.reduce((height, item) => item.size + height, 0),
    offsetTop,
    offsetBottom,
    top,
    bottom,
    totalCount,
    firstItemIndex
  };
}
const listStateSystem = system(
  ([
    { sizes, totalCount, data, firstItemIndex, gap },
    groupedListSystem2,
    { visibleRange, listBoundary, topListHeight: rangeTopListHeight },
    { scrolledToInitialItem, initialTopMostItemIndex },
    { topListHeight },
    stateFlags,
    { didMount },
    { recalcInProgress }
  ]) => {
    const topItemsIndexes = statefulStream([]);
    const itemsRendered = stream();
    connect(groupedListSystem2.topItemsIndexes, topItemsIndexes);
    const listState = statefulStreamFromEmitter(
      pipe(
        combineLatest(
          didMount,
          recalcInProgress,
          duc(visibleRange, tupleComparator),
          duc(totalCount),
          duc(sizes),
          duc(initialTopMostItemIndex),
          scrolledToInitialItem,
          duc(topItemsIndexes),
          duc(firstItemIndex),
          duc(gap),
          data
        ),
        filter(([mount, recalcInProgress2, , totalCount2, , , , , , , data2]) => {
          const dataChangeInProgress = data2 && data2.length !== totalCount2;
          return mount && !recalcInProgress2 && !dataChangeInProgress;
        }),
        map(
          ([
            ,
            ,
            [startOffset, endOffset],
            totalCount2,
            sizes2,
            initialTopMostItemIndex2,
            scrolledToInitialItem2,
            topItemsIndexes2,
            firstItemIndex2,
            gap2,
            data2
          ]) => {
            const sizesValue = sizes2;
            const { sizeTree, offsetTree } = sizesValue;
            if (totalCount2 === 0 || startOffset === 0 && endOffset === 0) {
              return { ...EMPTY_LIST_STATE, totalCount: totalCount2 };
            }
            if (empty(sizeTree)) {
              return buildListState(
                probeItemSet(getInitialTopMostItemIndexNumber(initialTopMostItemIndex2, totalCount2), sizesValue, data2),
                [],
                totalCount2,
                gap2,
                sizesValue,
                firstItemIndex2
              );
            }
            const topItems = [];
            if (topItemsIndexes2.length > 0) {
              const startIndex = topItemsIndexes2[0];
              const endIndex = topItemsIndexes2[topItemsIndexes2.length - 1];
              let offset = 0;
              for (const range of rangesWithin(sizeTree, startIndex, endIndex)) {
                const size = range.value;
                const rangeStartIndex = Math.max(range.start, startIndex);
                const rangeEndIndex = Math.min(range.end, endIndex);
                for (let i = rangeStartIndex; i <= rangeEndIndex; i++) {
                  topItems.push({ index: i, size, offset, data: data2 && data2[i] });
                  offset += size;
                }
              }
            }
            if (!scrolledToInitialItem2) {
              return buildListState([], topItems, totalCount2, gap2, sizesValue, firstItemIndex2);
            }
            const minStartIndex = topItemsIndexes2.length > 0 ? topItemsIndexes2[topItemsIndexes2.length - 1] + 1 : 0;
            const offsetPointRanges = rangesWithinOffsets(offsetTree, startOffset, endOffset, minStartIndex);
            if (offsetPointRanges.length === 0) {
              return null;
            }
            const maxIndex = totalCount2 - 1;
            const items = tap([], (result) => {
              for (const range of offsetPointRanges) {
                const point = range.value;
                let offset = point.offset;
                let rangeStartIndex = range.start;
                const size = point.size;
                if (point.offset < startOffset) {
                  rangeStartIndex += Math.floor((startOffset - point.offset + gap2) / (size + gap2));
                  const itemCount = rangeStartIndex - range.start;
                  offset += itemCount * size + itemCount * gap2;
                }
                if (rangeStartIndex < minStartIndex) {
                  offset += (minStartIndex - rangeStartIndex) * size;
                  rangeStartIndex = minStartIndex;
                }
                const endIndex = Math.min(range.end, maxIndex);
                for (let i = rangeStartIndex; i <= endIndex; i++) {
                  if (offset >= endOffset) {
                    break;
                  }
                  result.push({ index: i, size, offset, data: data2 && data2[i] });
                  offset += size + gap2;
                }
              }
            });
            return buildListState(items, topItems, totalCount2, gap2, sizesValue, firstItemIndex2);
          }
        ),
        filter((value) => value !== null),
        distinctUntilChanged()
      ),
      EMPTY_LIST_STATE
    );
    connect(
      pipe(
        data,
        filter((data2) => data2 !== void 0),
        map((data2) => data2 == null ? void 0 : data2.length)
      ),
      totalCount
    );
    connect(
      pipe(
        listState,
        map((value) => value.topListHeight)
      ),
      topListHeight
    );
    connect(topListHeight, rangeTopListHeight);
    connect(
      pipe(
        listState,
        map((state) => [state.top, state.bottom])
      ),
      listBoundary
    );
    connect(
      pipe(
        listState,
        map((state) => state.items)
      ),
      itemsRendered
    );
    const endReached = streamFromEmitter(
      pipe(
        listState,
        filter(({ items }) => items.length > 0),
        withLatestFrom(totalCount, data),
        filter(([{ items }, totalCount2]) => items[items.length - 1].originalIndex === totalCount2 - 1),
        map(([, totalCount2, data2]) => [totalCount2 - 1, data2]),
        distinctUntilChanged(tupleComparator),
        map(([count]) => count)
      )
    );
    const startReached = streamFromEmitter(
      pipe(
        listState,
        throttleTime(200),
        filter(({ items, topItems }) => {
          return items.length > 0 && items[0].originalIndex === topItems.length;
        }),
        map(({ items }) => items[0].index),
        distinctUntilChanged()
      )
    );
    const rangeChanged = streamFromEmitter(
      pipe(
        listState,
        filter(({ items }) => items.length > 0),
        map(({ items }) => {
          let startIndex = 0;
          let endIndex = items.length - 1;
          while (items[startIndex].type === "group" && startIndex < endIndex) {
            startIndex++;
          }
          while (items[endIndex].type === "group" && endIndex > startIndex) {
            endIndex--;
          }
          return {
            startIndex: items[startIndex].index,
            endIndex: items[endIndex].index
          };
        }),
        distinctUntilChanged(rangeComparator)
      )
    );
    return { listState, topItemsIndexes, endReached, startReached, rangeChanged, itemsRendered, ...stateFlags };
  },
  tup(
    sizeSystem,
    groupedListSystem,
    sizeRangeSystem,
    initialTopMostItemIndexSystem,
    scrollToIndexSystem,
    stateFlagsSystem,
    propsReadySystem,
    recalcSystem
  ),
  { singleton: true }
);
const initialItemCountSystem = system(
  ([{ sizes, firstItemIndex, data, gap }, { listState }, { didMount }]) => {
    const initialItemCount = statefulStream(0);
    connect(
      pipe(
        didMount,
        withLatestFrom(initialItemCount),
        filter(([, count]) => count !== 0),
        withLatestFrom(sizes, firstItemIndex, gap, data),
        map(([[, count], sizes2, firstItemIndex2, gap2, data2 = []]) => {
          let includedGroupsCount = 0;
          if (sizes2.groupIndices.length > 0) {
            for (const index of sizes2.groupIndices) {
              if (index - includedGroupsCount >= count) {
                break;
              }
              includedGroupsCount++;
            }
          }
          const adjustedCount = count + includedGroupsCount;
          const items = Array.from({ length: adjustedCount }).map((_, index) => ({ index, size: 0, offset: 0, data: data2[index] }));
          return buildListState(items, [], adjustedCount, gap2, sizes2, firstItemIndex2);
        })
      ),
      listState
    );
    return { initialItemCount };
  },
  tup(sizeSystem, listStateSystem, propsReadySystem),
  { singleton: true }
);
const scrollSeekSystem = system(
  ([{ scrollVelocity }]) => {
    const isSeeking = statefulStream(false);
    const rangeChanged = stream();
    const scrollSeekConfiguration = statefulStream(false);
    connect(
      pipe(
        scrollVelocity,
        withLatestFrom(scrollSeekConfiguration, isSeeking, rangeChanged),
        filter(([_, config]) => !!config),
        map(([speed, config, isSeeking2, range]) => {
          const { exit, enter } = config;
          if (isSeeking2) {
            if (exit(speed, range)) {
              return false;
            }
          } else {
            if (enter(speed, range)) {
              return true;
            }
          }
          return isSeeking2;
        }),
        distinctUntilChanged()
      ),
      isSeeking
    );
    subscribe(
      pipe(combineLatest(isSeeking, scrollVelocity, rangeChanged), withLatestFrom(scrollSeekConfiguration)),
      ([[isSeeking2, velocity, range], config]) => isSeeking2 && config && config.change && config.change(velocity, range)
    );
    return { isSeeking, scrollSeekConfiguration, scrollVelocity, scrollSeekRangeChanged: rangeChanged };
  },
  tup(stateFlagsSystem),
  { singleton: true }
);
const topItemCountSystem = system(([{ topItemsIndexes }]) => {
  const topItemCount = statefulStream(0);
  connect(
    pipe(
      topItemCount,
      filter((length) => length > 0),
      map((length) => Array.from({ length }).map((_, index) => index))
    ),
    topItemsIndexes
  );
  return { topItemCount };
}, tup(listStateSystem));
const totalListHeightSystem = system(
  ([{ footerHeight, headerHeight, fixedHeaderHeight, fixedFooterHeight }, { listState }]) => {
    const totalListHeightChanged = stream();
    const totalListHeight = statefulStreamFromEmitter(
      pipe(
        combineLatest(footerHeight, fixedFooterHeight, headerHeight, fixedHeaderHeight, listState),
        map(([footerHeight2, fixedFooterHeight2, headerHeight2, fixedHeaderHeight2, listState2]) => {
          return footerHeight2 + fixedFooterHeight2 + headerHeight2 + fixedHeaderHeight2 + listState2.offsetBottom + listState2.bottom;
        })
      ),
      0
    );
    connect(duc(totalListHeight), totalListHeightChanged);
    return { totalListHeight, totalListHeightChanged };
  },
  tup(domIOSystem, listStateSystem),
  { singleton: true }
);
function simpleMemoize(func) {
  let called = false;
  let result;
  return () => {
    if (!called) {
      called = true;
      result = func();
    }
    return result;
  };
}
const isMobileSafari = simpleMemoize(() => {
  return /iP(ad|od|hone)/i.test(navigator.userAgent) && /WebKit/i.test(navigator.userAgent);
});
const upwardScrollFixSystem = system(
  ([
    { scrollBy, scrollTop, deviation, scrollingInProgress },
    { isScrolling, isAtBottom, scrollDirection, lastJumpDueToItemResize },
    { listState },
    { beforeUnshiftWith, shiftWithOffset, sizes, gap },
    { log },
    { recalcInProgress }
  ]) => {
    const deviationOffset = streamFromEmitter(
      pipe(
        listState,
        withLatestFrom(lastJumpDueToItemResize),
        scan(
          ([, prevItems, prevTotalCount, prevTotalHeight], [{ items, totalCount, bottom, offsetBottom }, lastJumpDueToItemResize2]) => {
            const totalHeight = bottom + offsetBottom;
            let newDev = 0;
            if (prevTotalCount === totalCount) {
              if (prevItems.length > 0 && items.length > 0) {
                const atStart = items[0].originalIndex === 0 && prevItems[0].originalIndex === 0;
                if (!atStart) {
                  newDev = totalHeight - prevTotalHeight;
                  if (newDev !== 0) {
                    newDev += lastJumpDueToItemResize2;
                  }
                }
              }
            }
            return [newDev, items, totalCount, totalHeight];
          },
          [0, [], 0, 0]
        ),
        filter(([amount]) => amount !== 0),
        withLatestFrom(scrollTop, scrollDirection, scrollingInProgress, isAtBottom, log),
        filter(([, scrollTop2, scrollDirection2, scrollingInProgress2]) => {
          return !scrollingInProgress2 && scrollTop2 !== 0 && scrollDirection2 === UP;
        }),
        map(([[amount], , , , , log2]) => {
          log2("Upward scrolling compensation", { amount }, LogLevel.DEBUG);
          return amount;
        })
      )
    );
    function scrollByWith(offset) {
      if (offset > 0) {
        publish(scrollBy, { top: -offset, behavior: "auto" });
        publish(deviation, 0);
      } else {
        publish(deviation, 0);
        publish(scrollBy, { top: -offset, behavior: "auto" });
      }
    }
    subscribe(pipe(deviationOffset, withLatestFrom(deviation, isScrolling)), ([offset, deviationAmount, isScrolling2]) => {
      if (isScrolling2 && isMobileSafari()) {
        publish(deviation, deviationAmount - offset);
      } else {
        scrollByWith(-offset);
      }
    });
    subscribe(
      pipe(
        combineLatest(statefulStreamFromEmitter(isScrolling, false), deviation, recalcInProgress),
        filter(([is, deviation2, recalc]) => !is && !recalc && deviation2 !== 0),
        map(([_, deviation2]) => deviation2),
        throttleTime(1)
      ),
      scrollByWith
    );
    connect(
      pipe(
        shiftWithOffset,
        map((offset) => {
          return { top: -offset };
        })
      ),
      scrollBy
    );
    subscribe(
      pipe(
        beforeUnshiftWith,
        withLatestFrom(sizes, gap),
        map(([offset, { lastSize }, gap2]) => offset * lastSize + offset * gap2)
      ),
      (offset) => {
        publish(deviation, offset);
        requestAnimationFrame(() => {
          publish(scrollBy, { top: offset });
          requestAnimationFrame(() => {
            publish(deviation, 0);
            publish(recalcInProgress, false);
          });
        });
      }
    );
    return { deviation };
  },
  tup(domIOSystem, stateFlagsSystem, listStateSystem, sizeSystem, loggerSystem, recalcSystem)
);
const initialScrollTopSystem = system(
  ([{ totalListHeight }, { didMount }, { scrollTo }]) => {
    const initialScrollTop = statefulStream(0);
    subscribe(
      pipe(
        didMount,
        withLatestFrom(initialScrollTop),
        filter(([, offset]) => offset !== 0),
        map(([, offset]) => ({ top: offset }))
      ),
      (location) => {
        handleNext(
          pipe(
            totalListHeight,
            filter((val) => val !== 0)
          ),
          () => {
            setTimeout(() => {
              publish(scrollTo, location);
            });
          }
        );
      }
    );
    return {
      initialScrollTop
    };
  },
  tup(totalListHeightSystem, propsReadySystem, domIOSystem),
  { singleton: true }
);
const alignToBottomSystem = system(
  ([{ viewportHeight }, { totalListHeight }]) => {
    const alignToBottom = statefulStream(false);
    const paddingTopAddition = statefulStreamFromEmitter(
      pipe(
        combineLatest(alignToBottom, viewportHeight, totalListHeight),
        filter(([enabled]) => enabled),
        map(([, viewportHeight2, totalListHeight2]) => {
          return Math.max(0, viewportHeight2 - totalListHeight2);
        }),
        distinctUntilChanged()
      ),
      0
    );
    return { alignToBottom, paddingTopAddition };
  },
  tup(domIOSystem, totalListHeightSystem),
  { singleton: true }
);
const windowScrollerSystem = system(([{ scrollTo, scrollContainerState }]) => {
  const windowScrollContainerState = stream();
  const windowViewportRect = stream();
  const windowScrollTo = stream();
  const useWindowScroll = statefulStream(false);
  const customScrollParent = statefulStream(void 0);
  connect(
    pipe(
      combineLatest(windowScrollContainerState, windowViewportRect),
      map(([{ viewportHeight, scrollTop: windowScrollTop, scrollHeight }, { offsetTop }]) => {
        return {
          scrollTop: Math.max(0, windowScrollTop - offsetTop),
          scrollHeight,
          viewportHeight
        };
      })
    ),
    scrollContainerState
  );
  connect(
    pipe(
      scrollTo,
      withLatestFrom(windowViewportRect),
      map(([scrollTo2, { offsetTop }]) => {
        return {
          ...scrollTo2,
          top: scrollTo2.top + offsetTop
        };
      })
    ),
    windowScrollTo
  );
  return {
    useWindowScroll,
    customScrollParent,
    windowScrollContainerState,
    windowViewportRect,
    windowScrollTo
  };
}, tup(domIOSystem));
const defaultCalculateViewLocation = ({
  itemTop: itemTop2,
  itemBottom,
  viewportTop,
  viewportBottom,
  locationParams: { behavior, align, ...rest }
}) => {
  if (itemTop2 < viewportTop) {
    return { ...rest, behavior, align: align || "start" };
  }
  if (itemBottom > viewportBottom) {
    return { ...rest, behavior, align: align || "end" };
  }
  return null;
};
const scrollIntoViewSystem = system(
  ([
    { sizes, totalCount, gap },
    { scrollTop, viewportHeight, headerHeight, fixedHeaderHeight, fixedFooterHeight, scrollingInProgress },
    { scrollToIndex }
  ]) => {
    const scrollIntoView = stream();
    connect(
      pipe(
        scrollIntoView,
        withLatestFrom(sizes, viewportHeight, totalCount, headerHeight, fixedHeaderHeight, fixedFooterHeight, scrollTop),
        withLatestFrom(gap),
        map(([[viewLocation, sizes2, viewportHeight2, totalCount2, headerHeight2, fixedHeaderHeight2, fixedFooterHeight2, scrollTop2], gap2]) => {
          const { done, behavior, align, calculateViewLocation = defaultCalculateViewLocation, ...rest } = viewLocation;
          const actualIndex = originalIndexFromLocation(viewLocation, sizes2, totalCount2 - 1);
          const itemTop2 = offsetOf(actualIndex, sizes2.offsetTree, gap2) + headerHeight2 + fixedHeaderHeight2;
          const itemBottom = itemTop2 + findMaxKeyValue(sizes2.sizeTree, actualIndex)[1];
          const viewportTop = scrollTop2 + fixedHeaderHeight2;
          const viewportBottom = scrollTop2 + viewportHeight2 - fixedFooterHeight2;
          const location = calculateViewLocation({
            itemTop: itemTop2,
            itemBottom,
            viewportTop,
            viewportBottom,
            locationParams: { behavior, align, ...rest }
          });
          if (location) {
            done && handleNext(
              pipe(
                scrollingInProgress,
                filter((value) => value === false),
                skip(getValue(scrollingInProgress) ? 1 : 2)
              ),
              done
            );
          } else {
            done && done();
          }
          return location;
        }),
        filter((value) => value !== null)
      ),
      scrollToIndex
    );
    return {
      scrollIntoView
    };
  },
  tup(sizeSystem, domIOSystem, scrollToIndexSystem, listStateSystem, loggerSystem),
  { singleton: true }
);
const featureGroup1System = system(
  ([
    sizeRange,
    initialItemCount,
    propsReady,
    scrollSeek,
    totalListHeight,
    initialScrollTopSystem2,
    alignToBottom,
    windowScroller,
    scrollIntoView
  ]) => {
    return {
      ...sizeRange,
      ...initialItemCount,
      ...propsReady,
      ...scrollSeek,
      ...totalListHeight,
      ...initialScrollTopSystem2,
      ...alignToBottom,
      ...windowScroller,
      ...scrollIntoView
    };
  },
  tup(
    sizeRangeSystem,
    initialItemCountSystem,
    propsReadySystem,
    scrollSeekSystem,
    totalListHeightSystem,
    initialScrollTopSystem,
    alignToBottomSystem,
    windowScrollerSystem,
    scrollIntoViewSystem
  )
);
const listSystem = system(
  ([
    {
      totalCount,
      sizeRanges,
      fixedItemSize,
      defaultItemSize,
      trackItemSizes,
      itemSize,
      data,
      firstItemIndex,
      groupIndices,
      statefulTotalCount,
      gap
    },
    { initialTopMostItemIndex, scrolledToInitialItem },
    domIO,
    followOutput,
    { listState, topItemsIndexes, ...flags },
    { scrollToIndex },
    _,
    { topItemCount },
    { groupCounts },
    featureGroup1,
    log
  ]) => {
    connect(flags.rangeChanged, featureGroup1.scrollSeekRangeChanged);
    connect(
      pipe(
        featureGroup1.windowViewportRect,
        map((value) => value.visibleHeight)
      ),
      domIO.viewportHeight
    );
    return {
      totalCount,
      data,
      firstItemIndex,
      sizeRanges,
      initialTopMostItemIndex,
      scrolledToInitialItem,
      topItemsIndexes,
      topItemCount,
      groupCounts,
      fixedItemHeight: fixedItemSize,
      defaultItemHeight: defaultItemSize,
      gap,
      ...followOutput,
      statefulTotalCount,
      listState,
      scrollToIndex,
      trackItemSizes,
      itemSize,
      groupIndices,
      ...flags,
      ...featureGroup1,
      ...domIO,
      ...log
    };
  },
  tup(
    sizeSystem,
    initialTopMostItemIndexSystem,
    domIOSystem,
    followOutputSystem,
    listStateSystem,
    scrollToIndexSystem,
    upwardScrollFixSystem,
    topItemCountSystem,
    groupedListSystem,
    featureGroup1System,
    loggerSystem
  )
);
const WEBKIT_STICKY = "-webkit-sticky";
const STICKY = "sticky";
const positionStickyCssValue = simpleMemoize(() => {
  if (typeof document === "undefined") {
    return STICKY;
  }
  const node = document.createElement("div");
  node.style.position = WEBKIT_STICKY;
  return node.style.position === WEBKIT_STICKY ? WEBKIT_STICKY : STICKY;
});
function useWindowViewportRectRef(callback, customScrollParent) {
  const viewportInfo = react.useRef(null);
  const calculateInfo = react.useCallback(
    (element) => {
      if (element === null || !element.offsetParent) {
        return;
      }
      const rect = element.getBoundingClientRect();
      const visibleWidth = rect.width;
      let visibleHeight, offsetTop;
      if (customScrollParent) {
        const customScrollParentRect = customScrollParent.getBoundingClientRect();
        const deltaTop = rect.top - customScrollParentRect.top;
        visibleHeight = customScrollParentRect.height - Math.max(0, deltaTop);
        offsetTop = deltaTop + customScrollParent.scrollTop;
      } else {
        visibleHeight = window.innerHeight - Math.max(0, rect.top);
        offsetTop = rect.top + window.pageYOffset;
      }
      viewportInfo.current = {
        offsetTop,
        visibleHeight,
        visibleWidth
      };
      callback(viewportInfo.current);
    },
    [callback, customScrollParent]
  );
  const { callbackRef, ref } = useSizeWithElRef(calculateInfo);
  const scrollAndResizeEventHandler = react.useCallback(() => {
    calculateInfo(ref.current);
  }, [calculateInfo, ref]);
  react.useEffect(() => {
    if (customScrollParent) {
      customScrollParent.addEventListener("scroll", scrollAndResizeEventHandler);
      const observer = new ResizeObserver(scrollAndResizeEventHandler);
      observer.observe(customScrollParent);
      return () => {
        customScrollParent.removeEventListener("scroll", scrollAndResizeEventHandler);
        observer.unobserve(customScrollParent);
      };
    } else {
      window.addEventListener("scroll", scrollAndResizeEventHandler);
      window.addEventListener("resize", scrollAndResizeEventHandler);
      return () => {
        window.removeEventListener("scroll", scrollAndResizeEventHandler);
        window.removeEventListener("resize", scrollAndResizeEventHandler);
      };
    }
  }, [scrollAndResizeEventHandler, customScrollParent]);
  return callbackRef;
}
const VirtuosoMockContext = react.createContext(void 0);
const VirtuosoGridMockContext = react.createContext(void 0);
function identity(value) {
  return value;
}
const listComponentPropsSystem = /* @__PURE__ */ system(() => {
  const itemContent = statefulStream((index) => `Item ${index}`);
  const context = statefulStream(null);
  const groupContent = statefulStream((index) => `Group ${index}`);
  const components = statefulStream({});
  const computeItemKey = statefulStream(identity);
  const headerFooterTag = statefulStream("div");
  const scrollerRef = statefulStream(noop);
  const distinctProp = (propName, defaultValue = null) => {
    return statefulStreamFromEmitter(
      pipe(
        components,
        map((components2) => components2[propName]),
        distinctUntilChanged()
      ),
      defaultValue
    );
  };
  return {
    context,
    itemContent,
    groupContent,
    components,
    computeItemKey,
    headerFooterTag,
    scrollerRef,
    FooterComponent: distinctProp("Footer"),
    HeaderComponent: distinctProp("Header"),
    TopItemListComponent: distinctProp("TopItemList"),
    ListComponent: distinctProp("List", "div"),
    ItemComponent: distinctProp("Item", "div"),
    GroupComponent: distinctProp("Group", "div"),
    ScrollerComponent: distinctProp("Scroller", "div"),
    EmptyPlaceholder: distinctProp("EmptyPlaceholder"),
    ScrollSeekPlaceholder: distinctProp("ScrollSeekPlaceholder")
  };
});
const combinedSystem$2 = /* @__PURE__ */ system(([listSystem2, propsSystem]) => {
  return { ...listSystem2, ...propsSystem };
}, tup(listSystem, listComponentPropsSystem));
const DefaultScrollSeekPlaceholder$1 = ({ height }) => /* @__PURE__ */ react.createElement("div", { style: { height } });
const GROUP_STYLE = { position: positionStickyCssValue(), zIndex: 1, overflowAnchor: "none" };
const ITEM_STYLE = { overflowAnchor: "none" };
const Items$1 = /* @__PURE__ */ react.memo(function VirtuosoItems({ showTopList = false }) {
  const listState = useEmitterValue$2("listState");
  const sizeRanges = usePublisher$2("sizeRanges");
  const useWindowScroll = useEmitterValue$2("useWindowScroll");
  const customScrollParent = useEmitterValue$2("customScrollParent");
  const windowScrollContainerStateCallback = usePublisher$2("windowScrollContainerState");
  const _scrollContainerStateCallback = usePublisher$2("scrollContainerState");
  const scrollContainerStateCallback = customScrollParent || useWindowScroll ? windowScrollContainerStateCallback : _scrollContainerStateCallback;
  const itemContent = useEmitterValue$2("itemContent");
  const context = useEmitterValue$2("context");
  const groupContent = useEmitterValue$2("groupContent");
  const trackItemSizes = useEmitterValue$2("trackItemSizes");
  const itemSize = useEmitterValue$2("itemSize");
  const log = useEmitterValue$2("log");
  const listGap = usePublisher$2("gap");
  const { callbackRef } = useChangedListContentsSizes(
    sizeRanges,
    itemSize,
    trackItemSizes,
    showTopList ? noop : scrollContainerStateCallback,
    log,
    listGap,
    customScrollParent
  );
  const [deviation, setDeviation] = react.useState(0);
  useEmitter$2("deviation", (value) => {
    if (deviation !== value) {
      setDeviation(value);
    }
  });
  const EmptyPlaceholder = useEmitterValue$2("EmptyPlaceholder");
  const ScrollSeekPlaceholder = useEmitterValue$2("ScrollSeekPlaceholder") || DefaultScrollSeekPlaceholder$1;
  const ListComponent = useEmitterValue$2("ListComponent");
  const ItemComponent = useEmitterValue$2("ItemComponent");
  const GroupComponent = useEmitterValue$2("GroupComponent");
  const computeItemKey = useEmitterValue$2("computeItemKey");
  const isSeeking = useEmitterValue$2("isSeeking");
  const hasGroups2 = useEmitterValue$2("groupIndices").length > 0;
  const paddingTopAddition = useEmitterValue$2("paddingTopAddition");
  const containerStyle = showTopList ? {} : {
    boxSizing: "border-box",
    paddingTop: listState.offsetTop + paddingTopAddition,
    paddingBottom: listState.offsetBottom,
    marginTop: deviation
  };
  if (!showTopList && listState.totalCount === 0 && EmptyPlaceholder) {
    return react.createElement(EmptyPlaceholder, contextPropIfNotDomElement(EmptyPlaceholder, context));
  }
  return react.createElement(
    ListComponent,
    {
      ...contextPropIfNotDomElement(ListComponent, context),
      ref: callbackRef,
      style: containerStyle,
      "data-test-id": showTopList ? "virtuoso-top-item-list" : "virtuoso-item-list"
    },
    (showTopList ? listState.topItems : listState.items).map((item) => {
      const index = item.originalIndex;
      const key = computeItemKey(index + listState.firstItemIndex, item.data, context);
      if (isSeeking) {
        return react.createElement(ScrollSeekPlaceholder, {
          ...contextPropIfNotDomElement(ScrollSeekPlaceholder, context),
          key,
          index: item.index,
          height: item.size,
          type: item.type || "item",
          ...(item.type === "group" ? {} : { groupIndex: item.groupIndex })
        });
      }
      if (item.type === "group") {
        return react.createElement(
          GroupComponent,
          {
            ...contextPropIfNotDomElement(GroupComponent, context),
            key,
            "data-index": index,
            "data-known-size": item.size,
            "data-item-index": item.index,
            style: GROUP_STYLE
          },
          groupContent(item.index)
        );
      } else {
        return react.createElement(
          ItemComponent,
          {
            ...contextPropIfNotDomElement(ItemComponent, context),
            key,
            "data-index": index,
            "data-known-size": item.size,
            "data-item-index": item.index,
            "data-item-group-index": item.groupIndex,
            item: item.data,
            style: ITEM_STYLE
          },
          hasGroups2 ? itemContent(item.index, item.groupIndex, item.data, context) : itemContent(item.index, item.data, context)
        );
      }
    })
  );
});
const scrollerStyle = {
  height: "100%",
  outline: "none",
  overflowY: "auto",
  position: "relative",
  WebkitOverflowScrolling: "touch"
};
const viewportStyle = {
  width: "100%",
  height: "100%",
  position: "absolute",
  top: 0
};
const topItemListStyle = {
  width: "100%",
  position: positionStickyCssValue(),
  top: 0,
  zIndex: 1
};
function contextPropIfNotDomElement(element, context) {
  if (typeof element === "string") {
    return void 0;
  }
  return { context };
}
const Header$1 = /* @__PURE__ */ react.memo(function VirtuosoHeader() {
  const Header2 = useEmitterValue$2("HeaderComponent");
  const headerHeight = usePublisher$2("headerHeight");
  const headerFooterTag = useEmitterValue$2("headerFooterTag");
  const ref = useSize((el) => headerHeight(correctItemSize(el, "height")));
  const context = useEmitterValue$2("context");
  return Header2 ? react.createElement(headerFooterTag, { ref }, react.createElement(Header2, contextPropIfNotDomElement(Header2, context))) : null;
});
const Footer$1 = /* @__PURE__ */ react.memo(function VirtuosoFooter() {
  const Footer2 = useEmitterValue$2("FooterComponent");
  const footerHeight = usePublisher$2("footerHeight");
  const headerFooterTag = useEmitterValue$2("headerFooterTag");
  const ref = useSize((el) => footerHeight(correctItemSize(el, "height")));
  const context = useEmitterValue$2("context");
  return Footer2 ? react.createElement(headerFooterTag, { ref }, react.createElement(Footer2, contextPropIfNotDomElement(Footer2, context))) : null;
});
function buildScroller({ usePublisher: usePublisher2, useEmitter: useEmitter2, useEmitterValue: useEmitterValue2 }) {
  const Scroller2 = react.memo(function VirtuosoScroller({ style, children, ...props }) {
    const scrollContainerStateCallback = usePublisher2("scrollContainerState");
    const ScrollerComponent = useEmitterValue2("ScrollerComponent");
    const smoothScrollTargetReached = usePublisher2("smoothScrollTargetReached");
    const scrollerRefCallback = useEmitterValue2("scrollerRef");
    const context = useEmitterValue2("context");
    const { scrollerRef, scrollByCallback, scrollToCallback } = useScrollTop(
      scrollContainerStateCallback,
      smoothScrollTargetReached,
      ScrollerComponent,
      scrollerRefCallback
    );
    useEmitter2("scrollTo", scrollToCallback);
    useEmitter2("scrollBy", scrollByCallback);
    return react.createElement(
      ScrollerComponent,
      {
        ref: scrollerRef,
        style: { ...scrollerStyle, ...style },
        "data-test-id": "virtuoso-scroller",
        "data-virtuoso-scroller": true,
        tabIndex: 0,
        ...props,
        ...contextPropIfNotDomElement(ScrollerComponent, context)
      },
      children
    );
  });
  return Scroller2;
}
function buildWindowScroller({ usePublisher: usePublisher2, useEmitter: useEmitter2, useEmitterValue: useEmitterValue2 }) {
  const Scroller2 = react.memo(function VirtuosoWindowScroller({ style, children, ...props }) {
    const scrollContainerStateCallback = usePublisher2("windowScrollContainerState");
    const ScrollerComponent = useEmitterValue2("ScrollerComponent");
    const smoothScrollTargetReached = usePublisher2("smoothScrollTargetReached");
    const totalListHeight = useEmitterValue2("totalListHeight");
    const deviation = useEmitterValue2("deviation");
    const customScrollParent = useEmitterValue2("customScrollParent");
    const context = useEmitterValue2("context");
    const { scrollerRef, scrollByCallback, scrollToCallback } = useScrollTop(
      scrollContainerStateCallback,
      smoothScrollTargetReached,
      ScrollerComponent,
      noop,
      customScrollParent
    );
    useIsomorphicLayoutEffect$1(() => {
      scrollerRef.current = customScrollParent ? customScrollParent : window;
      return () => {
        scrollerRef.current = null;
      };
    }, [scrollerRef, customScrollParent]);
    useEmitter2("windowScrollTo", scrollToCallback);
    useEmitter2("scrollBy", scrollByCallback);
    return react.createElement(
      ScrollerComponent,
      {
        style: { position: "relative", ...style, ...(totalListHeight !== 0 ? { height: totalListHeight + deviation } : {}) },
        "data-virtuoso-scroller": true,
        ...props,
        ...contextPropIfNotDomElement(ScrollerComponent, context)
      },
      children
    );
  });
  return Scroller2;
}
const Viewport$2 = ({ children }) => {
  const ctx = react.useContext(VirtuosoMockContext);
  const viewportHeight = usePublisher$2("viewportHeight");
  const fixedItemHeight = usePublisher$2("fixedItemHeight");
  const viewportRef = useSize(compose(viewportHeight, (el) => correctItemSize(el, "height")));
  react.useEffect(() => {
    if (ctx) {
      viewportHeight(ctx.viewportHeight);
      fixedItemHeight(ctx.itemHeight);
    }
  }, [ctx, viewportHeight, fixedItemHeight]);
  return /* @__PURE__ */ react.createElement("div", { style: viewportStyle, ref: viewportRef, "data-viewport-type": "element" }, children);
};
const WindowViewport$2 = ({ children }) => {
  const ctx = react.useContext(VirtuosoMockContext);
  const windowViewportRect = usePublisher$2("windowViewportRect");
  const fixedItemHeight = usePublisher$2("fixedItemHeight");
  const customScrollParent = useEmitterValue$2("customScrollParent");
  const viewportRef = useWindowViewportRectRef(windowViewportRect, customScrollParent);
  react.useEffect(() => {
    if (ctx) {
      fixedItemHeight(ctx.itemHeight);
      windowViewportRect({ offsetTop: 0, visibleHeight: ctx.viewportHeight, visibleWidth: 100 });
    }
  }, [ctx, windowViewportRect, fixedItemHeight]);
  return /* @__PURE__ */ react.createElement("div", { ref: viewportRef, style: viewportStyle, "data-viewport-type": "window" }, children);
};
const TopItemListContainer = ({ children }) => {
  const TopItemList = useEmitterValue$2("TopItemListComponent");
  const headerHeight = useEmitterValue$2("headerHeight");
  const style = { ...topItemListStyle, marginTop: `${headerHeight}px` };
  const context = useEmitterValue$2("context");
  return react.createElement(TopItemList || "div", { style, context }, children);
};
const ListRoot = /* @__PURE__ */ react.memo(function VirtuosoRoot(props) {
  const useWindowScroll = useEmitterValue$2("useWindowScroll");
  const showTopList = useEmitterValue$2("topItemsIndexes").length > 0;
  const customScrollParent = useEmitterValue$2("customScrollParent");
  const TheScroller = customScrollParent || useWindowScroll ? WindowScroller$2 : Scroller$2;
  const TheViewport = customScrollParent || useWindowScroll ? WindowViewport$2 : Viewport$2;
  return /* @__PURE__ */ react.createElement(TheScroller, { ...props }, showTopList && /* @__PURE__ */ react.createElement(TopItemListContainer, null, /* @__PURE__ */ react.createElement(Items$1, { showTopList: true })), /* @__PURE__ */ react.createElement(TheViewport, null, /* @__PURE__ */ react.createElement(Header$1, null), /* @__PURE__ */ react.createElement(Items$1, null), /* @__PURE__ */ react.createElement(Footer$1, null)));
});
const {
  Component: List,
  usePublisher: usePublisher$2,
  useEmitterValue: useEmitterValue$2,
  useEmitter: useEmitter$2
} = /* @__PURE__ */ systemToComponent(
  combinedSystem$2,
  {
    required: {},
    optional: {
      context: "context",
      followOutput: "followOutput",
      firstItemIndex: "firstItemIndex",
      itemContent: "itemContent",
      groupContent: "groupContent",
      overscan: "overscan",
      increaseViewportBy: "increaseViewportBy",
      totalCount: "totalCount",
      topItemCount: "topItemCount",
      initialTopMostItemIndex: "initialTopMostItemIndex",
      components: "components",
      groupCounts: "groupCounts",
      atBottomThreshold: "atBottomThreshold",
      atTopThreshold: "atTopThreshold",
      computeItemKey: "computeItemKey",
      defaultItemHeight: "defaultItemHeight",
      fixedItemHeight: "fixedItemHeight",
      itemSize: "itemSize",
      scrollSeekConfiguration: "scrollSeekConfiguration",
      headerFooterTag: "headerFooterTag",
      data: "data",
      initialItemCount: "initialItemCount",
      initialScrollTop: "initialScrollTop",
      alignToBottom: "alignToBottom",
      useWindowScroll: "useWindowScroll",
      customScrollParent: "customScrollParent",
      scrollerRef: "scrollerRef",
      logLevel: "logLevel"
    },
    methods: {
      scrollToIndex: "scrollToIndex",
      scrollIntoView: "scrollIntoView",
      scrollTo: "scrollTo",
      scrollBy: "scrollBy",
      autoscrollToBottom: "autoscrollToBottom"
    },
    events: {
      isScrolling: "isScrolling",
      endReached: "endReached",
      startReached: "startReached",
      rangeChanged: "rangeChanged",
      atBottomStateChange: "atBottomStateChange",
      atTopStateChange: "atTopStateChange",
      totalListHeightChanged: "totalListHeightChanged",
      itemsRendered: "itemsRendered",
      groupIndices: "groupIndices"
    }
  },
  ListRoot
);
const Scroller$2 = /* @__PURE__ */ buildScroller({ usePublisher: usePublisher$2, useEmitterValue: useEmitterValue$2, useEmitter: useEmitter$2 });
const WindowScroller$2 = /* @__PURE__ */ buildWindowScroller({ usePublisher: usePublisher$2, useEmitterValue: useEmitterValue$2, useEmitter: useEmitter$2 });
const GroupedVirtuoso = List;
const INITIAL_GRID_STATE = {
  items: [],
  offsetBottom: 0,
  offsetTop: 0,
  top: 0,
  bottom: 0,
  itemHeight: 0,
  itemWidth: 0
};
const PROBE_GRID_STATE = {
  items: [{ index: 0 }],
  offsetBottom: 0,
  offsetTop: 0,
  top: 0,
  bottom: 0,
  itemHeight: 0,
  itemWidth: 0
};
const { round, ceil, floor, min, max } = Math;
function buildProbeGridState(items) {
  return {
    ...PROBE_GRID_STATE,
    items
  };
}
function buildItems(startIndex, endIndex, data) {
  return Array.from({ length: endIndex - startIndex + 1 }).map(
    (_, i) => ({ index: i + startIndex, data: data == null ? void 0 : data[i + startIndex] })
  );
}
function gapComparator(prev, next) {
  return prev && prev.column === next.column && prev.row === next.row;
}
function dimensionComparator(prev, next) {
  return prev && prev.width === next.width && prev.height === next.height;
}
const gridSystem = /* @__PURE__ */ system(
  ([
    { overscan, visibleRange, listBoundary },
    { scrollTop, viewportHeight, scrollBy, scrollTo, smoothScrollTargetReached, scrollContainerState, footerHeight, headerHeight },
    stateFlags,
    scrollSeek,
    { propsReady, didMount },
    { windowViewportRect, windowScrollTo, useWindowScroll, customScrollParent, windowScrollContainerState },
    log
  ]) => {
    const totalCount = statefulStream(0);
    const initialItemCount = statefulStream(0);
    const gridState = statefulStream(INITIAL_GRID_STATE);
    const viewportDimensions = statefulStream({ height: 0, width: 0 });
    const itemDimensions = statefulStream({ height: 0, width: 0 });
    const scrollToIndex = stream();
    const scrollHeight = stream();
    const deviation = statefulStream(0);
    const data = statefulStream(void 0);
    const gap = statefulStream({ row: 0, column: 0 });
    connect(
      pipe(
        combineLatest(didMount, initialItemCount, data),
        filter(([, count]) => count !== 0),
        map(([, count, data2]) => {
          return {
            items: buildItems(0, count - 1, data2),
            top: 0,
            bottom: 0,
            offsetBottom: 0,
            offsetTop: 0,
            itemHeight: 0,
            itemWidth: 0
          };
        })
      ),
      gridState
    );
    connect(
      pipe(
        combineLatest(
          duc(totalCount),
          visibleRange,
          duc(gap, gapComparator),
          duc(itemDimensions, dimensionComparator),
          duc(viewportDimensions, dimensionComparator),
          data
        ),
        map(([totalCount2, [startOffset, endOffset], gap2, item, viewport, data2]) => {
          const { row: rowGap, column: columnGap } = gap2;
          const { height: itemHeight, width: itemWidth } = item;
          const { width: viewportWidth } = viewport;
          if (totalCount2 === 0 || viewportWidth === 0) {
            return INITIAL_GRID_STATE;
          }
          if (itemWidth === 0) {
            return buildProbeGridState(buildItems(0, 0, data2));
          }
          const perRow = itemsPerRow(viewportWidth, itemWidth, columnGap);
          let startIndex = perRow * floor((startOffset + rowGap) / (itemHeight + rowGap));
          let endIndex = perRow * ceil((endOffset + rowGap) / (itemHeight + rowGap)) - 1;
          endIndex = min(totalCount2 - 1, max(endIndex, perRow - 1));
          startIndex = min(endIndex, max(0, startIndex));
          const items = buildItems(startIndex, endIndex, data2);
          const { top, bottom } = gridLayout(viewport, gap2, item, items);
          const rowCount = ceil(totalCount2 / perRow);
          const totalHeight = rowCount * itemHeight + (rowCount - 1) * rowGap;
          const offsetBottom = totalHeight - bottom;
          return { items, offsetTop: top, offsetBottom, top, bottom, itemHeight, itemWidth };
        })
      ),
      gridState
    );
    connect(
      pipe(
        data,
        filter((data2) => data2 !== void 0),
        map((data2) => data2.length)
      ),
      totalCount
    );
    connect(
      pipe(
        viewportDimensions,
        map(({ height }) => height)
      ),
      viewportHeight
    );
    connect(
      pipe(
        combineLatest(viewportDimensions, itemDimensions, gridState, gap),
        map(([viewportDimensions2, item, { items }, gap2]) => {
          const { top, bottom } = gridLayout(viewportDimensions2, gap2, item, items);
          return [top, bottom];
        }),
        distinctUntilChanged(tupleComparator)
      ),
      listBoundary
    );
    const endReached = streamFromEmitter(
      pipe(
        duc(gridState),
        filter(({ items }) => items.length > 0),
        withLatestFrom(totalCount),
        filter(([{ items }, totalCount2]) => items[items.length - 1].index === totalCount2 - 1),
        map(([, totalCount2]) => totalCount2 - 1),
        distinctUntilChanged()
      )
    );
    const startReached = streamFromEmitter(
      pipe(
        duc(gridState),
        filter(({ items }) => {
          return items.length > 0 && items[0].index === 0;
        }),
        mapTo(0),
        distinctUntilChanged()
      )
    );
    const rangeChanged = streamFromEmitter(
      pipe(
        duc(gridState),
        filter(({ items }) => items.length > 0),
        map(({ items }) => {
          return {
            startIndex: items[0].index,
            endIndex: items[items.length - 1].index
          };
        }),
        distinctUntilChanged(rangeComparator)
      )
    );
    connect(rangeChanged, scrollSeek.scrollSeekRangeChanged);
    connect(
      pipe(
        scrollToIndex,
        withLatestFrom(viewportDimensions, itemDimensions, totalCount, gap),
        map(([location, viewport, item, totalCount2, gap2]) => {
          const normalLocation = normalizeIndexLocation(location);
          const { align, behavior, offset } = normalLocation;
          let index = normalLocation.index;
          if (index === "LAST") {
            index = totalCount2 - 1;
          }
          index = max(0, index, min(totalCount2 - 1, index));
          let top = itemTop(viewport, gap2, item, index);
          if (align === "end") {
            top = round(top - viewport.height + item.height);
          } else if (align === "center") {
            top = round(top - viewport.height / 2 + item.height / 2);
          }
          if (offset) {
            top += offset;
          }
          return { top, behavior };
        })
      ),
      scrollTo
    );
    const totalListHeight = statefulStreamFromEmitter(
      pipe(
        gridState,
        map((gridState2) => {
          return gridState2.offsetBottom + gridState2.bottom;
        })
      ),
      0
    );
    connect(
      pipe(
        windowViewportRect,
        map((viewportInfo) => ({ width: viewportInfo.visibleWidth, height: viewportInfo.visibleHeight }))
      ),
      viewportDimensions
    );
    return {
      data,
      totalCount,
      viewportDimensions,
      itemDimensions,
      scrollTop,
      scrollHeight,
      overscan,
      scrollBy,
      scrollTo,
      scrollToIndex,
      smoothScrollTargetReached,
      windowViewportRect,
      windowScrollTo,
      useWindowScroll,
      customScrollParent,
      windowScrollContainerState,
      deviation,
      scrollContainerState,
      footerHeight,
      headerHeight,
      initialItemCount,
      gap,
      ...scrollSeek,
      gridState,
      totalListHeight,
      ...stateFlags,
      startReached,
      endReached,
      rangeChanged,
      propsReady,
      ...log
    };
  },
  tup(sizeRangeSystem, domIOSystem, stateFlagsSystem, scrollSeekSystem, propsReadySystem, windowScrollerSystem, loggerSystem)
);
function gridLayout(viewport, gap, item, items) {
  const { height: itemHeight } = item;
  if (itemHeight === void 0 || items.length === 0) {
    return { top: 0, bottom: 0 };
  }
  const top = itemTop(viewport, gap, item, items[0].index);
  const bottom = itemTop(viewport, gap, item, items[items.length - 1].index) + itemHeight;
  return { top, bottom };
}
function itemTop(viewport, gap, item, index) {
  const perRow = itemsPerRow(viewport.width, item.width, gap.column);
  const rowCount = floor(index / perRow);
  const top = rowCount * item.height + max(0, rowCount - 1) * gap.row;
  return top > 0 ? top + gap.row : top;
}
function itemsPerRow(viewportWidth, itemWidth, gap) {
  return max(1, floor((viewportWidth + gap) / (itemWidth + gap)));
}
const gridComponentPropsSystem = /* @__PURE__ */ system(() => {
  const itemContent = statefulStream((index) => `Item ${index}`);
  const components = statefulStream({});
  const context = statefulStream(null);
  const itemClassName = statefulStream("virtuoso-grid-item");
  const listClassName = statefulStream("virtuoso-grid-list");
  const computeItemKey = statefulStream(identity);
  const headerFooterTag = statefulStream("div");
  const scrollerRef = statefulStream(noop);
  const distinctProp = (propName, defaultValue = null) => {
    return statefulStreamFromEmitter(
      pipe(
        components,
        map((components2) => components2[propName]),
        distinctUntilChanged()
      ),
      defaultValue
    );
  };
  return {
    context,
    itemContent,
    components,
    computeItemKey,
    itemClassName,
    listClassName,
    headerFooterTag,
    scrollerRef,
    FooterComponent: distinctProp("Footer"),
    HeaderComponent: distinctProp("Header"),
    ListComponent: distinctProp("List", "div"),
    ItemComponent: distinctProp("Item", "div"),
    ScrollerComponent: distinctProp("Scroller", "div"),
    ScrollSeekPlaceholder: distinctProp("ScrollSeekPlaceholder", "div")
  };
});
const combinedSystem$1 = /* @__PURE__ */ system(([gridSystem2, gridComponentPropsSystem2]) => {
  return { ...gridSystem2, ...gridComponentPropsSystem2 };
}, tup(gridSystem, gridComponentPropsSystem));
const GridItems = /* @__PURE__ */ react.memo(function GridItems2() {
  const gridState = useEmitterValue$1("gridState");
  const listClassName = useEmitterValue$1("listClassName");
  const itemClassName = useEmitterValue$1("itemClassName");
  const itemContent = useEmitterValue$1("itemContent");
  const computeItemKey = useEmitterValue$1("computeItemKey");
  const isSeeking = useEmitterValue$1("isSeeking");
  const scrollHeightCallback = usePublisher$1("scrollHeight");
  const ItemComponent = useEmitterValue$1("ItemComponent");
  const ListComponent = useEmitterValue$1("ListComponent");
  const ScrollSeekPlaceholder = useEmitterValue$1("ScrollSeekPlaceholder");
  const context = useEmitterValue$1("context");
  const itemDimensions = usePublisher$1("itemDimensions");
  const gridGap = usePublisher$1("gap");
  const log = useEmitterValue$1("log");
  const listRef = useSize((el) => {
    const scrollHeight = el.parentElement.parentElement.scrollHeight;
    scrollHeightCallback(scrollHeight);
    const firstItem = el.firstChild;
    if (firstItem) {
      itemDimensions(firstItem.getBoundingClientRect());
    }
    gridGap({
      row: resolveGapValue("row-gap", getComputedStyle(el).rowGap, log),
      column: resolveGapValue("column-gap", getComputedStyle(el).columnGap, log)
    });
  });
  return react.createElement(
    ListComponent,
    {
      ref: listRef,
      className: listClassName,
      ...contextPropIfNotDomElement(ListComponent, context),
      style: { paddingTop: gridState.offsetTop, paddingBottom: gridState.offsetBottom },
      "data-test-id": "virtuoso-item-list"
    },
    gridState.items.map((item) => {
      const key = computeItemKey(item.index, item.data, context);
      return isSeeking ? react.createElement(ScrollSeekPlaceholder, {
        key,
        ...contextPropIfNotDomElement(ScrollSeekPlaceholder, context),
        index: item.index,
        height: gridState.itemHeight,
        width: gridState.itemWidth
      }) : react.createElement(
        ItemComponent,
        { ...contextPropIfNotDomElement(ItemComponent, context), className: itemClassName, "data-index": item.index, key },
        itemContent(item.index, item.data, context)
      );
    })
  );
});
const Header = react.memo(function VirtuosoHeader2() {
  const Header2 = useEmitterValue$1("HeaderComponent");
  const headerHeight = usePublisher$1("headerHeight");
  const headerFooterTag = useEmitterValue$1("headerFooterTag");
  const ref = useSize((el) => headerHeight(correctItemSize(el, "height")));
  const context = useEmitterValue$1("context");
  return Header2 ? react.createElement(headerFooterTag, { ref }, react.createElement(Header2, contextPropIfNotDomElement(Header2, context))) : null;
});
const Footer = react.memo(function VirtuosoGridFooter() {
  const Footer2 = useEmitterValue$1("FooterComponent");
  const footerHeight = usePublisher$1("footerHeight");
  const headerFooterTag = useEmitterValue$1("headerFooterTag");
  const ref = useSize((el) => footerHeight(correctItemSize(el, "height")));
  const context = useEmitterValue$1("context");
  return Footer2 ? react.createElement(headerFooterTag, { ref }, react.createElement(Footer2, contextPropIfNotDomElement(Footer2, context))) : null;
});
const Viewport$1 = ({ children }) => {
  const ctx = react.useContext(VirtuosoGridMockContext);
  const itemDimensions = usePublisher$1("itemDimensions");
  const viewportDimensions = usePublisher$1("viewportDimensions");
  const viewportRef = useSize((el) => {
    viewportDimensions(el.getBoundingClientRect());
  });
  react.useEffect(() => {
    if (ctx) {
      viewportDimensions({ height: ctx.viewportHeight, width: ctx.viewportWidth });
      itemDimensions({ height: ctx.itemHeight, width: ctx.itemWidth });
    }
  }, [ctx, viewportDimensions, itemDimensions]);
  return /* @__PURE__ */ react.createElement("div", { style: viewportStyle, ref: viewportRef }, children);
};
const WindowViewport$1 = ({ children }) => {
  const ctx = react.useContext(VirtuosoGridMockContext);
  const windowViewportRect = usePublisher$1("windowViewportRect");
  const itemDimensions = usePublisher$1("itemDimensions");
  const customScrollParent = useEmitterValue$1("customScrollParent");
  const viewportRef = useWindowViewportRectRef(windowViewportRect, customScrollParent);
  react.useEffect(() => {
    if (ctx) {
      itemDimensions({ height: ctx.itemHeight, width: ctx.itemWidth });
      windowViewportRect({ offsetTop: 0, visibleHeight: ctx.viewportHeight, visibleWidth: ctx.viewportWidth });
    }
  }, [ctx, windowViewportRect, itemDimensions]);
  return /* @__PURE__ */ react.createElement("div", { ref: viewportRef, style: viewportStyle }, children);
};
const GridRoot = /* @__PURE__ */ react.memo(function GridRoot2({ ...props }) {
  const useWindowScroll = useEmitterValue$1("useWindowScroll");
  const customScrollParent = useEmitterValue$1("customScrollParent");
  const TheScroller = customScrollParent || useWindowScroll ? WindowScroller$1 : Scroller$1;
  const TheViewport = customScrollParent || useWindowScroll ? WindowViewport$1 : Viewport$1;
  return /* @__PURE__ */ react.createElement(TheScroller, { ...props }, /* @__PURE__ */ react.createElement(TheViewport, null, /* @__PURE__ */ react.createElement(Header, null), /* @__PURE__ */ react.createElement(GridItems, null), /* @__PURE__ */ react.createElement(Footer, null)));
});
const {
  Component: Grid,
  usePublisher: usePublisher$1,
  useEmitterValue: useEmitterValue$1,
  useEmitter: useEmitter$1
} = /* @__PURE__ */ systemToComponent(
  combinedSystem$1,
  {
    optional: {
      context: "context",
      totalCount: "totalCount",
      overscan: "overscan",
      itemContent: "itemContent",
      components: "components",
      computeItemKey: "computeItemKey",
      data: "data",
      initialItemCount: "initialItemCount",
      scrollSeekConfiguration: "scrollSeekConfiguration",
      headerFooterTag: "headerFooterTag",
      listClassName: "listClassName",
      itemClassName: "itemClassName",
      useWindowScroll: "useWindowScroll",
      customScrollParent: "customScrollParent",
      scrollerRef: "scrollerRef"
    },
    methods: {
      scrollTo: "scrollTo",
      scrollBy: "scrollBy",
      scrollToIndex: "scrollToIndex"
    },
    events: {
      isScrolling: "isScrolling",
      endReached: "endReached",
      startReached: "startReached",
      rangeChanged: "rangeChanged",
      atBottomStateChange: "atBottomStateChange",
      atTopStateChange: "atTopStateChange"
    }
  },
  GridRoot
);
const Scroller$1 = /* @__PURE__ */ buildScroller({ usePublisher: usePublisher$1, useEmitterValue: useEmitterValue$1, useEmitter: useEmitter$1 });
const WindowScroller$1 = /* @__PURE__ */ buildWindowScroller({ usePublisher: usePublisher$1, useEmitterValue: useEmitterValue$1, useEmitter: useEmitter$1 });
function resolveGapValue(property, value, log) {
  if (value !== "normal" && !(value == null ? void 0 : value.endsWith("px"))) {
    log(`${property} was not resolved to pixel value correctly`, value, LogLevel.WARN);
  }
  if (value === "normal") {
    return 0;
  }
  return parseInt(value || "0", 10);
}


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Molecules/ItemCard.js
var ItemCard = __webpack_require__(6501);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Utils/isMobile.util.js
var isMobile_util = __webpack_require__(30558);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Molecules/SortSelector.js + 1 modules
var SortSelector = __webpack_require__(37646);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/Divider.js
var Divider = __webpack_require__(36548);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Components/Organisms/MenuPanel/Web/sort-filter.component.js





function SortFilter(_a) {
    var filterOptions = _a.filterOptions, sortOptions = _a.sortOptions, onFilterByCallback = _a.onFilterByCallback, onFilterClearCallback = _a.onFilterClearCallback, onSortClearCallback = _a.onSortClearCallback, _b = _a.selectedfilterOptions, selectedfilterOptions = _b === void 0 ? [] : _b, selectedSortOptions = _a.selectedSortOptions, filterSortIndicatorData = _a.filterSortIndicatorData;
    var _c = (0,react.useState)(selectedfilterOptions), _selectedfilterOptions = _c[0], _setSelectedfilterOptions = _c[1];
    var _d = (0,react.useState)(selectedSortOptions), _selectedSortOptions = _d[0], _setSelectedSortOptions = _d[1];
    var showDivider = function () { return (filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.length) && (sortOptions === null || sortOptions === void 0 ? void 0 : sortOptions.length); };
    var onFilterByChange = function (checked, id) {
        if (checked && !_selectedfilterOptions.includes(id)) {
            _setSelectedfilterOptions((0,tslib_es6/* __spreadArray */.ev)((0,tslib_es6/* __spreadArray */.ev)([], _selectedfilterOptions, true), [id], false));
        }
        else {
            if (_selectedfilterOptions.includes(id)) {
                _setSelectedfilterOptions(_selectedfilterOptions.filter(function (filterId) { return filterId != id; }));
            }
        }
    };
    var onSortByChange = function (id) {
        _setSelectedSortOptions(sortOptions === null || sortOptions === void 0 ? void 0 : sortOptions[id]);
    };
    var getSortOptions = function () {
        return [
            {
                group: "Sort By",
                options: sortOptions === null || sortOptions === void 0 ? void 0 : sortOptions.map(function (title, id) { return ({
                    id: id,
                    title: title
                }); })
            }
        ];
    };
    return (react.createElement("div", { className: "menu-panel__body__sections__header--sort-filter ".concat((_selectedSortOptions === null || _selectedSortOptions === void 0 ? void 0 : _selectedSortOptions.length) > 0 &&
            'menu-panel__body__sections__header--sort-filter--selected') },
        (filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.length) > 0 ? (react.createElement(SortSelector/* default */.Z, { key: "filter", classes: "item-list-header__filter-selector", sortOptions: filterOptions, type: "checkbox", onFilterByCallback: function () {
                return onFilterByCallback === null || onFilterByCallback === void 0 ? void 0 : onFilterByCallback(_selectedSortOptions, _selectedfilterOptions);
            }, onFilterByChange: onFilterByChange, onFilterClearCallback: onFilterClearCallback, selectedfilterOptions: _selectedfilterOptions, filterSortIndicatorData: filterSortIndicatorData })) : null,
        showDivider() ? (react.createElement(Divider/* default */.Z, { dividerStyle: 'solid', thickness: "thin", variant: 'vertical', size: 24 })) : null,
        (sortOptions === null || sortOptions === void 0 ? void 0 : sortOptions.length) > 0 ? (react.createElement(SortSelector/* default */.Z, { key: "sort", classes: "item-list-header__sort-selector", sortOptions: getSortOptions(), onSortByChange: onSortByChange, onFilterByCallback: function () {
                return onFilterByCallback === null || onFilterByCallback === void 0 ? void 0 : onFilterByCallback(_selectedSortOptions, _selectedfilterOptions);
            }, onSortClearCallback: onSortClearCallback, selectedSortOptions: _selectedSortOptions, filterSortIndicatorData: filterSortIndicatorData, type: "radio" })) : null));
}


//# sourceMappingURL=sort-filter.component.js.map

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/assets/icons/order-history.update.icon.js
var order_history_update_icon = __webpack_require__(38951);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Components/Organisms/MenuPanel/Web/empty-state.js






function MenuPanelEmptyState(_a) {
    var loading = _a.loading;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    if (loading) {
        return (react.createElement("div", { className: "menu-panel__loading-state" }, [1, 2, 3, 4].map(function (_) { return (react.createElement(ItemCard/* default */.Z, { loading: loading })); })));
    }
    return (react.createElement("div", { className: "menu-panel__empty-state" },
        react.createElement(order_history_update_icon/* default */.Z, null),
        react.createElement(Typography/* default */.Z, { variant: "headingTwo", classes: "menu-panel__empty-state__title" }, t('common.emptyListTitle'))));
}


//# sourceMappingURL=empty-state.js.map

;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Organisms/MenuPanel.js













function MenuPanel(_a) {
    var _b, _c, _d, _e;
    var categories = _a.categories, selectedCategory = _a.selectedCategory, onCategoryClick = _a.onCategoryClick, itemsMap = _a.itemsMap, imageComponent = _a.imageComponent, fetchCategoryItems = _a.fetchCategoryItems, sortFilter = _a.sortFilter, cartItems = _a.cartItems, totalItems = _a.totalItems, minOrder = _a.minOrder, subTotal = _a.subTotal, _f = _a.onItemUpdate, onItemUpdate = _f === void 0 ? function () { } : _f, _g = _a.onItemClicked, onItemClicked = _g === void 0 ? function () { } : _g, _h = _a.onCheckoutClicked, onCheckoutClicked = _h === void 0 ? function () { } : _h, _j = _a.toggleFavourite, toggleFavourite = _j === void 0 ? function () { } : _j, _k = _a.onFilterByCallback, onFilterByCallback = _k === void 0 ? function () { } : _k, _l = _a.onFilterClearCallback, onFilterClearCallback = _l === void 0 ? function () { } : _l, _m = _a.onSortClearCallback, onSortClearCallback = _m === void 0 ? function () { } : _m, _o = _a.editCustomizationCallback, editCustomizationCallback = _o === void 0 ? function () { } : _o, _p = _a.selectedfilterOptions, selectedfilterOptions = _p === void 0 ? [] : _p, selectedSortOptions = _a.selectedSortOptions, onError = _a.onError, showFoodType = _a.showFoodType, isFavouriteEnabled = _a.isFavouriteEnabled, filterSortIndicatorData = _a.filterSortIndicatorData, loading = _a.loading, itemLevelInstructionsEnabled = _a.itemLevelInstructionsEnabled;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var parentRef = (0,react.useRef)();
    var virtuosoRef = (0,react.useRef)();
    var isMobile = (0,isMobile_util/* useIsMobile */.d)();
    /** a flat category structure to populate the category left bar */
    var _q = react.useState([]), flatCategories = _q[0], setFlatCategories = _q[1];
    /* acrive category and sub category */
    var _r = react.useState(0), activeCategoryIndex = _r[0], setActiveCategoryIndex = _r[1];
    var _s = react.useState(0), activeSubCategoryIndex = _s[0], setActiveSubCategoryIndex = _s[1];
    var cartItemQuantityMap = cartItems === null || cartItems === void 0 ? void 0 : cartItems.reduce(function (acc, item) {
        if (!acc[item.id]) {
            acc[item.id] = 0;
        }
        acc[item.id] += item.quantity;
        return acc;
    }, {});
    (0,react.useEffect)(function () {
        if (categories.length > 0) {
            var _flatCategories = categories === null || categories === void 0 ? void 0 : categories.reduce(function (acc, category) {
                if (category.sub_categories) {
                    acc.push.apply(acc, category.sub_categories.map(function (e) { return ((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, e), { parent: category })); }));
                }
                else {
                    acc.push(category);
                }
                return acc;
            }, []);
            setFlatCategories(_flatCategories);
        }
        else {
            setFlatCategories([]);
        }
    }, [categories]);
    (0,react.useEffect)(function () {
        //to persist the scroll position
        if (flatCategories.length > 0) {
            var scrollSoFarOffset_1 = sessionStorage.getItem('scrolledSoFar') || 0;
            if (scrollSoFarOffset_1) {
                setTimeout(function () {
                    window.scrollTo(0, parseInt(scrollSoFarOffset_1));
                    sessionStorage.removeItem('scrolledSoFar');
                }, 1000);
            }
            else if (selectedCategory) {
                var category_1 = flatCategories.findIndex(function (cat) { return cat.id === selectedCategory; });
                if (category_1.parent) {
                    setTimeout(function () {
                        onCategoryChange(category_1.parent.id, selectedCategory, true);
                    }, 500);
                }
                else {
                    setTimeout(function () {
                        onCategoryChange(selectedCategory, undefined, true);
                    }, 500);
                }
            }
        }
    }, [selectedCategory, flatCategories]);
    var onCategoryChange = function (categoryId, subCategoryId, dontTriggerClick) {
        var _a, _b, _c;
        if (dontTriggerClick === void 0) { dontTriggerClick = false; }
        var category = categories.findIndex(function (category) { return category.id === categoryId; });
        var subCategory = (_b = (_a = categories[category]) === null || _a === void 0 ? void 0 : _a.sub_categories) === null || _b === void 0 ? void 0 : _b.findIndex(function (subCategory) { return subCategory.id === subCategoryId; });
        setActiveCategoryIndex(category);
        setActiveSubCategoryIndex(subCategory || 0);
        var selectedCategory = subCategoryId || categoryId;
        /** scroll to the selected category */
        var index = flatCategories.findIndex(function (e) { return e.id === selectedCategory; });
        var countTillNow = (_c = flatCategories
            .slice(0, index)) === null || _c === void 0 ? void 0 : _c.reduce(function (acc, category) {
            return acc + category.item_count;
        }, 0);
        virtuosoRef.current.scrollToIndex({
            index: countTillNow,
            offset: isMobile ? 4 : 8
        });
        !dontTriggerClick &&
            onCategoryClick &&
            onCategoryClick(flatCategories[index]);
    };
    return (react.createElement("div", { className: "menu-panel", ref: parentRef },
        react.createElement("div", { className: "menu-panel__categories" },
            !isMobile ? (react.createElement(Typography/* default */.Z, { classes: "menu-panel__categories__label", variant: "headingOne" }, t('common.categories'))) : null,
            react.createElement(ItemListNavigator/* default */.ZP, { categories: categories, onCategoryChange: onCategoryChange, activeCategoryId: (_b = categories[activeCategoryIndex]) === null || _b === void 0 ? void 0 : _b.id, activeSubCategoryId: (_e = (_d = (_c = categories[activeCategoryIndex]) === null || _c === void 0 ? void 0 : _c.sub_categories) === null || _d === void 0 ? void 0 : _d[activeSubCategoryIndex]) === null || _e === void 0 ? void 0 : _e.id })),
        react.createElement("div", { className: "menu-panel__sections" },
            react.createElement(GroupedVirtuoso, { onScroll: function (e) { return console.log(e); }, ref: virtuosoRef, useWindowScroll: true, width: "100%", itemsRendered: function (items) {
                    var _a, _b;
                    var renderedGroupIndices = items
                        .map(function (item) { return item.groupIndex; })
                        .filter(function (e) { return !isNaN(e); });
                    fetchCategoryItems(renderedGroupIndices.map(function (index) { var _a; return (_a = flatCategories[index]) === null || _a === void 0 ? void 0 : _a.id; }));
                    var _activeCategory = flatCategories[renderedGroupIndices.length > 0
                        ? Math.min.apply(Math, renderedGroupIndices) : 0];
                    var _parentActiveCategory = _activeCategory === null || _activeCategory === void 0 ? void 0 : _activeCategory.parent;
                    if (_parentActiveCategory) {
                        var _parentActiveCategoryIndex = categories.findIndex(function (cat) { return cat.id === (_parentActiveCategory === null || _parentActiveCategory === void 0 ? void 0 : _parentActiveCategory.id); });
                        var _activeCategoryIndex = (_b = (_a = categories[_parentActiveCategoryIndex]) === null || _a === void 0 ? void 0 : _a.sub_categories) === null || _b === void 0 ? void 0 : _b.findIndex(function (cat) { return cat.id === (_activeCategory === null || _activeCategory === void 0 ? void 0 : _activeCategory.id); });
                        setActiveCategoryIndex(_parentActiveCategoryIndex);
                        setActiveSubCategoryIndex(_activeCategoryIndex);
                    }
                    else {
                        var _activeCategoryIndex = categories.findIndex(function (cat) { return cat.id === (_activeCategory === null || _activeCategory === void 0 ? void 0 : _activeCategory.id); });
                        setActiveCategoryIndex(_activeCategoryIndex);
                        setActiveSubCategoryIndex(null);
                    }
                }, components: {
                    EmptyPlaceholder: function () {
                        return react.createElement(MenuPanelEmptyState, { loading: loading });
                    },
                    TopItemList: function (_a) {
                        var style = _a.style, children = _a.children;
                        var newStyle = style;
                        newStyle.zIndex = 8;
                        newStyle.borderBottom = '1px solid rgba(0, 0, 0, 0.06)';
                        return (react.createElement("div", { className: "menu-panel__body__top_item_list", style: newStyle },
                            react.createElement(SortFilter, { sortOptions: sortFilter === null || sortFilter === void 0 ? void 0 : sortFilter.sort_by, filterOptions: sortFilter === null || sortFilter === void 0 ? void 0 : sortFilter.filters, onFilterByCallback: onFilterByCallback, onFilterClearCallback: onFilterClearCallback, onSortClearCallback: onSortClearCallback, selectedfilterOptions: selectedfilterOptions, selectedSortOptions: selectedSortOptions, filterSortIndicatorData: filterSortIndicatorData }),
                            children));
                    }
                }, style: { height: "100vh" }, groupCounts: flatCategories.map(function (e) { return e.item_count; }), groupContent: function (index) {
                    return (react.createElement(StickyHeading, { className: "menu-panel__sticky__heading", category: flatCategories[index], parentCategory: flatCategories[index].parent }));
                }, itemContent: function (index, catIndex) {
                    var _a, _b, _c;
                    var countTillNow = (_a = flatCategories
                        .slice(0, catIndex)) === null || _a === void 0 ? void 0 : _a.reduce(function (acc, category) {
                        return acc + category.item_count;
                    }, 0);
                    var currentIndex = index - countTillNow;
                    var item = (_c = itemsMap === null || itemsMap === void 0 ? void 0 : itemsMap[(_b = flatCategories === null || flatCategories === void 0 ? void 0 : flatCategories[catIndex]) === null || _b === void 0 ? void 0 : _b.id]) === null || _c === void 0 ? void 0 : _c[currentIndex];
                    return (react.createElement("div", { className: "item-list-section__item-card__wrapper" },
                        react.createElement(ItemCard/* default */.Z, { classes: "item-list-section__item-card", shimmerClass: "item-list-section__item-card__shimmer", isFavouriteEnabled: isFavouriteEnabled, current_stock: item === null || item === void 0 ? void 0 : item.current_stock, loading: !Boolean(item), onError: function (err) { return onError && onError(err, item); }, onClickCallback: function () { return onItemClicked(item); }, item_title: item === null || item === void 0 ? void 0 : item.item_title, item_price: item === null || item === void 0 ? void 0 : item.item_price, markup_price: item === null || item === void 0 ? void 0 : item.markup_price, image_url: item === null || item === void 0 ? void 0 : item.image_url, food_type: showFoodType ? item === null || item === void 0 ? void 0 : item.food_type : null, item_desc: item === null || item === void 0 ? void 0 : item.item_desc, has_options: item === null || item === void 0 ? void 0 : item.has_options, image_blur_hash: item === null || item === void 0 ? void 0 : item.image_blur_hash, price_descriptor: item === null || item === void 0 ? void 0 : item.price_descriptor, isFavourite: item === null || item === void 0 ? void 0 : item.isFavourite, toggleFavourite: function (state) {
                                return toggleFavourite(item, state);
                            }, onItemUpdate: onItemUpdate, id: item === null || item === void 0 ? void 0 : item.id, imageComponent: imageComponent, count: cartItemQuantityMap[item === null || item === void 0 ? void 0 : item.id] || 0, loadFirst: index < 5 })));
                } })),
        !isMobile && (react.createElement(ItemListCart/* default */.Z, { classes: "menu-panel__cart", minOrder: minOrder, showCount: false, cartItems: cartItems || [], subTotal: subTotal || 0, totalItems: totalItems || 0, editCustomizationCallback: editCustomizationCallback, onItemUpdate: onItemUpdate, checkoutCallback: onCheckoutClicked, itemLevelInstructionsEnabled: itemLevelInstructionsEnabled }))));
}


//# sourceMappingURL=MenuPanel.js.map


/***/ }),

/***/ 58316:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ clone; }
/* harmony export */ });
function clone(item) {
    if (!item) {
        return item;
    } // null, undefined values check
    var types = [Number, String, Boolean];
    var result;
    // normalizing primitives if someone did new String('aaa'), or new Number('444');
    types.forEach(function (type) {
        if (item instanceof type) {
            result = type(item);
        }
    });
    if (typeof result == 'undefined') {
        if (Object.prototype.toString.call(item) === '[object Array]') {
            result = [];
            item.forEach(function (child, index) {
                result[index] = clone(child);
            });
        }
        else if (typeof item == 'object') {
            // testing that this is DOM
            if (item.nodeType && typeof item.cloneNode == 'function') {
                result = item.cloneNode(true);
            }
            else if (!item.prototype) {
                // check that this is a literal
                if (item instanceof Date) {
                    result = new Date(item);
                }
                else {
                    // it is an object literal
                    result = {};
                    for (var i in item) {
                        result[i] = clone(item[i]);
                    }
                }
            }
            else {
                // depending what you would like here,
                // just keep the reference, or create new object
                result = item;
            }
        }
        else {
            result = item;
        }
    }
    return result;
}


//# sourceMappingURL=clone.util.js.map


/***/ }),

/***/ 72443:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TextHelpers; }
/* harmony export */ });
var TextHelpers = /** @class */ (function () {
    function TextHelpers() {
    }
    /**
     * Decode HTML (removes escape html)
     *
     * @param {string} encoded html
     * @returns {string} decoded html
     */
    TextHelpers.htmlDecode = function (content) {
        if (document) {
            var e = document.createElement('div');
            e.innerHTML = content;
            return e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue;
        }
    };
    return TextHelpers;
}());


//# sourceMappingURL=text.util.js.map


/***/ }),

/***/ 85470:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CautionIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function CautionIcon() {
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: "19", height: "18", viewBox: "0 0 19 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M9.5 16.7812C13.9183 16.7812 17.5 13.1995 17.5 8.78125C17.5 4.36297 13.9183 0.78125 9.5 0.78125C5.08172 0.78125 1.5 4.36297 1.5 8.78125C1.5 13.1995 5.08172 16.7812 9.5 16.7812Z", stroke: "#996001", "stroke-width": "1.4", "stroke-linecap": "round", "stroke-linejoin": "round" }),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M9.5 5.58203V8.78203", stroke: "#996001", "stroke-width": "1.4", "stroke-linecap": "round", "stroke-linejoin": "round" }),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M9.5 11.9805H9.508", stroke: "#996001", "stroke-width": "1.4", "stroke-linecap": "round", "stroke-linejoin": "round" })));
}


//# sourceMappingURL=caution.icon.js.map


/***/ }),

/***/ 23199:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FilterIcon; }
/* harmony export */ });
/* harmony import */ var _external_lib_tslib_tslib_es6_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36929);
/* harmony import */ var _Atoms_Icon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8055);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);




function FilterIcon(props) {
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Atoms_Icon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_external_lib_tslib_tslib_es6_js__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({ svg: function () { return "\n      <svg width=\"20\" height=\"20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M10.0002 18.0205C7.87291 18.0205 5.83277 17.1755 4.32858 15.6713C2.82438 14.1671 1.97933 12.1269 1.97933 9.99967C1.97933 7.87242 2.82438 5.83229 4.32858 4.32809C5.83277 2.82389 7.87291 1.97884 10.0002 1.97884C12.1274 1.97884 14.1675 2.82389 15.6717 4.32809C17.1759 5.83229 18.021 7.87242 18.021 9.99967C18.021 12.1269 17.1759 14.1671 15.6717 15.6713C14.1675 17.1755 12.1274 18.0205 10.0002 18.0205ZM10.0002 19.1663C12.4313 19.1663 14.7629 18.2006 16.482 16.4815C18.2011 14.7624 19.1668 12.4308 19.1668 9.99967C19.1668 7.56852 18.2011 5.23695 16.482 3.51786C14.7629 1.79878 12.4313 0.833008 10.0002 0.833008C7.56901 0.833008 5.23743 1.79878 3.51835 3.51786C1.79927 5.23695 0.833496 7.56852 0.833496 9.99967C0.833496 12.4308 1.79927 14.7624 3.51835 16.4815C5.23743 18.2006 7.56901 19.1663 10.0002 19.1663Z\" fill=\"#151515\" stroke=\"#151515\" stroke-width=\"0.6\"/>\n      <path d=\"M8.83366 14.6663C8.83366 14.5116 8.89512 14.3633 9.00451 14.2539C9.11391 14.1445 9.26228 14.083 9.41699 14.083H10.5837C10.7384 14.083 10.8867 14.1445 10.9961 14.2539C11.1055 14.3633 11.167 14.5116 11.167 14.6663C11.167 14.8211 11.1055 14.9694 10.9961 15.0788C10.8867 15.1882 10.7384 15.2497 10.5837 15.2497H9.41699C9.26228 15.2497 9.11391 15.1882 9.00451 15.0788C8.89512 14.9694 8.83366 14.8211 8.83366 14.6663ZM6.50033 11.1663C6.50033 11.0116 6.56178 10.8633 6.67118 10.7539C6.78058 10.6445 6.92895 10.583 7.08366 10.583H12.917C13.0717 10.583 13.2201 10.6445 13.3295 10.7539C13.4389 10.8633 13.5003 11.0116 13.5003 11.1663C13.5003 11.3211 13.4389 11.4694 13.3295 11.5788C13.2201 11.6882 13.0717 11.7497 12.917 11.7497H7.08366C6.92895 11.7497 6.78058 11.6882 6.67118 11.5788C6.56178 11.4694 6.50033 11.3211 6.50033 11.1663ZM4.16699 7.66634C4.16699 7.51163 4.22845 7.36326 4.33785 7.25386C4.44724 7.14447 4.59562 7.08301 4.75033 7.08301H15.2503C15.405 7.08301 15.5534 7.14447 15.6628 7.25386C15.7722 7.36326 15.8337 7.51163 15.8337 7.66634C15.8337 7.82105 15.7722 7.96942 15.6628 8.07882C15.5534 8.18822 15.405 8.24967 15.2503 8.24967H4.75033C4.59562 8.24967 4.44724 8.18822 4.33785 8.07882C4.22845 7.96942 4.16699 7.82105 4.16699 7.66634Z\" fill=\"#151515\" stroke=\"#151515\" stroke-width=\"0.6\"/>\n      </svg>\n    "; } }, props)));
}


//# sourceMappingURL=filter.icon.js.map


/***/ }),

/***/ 38951:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OrderHistoryIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function OrderHistoryIcon() {
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: "378", height: "207", viewBox: "0 0 378 207", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { "clip-path": "url(#clip0_4478_73564)" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M50.83 107.892H38.7328C38.3074 107.892 37.8994 108.061 37.5987 108.362C37.2979 108.663 37.1289 109.072 37.1289 109.498V114.817C37.1289 115.243 37.2979 115.651 37.5987 115.953C37.8994 116.254 38.3074 116.423 38.7328 116.423H40.7374V124.392H48.8253V116.423H50.83C51.2553 116.423 51.6633 116.254 51.964 115.953C52.2648 115.651 52.4338 115.243 52.4338 114.817V109.498C52.4338 109.072 52.2648 108.663 51.964 108.362C51.6633 108.061 51.2553 107.892 50.83 107.892Z", fill: "#EAEAEA" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M62.9459 156.567C55.5372 145.708 51.7498 132.779 52.1261 119.633C52.1328 119.329 52.0345 119.033 51.8479 118.794C51.6613 118.555 51.3978 118.388 51.1022 118.322V116.023H38.326V118.29H38.15C37.9698 118.29 37.7915 118.327 37.6264 118.4C37.4613 118.472 37.3129 118.578 37.1904 118.71C37.0678 118.842 36.9739 118.998 36.9143 119.169C36.8548 119.339 36.831 119.52 36.8443 119.7C37.8508 133.754 34.452 146.357 26.6478 157.51C26.1988 158.151 25.9693 158.92 25.994 159.703L27.391 202.987C27.4246 203.953 27.8291 204.868 28.5202 205.542C29.2113 206.216 30.1355 206.596 31.0999 206.604H59.9979C60.9733 206.596 61.9071 206.207 62.6003 205.519C63.2935 204.832 63.6914 203.901 63.709 202.924L64.2474 160.898C64.2633 159.355 63.8093 157.844 62.9459 156.567Z", fill: "#3F3D56" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { opacity: "0.2", d: "M48.3072 109.625C48.3072 110.544 47.9426 111.426 47.2937 112.076C46.6448 112.726 45.7647 113.091 44.847 113.091C43.9292 113.091 43.0491 112.726 42.4002 112.076C41.7513 111.426 41.3867 110.544 41.3867 109.625", fill: "black" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M58.3726 170.945H54.8733C54.5392 168.773 53.4403 166.793 51.7754 165.363C50.1104 163.933 47.9894 163.146 45.796 163.146C43.6026 163.146 41.4815 163.933 39.8166 165.363C38.1517 166.793 37.0528 168.773 36.7187 170.945H33.2192C32.8468 170.945 32.4789 171.025 32.1406 171.181C31.8023 171.337 31.5016 171.564 31.2592 171.847C31.0167 172.13 30.8383 172.462 30.736 172.821C30.6338 173.18 30.6101 173.556 30.6667 173.925L34.4678 198.672H56.2939L60.9108 174.008C60.9807 173.635 60.9676 173.25 60.8724 172.882C60.7772 172.514 60.6022 172.172 60.3598 171.88C60.1175 171.587 59.8138 171.352 59.4703 171.19C59.1269 171.029 58.7521 170.945 58.3726 170.945Z", fill: "#EAEAEA" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M352.439 131.167L351.599 164.771L350.56 206.442H315.176L313.958 157.62L313.297 131.167H352.439Z", fill: "#E6E6E6" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M335.217 113.289H330.207V179.782H335.217V113.289Z", fill: "#EAEAEA" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M349.935 156.487L348.987 204.25H316.735L315.625 148.291C318.531 147.473 321.573 147.264 324.563 147.676C327.553 148.088 330.427 149.112 333.004 150.685C338.393 153.877 344.446 155.596 349.935 156.487Z", fill: "#3F3D56" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M324.718 161.864H320.121V166.469H324.718V161.864Z", fill: "#E6E6E6" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M327.851 152.455H323.254V157.06H327.851V152.455Z", fill: "#E6E6E6" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M337.72 158.97L334.027 156.227L331.289 159.925L334.981 162.668L337.72 158.97Z", fill: "#E6E6E6" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M346.028 167.128L342.336 164.385L339.597 168.083L343.29 170.826L346.028 167.128Z", fill: "#E6E6E6" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M331.939 171.833L328.246 169.09L325.507 172.788L329.2 175.532L331.939 171.833Z", fill: "#E6E6E6" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M342.732 150.613C343.251 150.613 343.672 150.192 343.672 149.672C343.672 149.153 343.251 148.731 342.732 148.731C342.214 148.731 341.793 149.153 341.793 149.672C341.793 150.192 342.214 150.613 342.732 150.613Z", fill: "#3F3D56" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M323.631 144.34C324.15 144.34 324.57 143.919 324.57 143.399C324.57 142.879 324.15 142.458 323.631 142.458C323.112 142.458 322.691 142.879 322.691 143.399C322.691 143.919 323.112 144.34 323.631 144.34Z", fill: "#3F3D56" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M339.6 137.754C340.118 137.754 340.539 137.333 340.539 136.813C340.539 136.293 340.118 135.872 339.6 135.872C339.081 135.872 338.66 136.293 338.66 136.813C338.66 137.333 339.081 137.754 339.6 137.754Z", fill: "#3F3D56" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M189.217 206.155C246.052 206.155 292.126 160.006 292.126 103.078C292.126 46.1494 246.052 0 189.217 0C132.382 0 86.3086 46.1494 86.3086 103.078C86.3086 160.006 132.382 206.155 189.217 206.155Z", fill: "#EAEAEA" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { opacity: "0.2", d: "M189.218 178.314C171.84 178.314 155 172.279 141.567 161.236C128.134 150.194 118.939 134.827 115.549 117.756C112.159 100.684 114.783 82.9626 122.975 67.6117C131.167 52.2607 144.419 40.2298 160.474 33.5687C176.529 26.9077 194.393 26.0287 211.023 31.0815C227.652 36.1343 242.018 46.8064 251.673 61.2792C261.327 75.752 265.673 93.1301 263.97 110.453C262.267 127.775 254.619 143.97 242.331 156.278C235.373 163.286 227.095 168.843 217.978 172.625C208.862 176.408 199.086 178.341 189.218 178.314ZM189.218 32.481C150.355 32.481 118.737 64.1504 118.737 103.078C118.737 142.005 150.355 173.674 189.218 173.674C228.081 173.674 259.699 142.005 259.699 103.078C259.699 64.1504 228.081 32.481 189.218 32.481Z", fill: "black" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M189.215 175.995C229.42 175.995 262.012 143.349 262.012 103.078C262.012 62.807 229.42 30.1611 189.215 30.1611C149.01 30.1611 116.418 62.807 116.418 103.078C116.418 143.349 149.01 175.995 189.215 175.995Z", fill: "#F1F1F1" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M135.077 73.9211C134.525 72.838 134.191 71.6566 134.095 70.4443C133.999 69.232 134.143 68.0127 134.518 66.856C134.893 65.6994 135.491 64.628 136.28 63.7033C137.068 62.7785 138.031 62.0185 139.113 61.4667C140.195 60.9148 141.374 60.582 142.585 60.4872C143.795 60.3923 145.012 60.5374 146.167 60.9141C147.321 61.2907 148.39 61.8916 149.313 62.6823C150.235 63.473 150.993 64.4381 151.543 65.5223L172.11 105.976C172.662 107.059 172.995 108.24 173.091 109.453C173.187 110.665 173.044 111.884 172.669 113.041C172.294 114.198 171.695 115.269 170.907 116.194C170.118 117.119 169.156 117.879 168.074 118.43C166.992 118.982 165.812 119.315 164.602 119.41C163.391 119.505 162.174 119.36 161.02 118.983C159.865 118.606 158.796 118.006 157.874 117.215C156.952 116.424 156.194 115.459 155.644 114.375L135.077 73.9211Z", fill: "#FF6584" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { opacity: "0.2", d: "M137.371 78.4339L136.422 76.5668C141.159 72.8798 146.722 70.1682 152.888 68.168L153.837 70.0351C147.164 71.4269 141.487 74.0026 137.371 78.4339Z", fill: "black" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { opacity: "0.2", d: "M141.801 87.1468L140.852 85.2797C145.589 81.5926 151.152 78.8811 157.317 76.8809L158.266 78.748C151.594 80.1397 145.917 82.7155 141.801 87.1468Z", fill: "black" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { opacity: "0.2", d: "M146.23 95.8597L145.281 93.9926C150.019 90.3055 155.582 87.594 161.747 85.5938L162.696 87.4608C156.024 88.8526 150.347 91.4284 146.23 95.8597Z", fill: "black" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { opacity: "0.2", d: "M150.66 104.573L149.711 102.705C154.448 99.0184 160.011 96.3068 166.177 94.3066L167.126 96.1737C160.453 97.5655 154.776 100.141 150.66 104.573Z", fill: "black" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { opacity: "0.2", d: "M155.094 113.285L154.145 111.418C158.882 107.731 164.445 105.02 170.61 103.02L171.559 104.887C164.887 106.278 159.21 108.854 155.094 113.285Z", fill: "black" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M119.647 89.0657C119.095 87.9827 118.761 86.8013 118.666 85.5891C118.57 84.3769 118.713 83.1577 119.088 82.0011C119.463 80.8445 120.062 79.7733 120.85 78.8486C121.639 77.9239 122.601 77.164 123.683 76.6122C124.765 76.0604 125.945 75.7275 127.155 75.6327C128.365 75.5378 129.582 75.6828 130.737 76.0594C131.891 76.436 132.96 77.0367 133.882 77.8273C134.805 78.6179 135.563 79.5828 136.112 80.6669L156.679 121.121C157.788 123.307 157.985 125.846 157.227 128.178C156.468 130.51 154.817 132.445 152.635 133.558C150.453 134.671 147.919 134.871 145.59 134.113C143.261 133.356 141.327 131.704 140.214 129.519L119.647 89.0657Z", fill: "#FF6584" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { opacity: "0.2", d: "M121.941 93.5774L120.992 91.7103C125.73 88.0233 131.293 85.3117 137.458 83.3115L138.407 85.1786C131.734 86.5704 126.058 89.1461 121.941 93.5774Z", fill: "black" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { opacity: "0.2", d: "M126.371 102.291L125.422 100.424C130.159 96.7372 135.722 94.0256 141.888 92.0254L142.837 93.8925C136.164 95.2843 130.487 97.86 126.371 102.291Z", fill: "black" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { opacity: "0.2", d: "M130.801 111.004L129.852 109.137C134.589 105.45 140.152 102.738 146.317 100.738L147.266 102.605C140.594 103.997 134.917 106.573 130.801 111.004Z", fill: "black" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { opacity: "0.2", d: "M135.23 119.717L134.281 117.85C139.019 114.163 144.582 111.451 150.747 109.451L151.696 111.318C145.023 112.71 139.347 115.286 135.23 119.717Z", fill: "black" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { opacity: "0.2", d: "M139.66 128.43L138.711 126.563C143.448 122.876 149.011 120.164 155.177 118.164L156.126 120.031C149.453 121.423 143.776 123.999 139.66 128.43Z", fill: "black" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M237.859 105.397L237.924 105.398C240.14 105.416 242.309 104.766 244.15 103.531C245.99 102.296 247.417 100.534 248.242 98.4748C249.941 94.1742 250.797 89.5862 250.764 84.9613C250.648 65.3862 234.749 49.3271 215.207 49.0563C206.885 48.9396 198.778 51.7091 192.262 56.8952C185.745 62.0814 181.219 69.3652 179.452 77.5118C177.684 85.6585 178.783 94.1667 182.563 101.594C186.343 109.022 192.571 114.912 200.191 118.265C202.205 119.158 204.441 119.421 206.606 119.019C208.771 118.617 210.765 117.569 212.325 116.012C215.671 112.642 219.65 109.97 224.033 108.148C228.415 106.326 233.115 105.391 237.859 105.397Z", fill: "#E6E6E6" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M219.326 94.4603C225.905 94.4603 231.239 89.1183 231.239 82.5285C231.239 75.9387 225.905 70.5967 219.326 70.5967C212.747 70.5967 207.414 75.9387 207.414 82.5285C207.414 89.1183 212.747 94.4603 219.326 94.4603Z", fill: "#F9A825" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M193.438 81.1862C194.214 81.1862 194.842 80.5569 194.842 79.7806C194.842 79.0043 194.214 78.375 193.438 78.375C192.663 78.375 192.035 79.0043 192.035 79.7806C192.035 80.5569 192.663 81.1862 193.438 81.1862Z", fill: "#3F3D56" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M147.114 82.5124C147.889 82.5124 148.518 81.8831 148.518 81.1068C148.518 80.3305 147.889 79.7012 147.114 79.7012C146.339 79.7012 145.711 80.3305 145.711 81.1068C145.711 81.8831 146.339 82.5124 147.114 82.5124Z", fill: "#3F3D56" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M200.919 66.6189C201.694 66.6189 202.322 65.9895 202.322 65.2132C202.322 64.4369 201.694 63.8076 200.919 63.8076C200.144 63.8076 199.516 64.4369 199.516 65.2132C199.516 65.9895 200.144 66.6189 200.919 66.6189Z", fill: "#3F3D56" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M200.876 107.134C201.651 107.134 202.279 106.505 202.279 105.729C202.279 104.953 201.651 104.323 200.876 104.323C200.101 104.323 199.473 104.953 199.473 105.729C199.473 106.505 200.101 107.134 200.876 107.134Z", fill: "#3F3D56" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M228.673 63.7165C229.448 63.7165 230.076 63.0872 230.076 62.3109C230.076 61.5346 229.448 60.9053 228.673 60.9053C227.898 60.9053 227.27 61.5346 227.27 62.3109C227.27 63.0872 227.898 63.7165 228.673 63.7165Z", fill: "#3F3D56" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M138.009 102.163C138.784 102.163 139.412 101.533 139.412 100.757C139.412 99.9809 138.784 99.3516 138.009 99.3516C137.234 99.3516 136.605 99.9809 136.605 100.757C136.605 101.533 137.234 102.163 138.009 102.163Z", fill: "#3F3D56" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M148.267 122.381C149.042 122.381 149.67 121.751 149.67 120.975C149.67 120.199 149.042 119.569 148.267 119.569C147.492 119.569 146.863 120.199 146.863 120.975C146.863 121.751 147.492 122.381 148.267 122.381Z", fill: "#3F3D56" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M212.708 128.93C215.632 128.93 218.003 126.556 218.003 123.627C218.003 120.698 215.632 118.324 212.708 118.324C209.784 118.324 207.414 120.698 207.414 123.627C207.414 126.556 209.784 128.93 212.708 128.93Z", fill: "#FF6584" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { opacity: "0.2", d: "M216.68 123.958C216.68 125.013 216.261 126.024 215.517 126.77C214.772 127.516 213.762 127.935 212.709 127.935C211.656 127.935 210.646 127.516 209.901 126.77C209.157 126.024 208.738 125.013 208.738 123.958", fill: "black" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { opacity: "0.2", d: "M208.738 123.296C208.738 122.241 209.157 121.229 209.901 120.483C210.646 119.737 211.656 119.318 212.709 119.318C213.762 119.318 214.772 119.737 215.517 120.483C216.261 121.229 216.68 122.241 216.68 123.296", fill: "black" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M210.725 122.301C210.908 122.301 211.056 122.078 211.056 121.804C211.056 121.529 210.908 121.307 210.725 121.307C210.543 121.307 210.395 121.529 210.395 121.804C210.395 122.078 210.543 122.301 210.725 122.301Z", fill: "#FF6584" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M212.71 121.638C212.893 121.638 213.041 121.415 213.041 121.141C213.041 120.866 212.893 120.644 212.71 120.644C212.527 120.644 212.379 120.866 212.379 121.141C212.379 121.415 212.527 121.638 212.71 121.638Z", fill: "#FF6584" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M212.71 125.947C212.893 125.947 213.041 125.725 213.041 125.45C213.041 125.176 212.893 124.953 212.71 124.953C212.527 124.953 212.379 125.176 212.379 125.45C212.379 125.725 212.527 125.947 212.71 125.947Z", fill: "#FF6584" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M214.694 123.295C214.877 123.295 215.025 123.073 215.025 122.798C215.025 122.523 214.877 122.301 214.694 122.301C214.511 122.301 214.363 122.523 214.363 122.798C214.363 123.073 214.511 123.295 214.694 123.295Z", fill: "#FF6584" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M214.366 126.942C214.549 126.942 214.697 126.719 214.697 126.444C214.697 126.17 214.549 125.947 214.366 125.947C214.183 125.947 214.035 126.17 214.035 126.444C214.035 126.719 214.183 126.942 214.366 126.942Z", fill: "#FF6584" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M210.393 125.284C210.576 125.284 210.724 125.062 210.724 124.787C210.724 124.513 210.576 124.29 210.393 124.29C210.211 124.29 210.062 124.513 210.062 124.787C210.062 125.062 210.211 125.284 210.393 125.284Z", fill: "#FF6584" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M223.298 114.678C226.222 114.678 228.593 112.304 228.593 109.375C228.593 106.447 226.222 104.072 223.298 104.072C220.374 104.072 218.004 106.447 218.004 109.375C218.004 112.304 220.374 114.678 223.298 114.678Z", fill: "#FF6584" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { opacity: "0.2", d: "M227.27 109.706C227.27 110.761 226.851 111.773 226.107 112.518C225.362 113.264 224.352 113.683 223.299 113.683C222.246 113.683 221.236 113.264 220.491 112.518C219.746 111.773 219.328 110.761 219.328 109.706", fill: "black" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { opacity: "0.2", d: "M219.328 109.044C219.328 107.989 219.746 106.977 220.491 106.231C221.236 105.485 222.246 105.066 223.299 105.066C224.352 105.066 225.362 105.485 226.107 106.231C226.851 106.977 227.27 107.989 227.27 109.044", fill: "black" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M221.311 108.049C221.494 108.049 221.642 107.826 221.642 107.552C221.642 107.277 221.494 107.055 221.311 107.055C221.129 107.055 220.98 107.277 220.98 107.552C220.98 107.826 221.129 108.049 221.311 108.049Z", fill: "#FF6584" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M223.3 107.386C223.482 107.386 223.631 107.163 223.631 106.889C223.631 106.614 223.482 106.392 223.3 106.392C223.117 106.392 222.969 106.614 222.969 106.889C222.969 107.163 223.117 107.386 223.3 107.386Z", fill: "#FF6584" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M223.3 111.695C223.482 111.695 223.631 111.473 223.631 111.198C223.631 110.924 223.482 110.701 223.3 110.701C223.117 110.701 222.969 110.924 222.969 111.198C222.969 111.473 223.117 111.695 223.3 111.695Z", fill: "#FF6584" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M225.284 109.043C225.467 109.043 225.615 108.821 225.615 108.546C225.615 108.271 225.467 108.049 225.284 108.049C225.101 108.049 224.953 108.271 224.953 108.546C224.953 108.821 225.101 109.043 225.284 109.043Z", fill: "#FF6584" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M224.952 112.69C225.135 112.69 225.283 112.467 225.283 112.192C225.283 111.918 225.135 111.695 224.952 111.695C224.769 111.695 224.621 111.918 224.621 112.192C224.621 112.467 224.769 112.69 224.952 112.69Z", fill: "#FF6584" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M220.983 111.032C221.166 111.032 221.314 110.81 221.314 110.535C221.314 110.261 221.166 110.038 220.983 110.038C220.8 110.038 220.652 110.261 220.652 110.535C220.652 110.81 220.8 111.032 220.983 111.032Z", fill: "#FF6584" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M233.888 121.969C236.812 121.969 239.182 119.595 239.182 116.666C239.182 113.738 236.812 111.363 233.888 111.363C230.964 111.363 228.594 113.738 228.594 116.666C228.594 119.595 230.964 121.969 233.888 121.969Z", fill: "#EAEAEA" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { opacity: "0.2", d: "M237.859 116.998C237.859 118.053 237.441 119.065 236.696 119.81C235.952 120.556 234.942 120.975 233.889 120.975C232.836 120.975 231.826 120.556 231.081 119.81C230.336 119.065 229.918 118.053 229.918 116.998", fill: "black" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { opacity: "0.2", d: "M229.918 116.336C229.918 115.281 230.336 114.269 231.081 113.523C231.826 112.777 232.836 112.358 233.889 112.358C234.942 112.358 235.952 112.777 236.696 113.523C237.441 114.269 237.859 115.281 237.859 116.336", fill: "black" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M231.901 115.341C232.084 115.341 232.232 115.118 232.232 114.844C232.232 114.569 232.084 114.347 231.901 114.347C231.718 114.347 231.57 114.569 231.57 114.844C231.57 115.118 231.718 115.341 231.901 115.341Z", fill: "#EAEAEA" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M233.886 114.678C234.068 114.678 234.216 114.455 234.216 114.181C234.216 113.906 234.068 113.684 233.886 113.684C233.703 113.684 233.555 113.906 233.555 114.181C233.555 114.455 233.703 114.678 233.886 114.678Z", fill: "#EAEAEA" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M233.886 118.987C234.068 118.987 234.216 118.764 234.216 118.489C234.216 118.215 234.068 117.992 233.886 117.992C233.703 117.992 233.555 118.215 233.555 118.489C233.555 118.764 233.703 118.987 233.886 118.987Z", fill: "#EAEAEA" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M235.874 116.335C236.057 116.335 236.205 116.113 236.205 115.838C236.205 115.563 236.057 115.341 235.874 115.341C235.691 115.341 235.543 115.563 235.543 115.838C235.543 116.113 235.691 116.335 235.874 116.335Z", fill: "#EAEAEA" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M235.542 119.981C235.725 119.981 235.873 119.758 235.873 119.483C235.873 119.209 235.725 118.986 235.542 118.986C235.359 118.986 235.211 119.209 235.211 119.483C235.211 119.758 235.359 119.981 235.542 119.981Z", fill: "#EAEAEA" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M231.569 118.323C231.752 118.323 231.9 118.101 231.9 117.826C231.9 117.552 231.752 117.329 231.569 117.329C231.386 117.329 231.238 117.552 231.238 117.826C231.238 118.101 231.386 118.323 231.569 118.323Z", fill: "#EAEAEA" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M207.415 122.632C210.339 122.632 212.71 120.258 212.71 117.329C212.71 114.401 210.339 112.026 207.415 112.026C204.491 112.026 202.121 114.401 202.121 117.329C202.121 120.258 204.491 122.632 207.415 122.632Z", fill: "#EAEAEA" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { opacity: "0.2", d: "M211.387 117.661C211.387 118.716 210.968 119.728 210.224 120.474C209.479 121.219 208.469 121.638 207.416 121.638C206.363 121.638 205.353 121.219 204.608 120.474C203.864 119.728 203.445 118.716 203.445 117.661", fill: "black" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { opacity: "0.2", d: "M203.445 116.998C203.445 115.943 203.864 114.931 204.608 114.185C205.353 113.44 206.363 113.021 207.416 113.021C208.469 113.021 209.479 113.44 210.224 114.185C210.968 114.931 211.387 115.943 211.387 116.998", fill: "black" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M205.429 116.004C205.611 116.004 205.759 115.781 205.759 115.507C205.759 115.232 205.611 115.01 205.429 115.01C205.246 115.01 205.098 115.232 205.098 115.507C205.098 115.781 205.246 116.004 205.429 116.004Z", fill: "#EAEAEA" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M207.417 115.341C207.6 115.341 207.748 115.118 207.748 114.844C207.748 114.569 207.6 114.347 207.417 114.347C207.234 114.347 207.086 114.569 207.086 114.844C207.086 115.118 207.234 115.341 207.417 115.341Z", fill: "#EAEAEA" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M207.417 119.65C207.6 119.65 207.748 119.427 207.748 119.152C207.748 118.878 207.6 118.655 207.417 118.655C207.234 118.655 207.086 118.878 207.086 119.152C207.086 119.427 207.234 119.65 207.417 119.65Z", fill: "#EAEAEA" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M209.401 116.998C209.584 116.998 209.732 116.776 209.732 116.501C209.732 116.226 209.584 116.004 209.401 116.004C209.218 116.004 209.07 116.226 209.07 116.501C209.07 116.776 209.218 116.998 209.401 116.998Z", fill: "#EAEAEA" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M209.069 120.644C209.252 120.644 209.4 120.421 209.4 120.147C209.4 119.872 209.252 119.649 209.069 119.649C208.886 119.649 208.738 119.872 208.738 120.147C208.738 120.421 208.886 120.644 209.069 120.644Z", fill: "#EAEAEA" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M205.1 118.987C205.283 118.987 205.431 118.764 205.431 118.489C205.431 118.215 205.283 117.992 205.1 117.992C204.918 117.992 204.77 118.215 204.77 118.489C204.77 118.764 204.918 118.987 205.1 118.987Z", fill: "#EAEAEA" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M219.33 124.953C222.253 124.953 224.624 122.578 224.624 119.65C224.624 116.721 222.253 114.347 219.33 114.347C216.406 114.347 214.035 116.721 214.035 119.65C214.035 122.578 216.406 124.953 219.33 124.953Z", fill: "#EAEAEA" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { opacity: "0.2", d: "M223.297 119.981C223.297 120.504 223.194 121.021 222.995 121.503C222.795 121.986 222.503 122.424 222.134 122.794C221.765 123.163 221.328 123.456 220.846 123.656C220.364 123.856 219.848 123.959 219.326 123.959C218.805 123.959 218.288 123.856 217.807 123.656C217.325 123.456 216.887 123.163 216.518 122.794C216.15 122.424 215.857 121.986 215.658 121.503C215.458 121.021 215.355 120.504 215.355 119.981", fill: "black" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { opacity: "0.2", d: "M215.355 119.318C215.355 118.796 215.458 118.279 215.658 117.796C215.857 117.314 216.15 116.875 216.518 116.506C216.887 116.136 217.325 115.843 217.807 115.644C218.288 115.444 218.805 115.341 219.326 115.341C219.848 115.341 220.364 115.444 220.846 115.644C221.328 115.843 221.765 116.136 222.134 116.506C222.503 116.875 222.795 117.314 222.995 117.796C223.194 118.279 223.297 118.796 223.297 119.318", fill: "black" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M217.343 118.323C217.525 118.323 217.674 118.101 217.674 117.826C217.674 117.552 217.525 117.329 217.343 117.329C217.16 117.329 217.012 117.552 217.012 117.826C217.012 118.101 217.16 118.323 217.343 118.323Z", fill: "#EAEAEA" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M219.327 117.661C219.51 117.661 219.658 117.439 219.658 117.164C219.658 116.89 219.51 116.667 219.327 116.667C219.144 116.667 218.996 116.89 218.996 117.164C218.996 117.439 219.144 117.661 219.327 117.661Z", fill: "#EAEAEA" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M219.327 121.97C219.51 121.97 219.658 121.747 219.658 121.473C219.658 121.198 219.51 120.976 219.327 120.976C219.144 120.976 218.996 121.198 218.996 121.473C218.996 121.747 219.144 121.97 219.327 121.97Z", fill: "#EAEAEA" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M221.311 119.319C221.494 119.319 221.642 119.096 221.642 118.821C221.642 118.547 221.494 118.324 221.311 118.324C221.129 118.324 220.98 118.547 220.98 118.821C220.98 119.096 221.129 119.319 221.311 119.319Z", fill: "#EAEAEA" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M220.983 122.964C221.166 122.964 221.314 122.741 221.314 122.467C221.314 122.192 221.166 121.97 220.983 121.97C220.8 121.97 220.652 122.192 220.652 122.467C220.652 122.741 220.8 122.964 220.983 122.964Z", fill: "#EAEAEA" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M217.011 121.307C217.193 121.307 217.341 121.084 217.341 120.81C217.341 120.535 217.193 120.312 217.011 120.312C216.828 120.312 216.68 120.535 216.68 120.81C216.68 121.084 216.828 121.307 217.011 121.307Z", fill: "#EAEAEA" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M227.599 130.588C230.523 130.588 232.893 128.213 232.893 125.284C232.893 122.356 230.523 119.981 227.599 119.981C224.675 119.981 222.305 122.356 222.305 125.284C222.305 128.213 224.675 130.588 227.599 130.588Z", fill: "#FF6584" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { opacity: "0.2", d: "M231.57 125.615C231.57 126.67 231.152 127.682 230.407 128.428C229.663 129.173 228.653 129.593 227.6 129.593C226.547 129.593 225.537 129.173 224.792 128.428C224.047 127.682 223.629 126.67 223.629 125.615", fill: "black" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { opacity: "0.2", d: "M223.629 124.953C223.629 123.898 224.047 122.886 224.792 122.141C225.537 121.395 226.547 120.976 227.6 120.976C228.653 120.976 229.663 121.395 230.407 122.141C231.152 122.886 231.57 123.898 231.57 124.953", fill: "black" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M225.616 123.958C225.799 123.958 225.947 123.736 225.947 123.461C225.947 123.186 225.799 122.964 225.616 122.964C225.433 122.964 225.285 123.186 225.285 123.461C225.285 123.736 225.433 123.958 225.616 123.958Z", fill: "#FF6584" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M227.6 123.295C227.783 123.295 227.931 123.073 227.931 122.798C227.931 122.523 227.783 122.301 227.6 122.301C227.418 122.301 227.27 122.523 227.27 122.798C227.27 123.073 227.418 123.295 227.6 123.295Z", fill: "#FF6584" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M227.6 127.605C227.783 127.605 227.931 127.382 227.931 127.108C227.931 126.833 227.783 126.61 227.6 126.61C227.418 126.61 227.27 126.833 227.27 127.108C227.27 127.382 227.418 127.605 227.6 127.605Z", fill: "#FF6584" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M229.585 124.952C229.768 124.952 229.916 124.73 229.916 124.455C229.916 124.181 229.768 123.958 229.585 123.958C229.402 123.958 229.254 124.181 229.254 124.455C229.254 124.73 229.402 124.952 229.585 124.952Z", fill: "#FF6584" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M229.257 128.599C229.439 128.599 229.588 128.376 229.588 128.102C229.588 127.827 229.439 127.604 229.257 127.604C229.074 127.604 228.926 127.827 228.926 128.102C228.926 128.376 229.074 128.599 229.257 128.599Z", fill: "#FF6584" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M225.284 126.942C225.467 126.942 225.615 126.719 225.615 126.444C225.615 126.17 225.467 125.947 225.284 125.947C225.101 125.947 224.953 126.17 224.953 126.444C224.953 126.719 225.101 126.942 225.284 126.942Z", fill: "#FF6584" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M159.517 106.472C160.292 106.472 160.92 105.843 160.92 105.067C160.92 104.29 160.292 103.661 159.517 103.661C158.742 103.661 158.113 104.29 158.113 105.067C158.113 105.843 158.742 106.472 159.517 106.472Z", fill: "#3F3D56" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M197.66 156.087L163.957 146.725L165.248 141.922L198.951 151.284L197.66 156.087Z", fill: "#F9A825" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M192.72 154.481C181.178 156.694 169.323 156.694 157.781 154.481V149.502C169.349 151.422 181.152 151.422 192.72 149.502V154.481Z", fill: "#F9A825" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M196.31 139.544C184.768 141.757 172.912 141.757 161.371 139.544V134.564C172.938 136.485 184.742 136.485 196.31 134.564V139.544Z", fill: "#F9A825" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M208.392 145.519C196.85 147.732 184.994 147.732 173.453 145.519V140.54C185.02 142.46 196.824 142.46 208.392 140.54V145.519Z", fill: "#F9A825" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M211.333 151.162C199.792 153.375 187.936 153.375 176.395 151.162V146.183C187.962 148.103 199.766 148.103 211.333 146.183V151.162Z", fill: "#F9A825" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M221.578 158.536L187.108 164.335L186.309 159.423L220.778 153.623L221.578 158.536Z", fill: "#F9A825" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M216.429 159.175C206.872 166.075 196.101 171.107 184.682 174.006L182.637 169.482C193.956 166.307 204.681 161.297 214.384 154.65L216.429 159.175Z", fill: "#F9A825" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M213.558 144.076C204.001 150.976 193.23 156.008 181.811 158.907L179.766 154.383C191.085 151.208 201.809 146.198 211.513 139.552L213.558 144.076Z", fill: "#F9A825" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M226.987 144.377C217.431 151.277 206.66 156.309 195.24 159.208L193.195 154.684C204.515 151.509 215.239 146.499 224.942 139.853L226.987 144.377Z", fill: "#F9A825" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M231.976 148.258C222.419 155.158 211.648 160.19 200.229 163.089L198.184 158.565C209.503 155.39 220.227 150.38 229.93 143.733L231.976 148.258Z", fill: "#F9A825" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M190.209 138.542H188.555V140.199H190.209V138.542Z", fill: "#00BF71" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M195.174 167.377H193.52V169.034H195.174V167.377Z", fill: "#00BF71" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M168.701 138.542H167.047V140.199H168.701V138.542Z", fill: "#00BF71" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M207.084 159.091H205.43V160.748H207.084V159.091Z", fill: "#00BF71" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M208.076 149.479H206.422V151.137H208.076V149.479Z", fill: "#00BF71" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M180.784 144.942L178.867 143.64L178.124 144.737L180.041 146.039L180.784 144.942Z", fill: "#00BF71" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M200.307 148.588L198.391 147.285L197.648 148.382L199.564 149.685L200.307 148.588Z", fill: "#00BF71" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M176.483 154.885L174.566 153.582L173.823 154.679L175.74 155.982L176.483 154.885Z", fill: "#00BF71" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M188.618 154.789L189.918 152.869L188.823 152.125L187.522 154.045L188.618 154.789Z", fill: "#00BF71" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M197.551 157.108L198.852 155.188L197.756 154.444L196.456 156.364L197.551 157.108Z", fill: "#00BF71" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M221.379 149.153L222.68 147.233L221.584 146.489L220.284 148.409L221.379 149.153Z", fill: "#00BF71" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M378 206.045H0V207H378V206.045Z", fill: "#3F3D56" })),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null,
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", { id: "clip0_4478_73564" },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", { width: "378", height: "207", fill: "white" })))));
}


//# sourceMappingURL=order-history.update.icon.js.map


/***/ }),

/***/ 95289:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PlusIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function PlusIcon() {
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: "20", height: "20", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M11.75 3C11.9312 3.00001 12.1063 3.06564 12.2429 3.18477C12.3795 3.30389 12.4684 3.46845 12.493 3.648L12.5 3.75L12.501 11H19.754C19.944 11.0001 20.1269 11.0722 20.2658 11.202C20.4046 11.3317 20.4891 11.5093 20.502 11.6989C20.515 11.8885 20.4555 12.0759 20.3356 12.2233C20.2157 12.3707 20.0443 12.4671 19.856 12.493L19.754 12.5H12.501L12.503 19.75C12.5027 19.9399 12.4303 20.1227 12.3005 20.2613C12.1707 20.4 11.9931 20.4842 11.8036 20.4971C11.6141 20.5099 11.4268 20.4503 11.2795 20.3304C11.1322 20.2105 11.0359 20.0392 11.01 19.851L11.003 19.749L11.001 12.5H3.752C3.56198 12.4999 3.37906 12.4278 3.24021 12.298C3.10136 12.1683 3.01693 11.9907 3.00397 11.8011C2.99102 11.6115 3.05051 11.4241 3.17043 11.2767C3.29035 11.1293 3.46175 11.0329 3.65 11.007L3.752 11H11.002L11 3.75C11 3.55109 11.079 3.36032 11.2197 3.21967C11.3603 3.07902 11.5511 3 11.75 3Z", fill: "black", stroke: "black", strokeWidth: "0.6" })));
}


//# sourceMappingURL=plus.icon.js.map


/***/ }),

/***/ 43841:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fC": function() { return /* binding */ $e698a72e93240346$export$be92b6f5f03c0fe9; },
/* harmony export */   "z$": function() { return /* binding */ $e698a72e93240346$export$adb584737d712b70; }
/* harmony export */ });
/* unused harmony exports Checkbox, CheckboxIndicator, createCheckboxScope */
/* harmony import */ var _babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32159);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _react_compose_refs_dist_index_module_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22662);
/* harmony import */ var _react_context_dist_index_module_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77818);
/* harmony import */ var _primitive_dist_index_module_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(91639);
/* harmony import */ var _react_use_controllable_state_dist_index_module_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20403);
/* harmony import */ var _react_use_previous_dist_index_module_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67157);
/* harmony import */ var _react_use_size_dist_index_module_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75692);
/* harmony import */ var _react_presence_dist_index_module_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88372);
/* harmony import */ var _react_primitive_dist_index_module_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25217);











/* -------------------------------------------------------------------------------------------------
 * Checkbox
 * -----------------------------------------------------------------------------------------------*/ const $e698a72e93240346$var$CHECKBOX_NAME = 'Checkbox';
const [$e698a72e93240346$var$createCheckboxContext, $e698a72e93240346$export$b566c4ff5488ea01] = (0,_react_context_dist_index_module_js__WEBPACK_IMPORTED_MODULE_2__/* .createContextScope */ .b)($e698a72e93240346$var$CHECKBOX_NAME);
const [$e698a72e93240346$var$CheckboxProvider, $e698a72e93240346$var$useCheckboxContext] = $e698a72e93240346$var$createCheckboxContext($e698a72e93240346$var$CHECKBOX_NAME);
const $e698a72e93240346$export$48513f6b9f8ce62d = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const { __scopeCheckbox: __scopeCheckbox , name: name , checked: checkedProp , defaultChecked: defaultChecked , required: required , disabled: disabled , value: value = 'on' , onCheckedChange: onCheckedChange , ...checkboxProps } = props;
    const [button, setButton] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const composedRefs = (0,_react_compose_refs_dist_index_module_js__WEBPACK_IMPORTED_MODULE_1__/* .useComposedRefs */ .e)(forwardedRef, (node)=>setButton(node)
    );
    const hasConsumerStoppedPropagationRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false); // We set this to true by default so that events bubble to forms without JS (SSR)
    const isFormControl = button ? Boolean(button.closest('form')) : true;
    const [checked = false, setChecked] = (0,_react_use_controllable_state_dist_index_module_js__WEBPACK_IMPORTED_MODULE_3__/* .useControllableState */ .T)({
        prop: checkedProp,
        defaultProp: defaultChecked,
        onChange: onCheckedChange
    });
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)($e698a72e93240346$var$CheckboxProvider, {
        scope: __scopeCheckbox,
        state: checked,
        disabled: disabled
    }, /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_react_primitive_dist_index_module_js__WEBPACK_IMPORTED_MODULE_7__/* .Primitive.button */ .W.button, (0,_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        type: "button",
        role: "checkbox",
        "aria-checked": $e698a72e93240346$var$isIndeterminate(checked) ? 'mixed' : checked,
        "aria-required": required,
        "data-state": $e698a72e93240346$var$getState(checked),
        "data-disabled": disabled ? '' : undefined,
        disabled: disabled,
        value: value
    }, checkboxProps, {
        ref: composedRefs,
        onKeyDown: (0,_primitive_dist_index_module_js__WEBPACK_IMPORTED_MODULE_9__/* .composeEventHandlers */ .M)(props.onKeyDown, (event)=>{
            // According to WAI ARIA, Checkboxes don't activate on enter keypress
            if (event.key === 'Enter') event.preventDefault();
        }),
        onClick: (0,_primitive_dist_index_module_js__WEBPACK_IMPORTED_MODULE_9__/* .composeEventHandlers */ .M)(props.onClick, (event)=>{
            setChecked((prevChecked)=>$e698a72e93240346$var$isIndeterminate(prevChecked) ? true : !prevChecked
            );
            if (isFormControl) {
                hasConsumerStoppedPropagationRef.current = event.isPropagationStopped(); // if checkbox is in a form, stop propagation from the button so that we only propagate
                // one click event (from the input). We propagate changes from an input so that native
                // form validation works and form events reflect checkbox updates.
                if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
            }
        })
    })), isFormControl && /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)($e698a72e93240346$var$BubbleInput, {
        control: button,
        bubbles: !hasConsumerStoppedPropagationRef.current,
        name: name,
        value: value,
        checked: checked,
        required: required,
        disabled: disabled // We transform because the input is absolutely positioned but we have
        ,
        style: {
            transform: 'translateX(-100%)'
        }
    }));
});
/* -------------------------------------------------------------------------------------------------
 * CheckboxIndicator
 * -----------------------------------------------------------------------------------------------*/ const $e698a72e93240346$var$INDICATOR_NAME = 'CheckboxIndicator';
const $e698a72e93240346$export$59aad738f51d1c05 = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const { __scopeCheckbox: __scopeCheckbox , forceMount: forceMount , ...indicatorProps } = props;
    const context = $e698a72e93240346$var$useCheckboxContext($e698a72e93240346$var$INDICATOR_NAME, __scopeCheckbox);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_react_presence_dist_index_module_js__WEBPACK_IMPORTED_MODULE_6__/* .Presence */ .z, {
        present: forceMount || $e698a72e93240346$var$isIndeterminate(context.state) || context.state === true
    }, /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_react_primitive_dist_index_module_js__WEBPACK_IMPORTED_MODULE_7__/* .Primitive.span */ .W.span, (0,_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        "data-state": $e698a72e93240346$var$getState(context.state),
        "data-disabled": context.disabled ? '' : undefined
    }, indicatorProps, {
        ref: forwardedRef,
        style: {
            pointerEvents: 'none',
            ...props.style
        }
    })));
});
/* ---------------------------------------------------------------------------------------------- */ const $e698a72e93240346$var$BubbleInput = (props)=>{
    const { control: control , checked: checked , bubbles: bubbles = true , ...inputProps } = props;
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const prevChecked = (0,_react_use_previous_dist_index_module_js__WEBPACK_IMPORTED_MODULE_4__/* .usePrevious */ .D)(checked);
    const controlSize = (0,_react_use_size_dist_index_module_js__WEBPACK_IMPORTED_MODULE_5__/* .useSize */ .t)(control); // Bubble checked change to parents (e.g form change event)
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const input = ref.current;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, 'checked');
        const setChecked = descriptor.set;
        if (prevChecked !== checked && setChecked) {
            const event = new Event('click', {
                bubbles: bubbles
            });
            input.indeterminate = $e698a72e93240346$var$isIndeterminate(checked);
            setChecked.call(input, $e698a72e93240346$var$isIndeterminate(checked) ? false : checked);
            input.dispatchEvent(event);
        }
    }, [
        prevChecked,
        checked,
        bubbles
    ]);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("input", (0,_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        type: "checkbox",
        "aria-hidden": true,
        defaultChecked: $e698a72e93240346$var$isIndeterminate(checked) ? false : checked
    }, inputProps, {
        tabIndex: -1,
        ref: ref,
        style: {
            ...props.style,
            ...controlSize,
            position: 'absolute',
            pointerEvents: 'none',
            opacity: 0,
            margin: 0
        }
    }));
};
function $e698a72e93240346$var$isIndeterminate(checked) {
    return checked === 'indeterminate';
}
function $e698a72e93240346$var$getState(checked) {
    return $e698a72e93240346$var$isIndeterminate(checked) ? 'indeterminate' : checked ? 'checked' : 'unchecked';
}
const $e698a72e93240346$export$be92b6f5f03c0fe9 = $e698a72e93240346$export$48513f6b9f8ce62d;
const $e698a72e93240346$export$adb584737d712b70 = $e698a72e93240346$export$59aad738f51d1c05;


//# sourceMappingURL=index.module.js.map


/***/ })

}]);